/* eslint-disable */
/* tslint:disable */
/*
 * ---------------------------------------------------------------
 * ## THIS FILE WAS GENERATED VIA SWAGGER-TYPESCRIPT-API        ##
 * ##                                                           ##
 * ## AUTHOR: acacode                                           ##
 * ## SOURCE: https://github.com/acacode/swagger-typescript-api ##
 * ---------------------------------------------------------------
 */

export interface AccountEconomics {
  runningStatus: AccountRunningStatus
  /** @format double */
  accountValue: number
  /** @format double */
  impliedLeverageRatio?: number | null
  /** @format double */
  targetPerformanceAllocation?: number | null
  /** @format double */
  targetProtectionAllocation?: number | null
  /** @format double */
  performanceAllocation?: number
  /** @format double */
  pendingPerformanceAllocation?: number | null
  /** @format double */
  protectionAllocation?: number
  /** @format double */
  pendingProtectionAllocation?: number | null
  /** @format double */
  cashAllocation?: number | null
  /** @format double */
  loanAllocation?: number | null
  /** @format double */
  pendingCashAllocation?: number | null
  /** @format double */
  pendingLoanAllocation?: number | null
  /** @format double */
  dividendAccrualValue?: number | null
  /** @format double */
  zcbAllocation?: number | null
  /** @format date-time */
  cashLockClosureDate?: string | null
}

export interface AccountExportReport {
  tradeId: string
  tradeName: string
  noteName: string
  currency: string
  /** @format double */
  netContributions: number
  /** @format double */
  tradeValue: number
  /** @format double */
  protectedAmount: number
  /** @format double */
  performanceAssetValue: number
  /** @format double */
  protectionAssetValue: number
  /** @format double */
  cash: number
  /** @format double */
  loan: number
  hasBankGuarantee: boolean | null
  portfolioName?: string | null
}

export interface AccountOwner {
  type: AccountOwnerType
  ownerId: string
}

export type AccountOwnerType = 'HedgingCounterparty' | 'Distributor'

export interface AccountPerformanceOnDay {
  /** @format date-time */
  date?: string
  /** @format double */
  value?: number
  /** @format double */
  growthFactor?: number | null
}

export type AccountProtectedStatus = 'Protected' | 'Unprotected' | 'CashLocked' | 'GapEvent'

export interface AccountReconciliationResult {
  result: ReconciliationResult
  reason?: string | null
  warning?: ReconciliationWarning
  /** @format date-time */
  viewSourceTimeStamp?: string | null
  outstandingOperations?: boolean | null
  /** @format double */
  difference?: number | null
  sharesDifference?: InvestmentShares[] | null
  reconciledAccountState?: ReconciledAccountState
}

export interface AccountReplayResult {
  log: string[]
  audience?: ReplayAudience
  replayedActions?: ReplayAction[] | null
  replayedInstructions?: ReplayInstruction[] | null
  intermediateStates?: ReplayedAccountState[] | null
  replayedAccountState?: ReplayedAccountState
  cancelledOperations?: Operation[] | null
  reconciliationOperations?: ReplayReconciliationOperation[] | null
  /** @deprecated */
  transfers?: TransferOperation[] | null
  raiseOrdersImmediately?: boolean
}

export type AccountRunningStatus = 'New' | 'Running' | 'Suspended' | 'Closing' | 'Closed'

export interface AccountValuationBlock {
  accountId: string
  valuationCycle: ValuationCycleIdentifier
  valuationCycleExpiry: ValuationCycleExpiryIdentifier
  valuationSnap: ValuationSnapIdentifier
  owners?: AccountOwner[] | null
  initialState?: InitialAccountState
  inputs?: ValuationInput[] | null
  replayState?: AccountReplayResult
  reconciliationState?: AccountReconciliationResult
  dealingState?: DealingState
  valuationState?: ValuedAccountState
  outputs?: ValuationOutput[] | null
  errors?: AccountValuationBlockError[] | null
  blockHeader: BlockHeader
  metadata?: DocumentMetadata
}

export interface AccountValuationBlockError {
  stage?: AccountValuationStage
  severity: ErrorSeverity
  visibility?: ErrorVisibility
  error: string
}

export type AccountValuationStage =
  | 'None'
  | 'Creation'
  | 'Fetch'
  | 'InputProcessing'
  | 'Replay'
  | 'Reconciliation'
  | 'Dealing'
  | 'Valuation'

export type ActionResult = object

/**
 * Adds a new note to the system.
 */
export interface AddNote {
  noteName: string
  /** @format date-time */
  startDate: string
  /** @format date-time */
  endDate?: string | null
  dividendProcessing: ApiDividendProcessing
  businessUnitId: string
  fees?: ApiFee[] | null
  isCollateralForLoan: boolean
}

export interface AddUserRoleCommand {
  userName: string
  role: string
}

export type AdjustmentOngoingReason =
  | 'NewAdjustmentRebalancing'
  | 'PortfolioNotRunning'
  | 'WithdrawalPresent'
  | 'OrderBatchBeforeRiskNormalizationDate'
  | 'AdjustmentOrdersNotComplete'
  | 'AdjustmentInstructionsNotComplete'

export type AdjustmentReason =
  | 'TransferToleranceBreach'
  | 'AggregateTransferToleranceBreach'
  | 'SyntheticBuybackToleranceBreach'
  | 'AggregateSyntheticBuybackToleranceBreach'
  | 'ModifiedPortfolioState'
  | 'ScalingFactorChange'
  | 'FeeChangeToleranceBreach'
  | 'FeeProportionToleranceBreach'
  | 'OfficialHighWatermarkToleranceBreach'
  | 'WithdrawalHasOutstandingOrderBatches'
  | 'ActivePremiumToleranceBreach'
  | 'ProtectedValueToleranceBreach'

export interface AllAssetsLadderScenarioConfiguration {
  ladder?: number[] | null
  metadata?: DocumentMetadata
}

export interface AllAssetsLadderScenarioResult {
  values?: ScenarioPoint[] | null
  valuationCycle?: ValuationCycleIdentifier
  scenarioName?: string | null
  /** @format date-time */
  creationTime?: string
  metadata?: DocumentMetadata
}

export interface AncillaryAssetsDefinition {
  loanReferenceId?: string | null
  depositReferenceId?: string | null
  zcbInstrumentId?: string | null
}

export interface ApiAccountApprovalEvent {
  statusBefore?: ApiAccountStatus
  statusAfter?: ApiAccountStatus
  /** @format date-time */
  time?: string
  userId?: string | null
  firstName?: string | null
  lastName?: string | null
  organisation?: string | null
  comments?: string | null
}

export interface ApiAccountApprovalState {
  approvalEvents?: ApiAccountApprovalEvent[] | null
}

export interface ApiAccountBuilderState {
  /** @format date-time */
  lastModified?: string | null
  accountName?: string | null
  /** @format double */
  deposit?: number | null
  transferUnits?: ApiTransferOfUnits[] | null
  switchRequest?: ApiAccountSwitchRequest
  /** @format double */
  withdrawal?: number | null
  /** @format double */
  protectedValue?: number | null
  strategyTemplateId?: string | null
  note?: ApiNote
  client?: ApiClient
  businessUnit?: ApiBusinessUnit
  loanId?: string | null
  depositId?: string | null
  zcbInstrumentId?: string | null
  strategy?:
    | ApiPassThroughStrategy
    | ApiCPPIStrategy
    | ApiTIPPStrategy
    | ApiVolControlStrategy
    | null
  portfolio?: ApiModelPortfolio | ApiFundOfFundsPortfolio | ApiSelfSelectPortfolio | null
  protectionWeights?: ApiPortfolioInvestment[] | null
  closeAccount?: boolean
  portfolioOverrideFees?: ApiFee[] | null
  strategyOverrideFees?: ApiFee[] | null
  noteOverrideFees?: ApiFee[] | null
  updateDoesNotRequireFullApproval?: boolean
}

export type ApiAccountClosureInstruction = ApiInstruction & {
  type: ApiInstructionType
  /** @format date-time */
  effectiveDate?: string | null
  reason?: string | null
}

export interface ApiAccountDashboard {
  /** @format int32 */
  numberOfActiveAccounts?: number
  /** @format double */
  localCurrencyValue?: number | null
  notionalCurrency?: string | null
  /** @format double */
  zarValue?: number
  strategies?: ApiAccountDashboardStrategy[] | null
  assets?: ApiAccountDashboardAsset[] | null
  portfolios?: ApiAccountDashboardPortfolios
  notes?: ApiAccountDashboardNote[] | null
  currencies?: ApiAccountDashboardCurrency[] | null
  fees?: ApiAccountDashboardFeeDefinition[] | null
  aggregateAccountHistory?: ApiAggregateAccountHistory
}

export interface ApiAccountDashboardAccount {
  accountId: string
  accountSource: string
  notionalCurrency: string
  accountName: string
  status: ApiAccountRunningStatus
  noteId: string
  portfolioId: string
  strategyType: ApiStrategyType
  strategyTemplateName?: string | null
  /** @format double */
  leverageRatio?: number | null
  /** @format double */
  targetVolatility?: number | null
  strategyFees?: ApiFee[] | null
  /** @format date-time */
  latestValuationDate: string
  /** @format double */
  accountValue: number
  /** @format double */
  protectedLevel?: number | null
}

export interface ApiAccountDashboardAccountApiPaginationResult {
  /** @format int64 */
  totalDocuments: number
  data: ApiAccountDashboardAccount[]
}

export interface ApiAccountDashboardAsset {
  assetId: string
  name: string
  notionalCurrency: string
  assetClass: string
  /** @format int32 */
  numberOfActiveAccounts: number
  /** @format double */
  localCurrencyValue: number
  /** @format double */
  zarValue: number
  /** @format double */
  performancePercentage12Months?: number | null
  /** @format double */
  performancePercentageYTD?: number | null
}

export interface ApiAccountDashboardCurrency {
  notionalCurrency: string
  /** @format int32 */
  numberOfActiveAccounts: number
  /** @format double */
  localCurrencyValue: number
  /** @format double */
  zarValue: number
}

export interface ApiAccountDashboardFeeDefinition {
  feeType: ApiFeeType
  /** @format double */
  localCurrencyValue?: number | null
  notionalCurrency?: string | null
  /** @format double */
  zarValue: number
  totalsByCurrency: Record<string, number>
}

export interface ApiAccountDashboardFundOfFundsPortfolio {
  portfolioId: string
  portfolioName: string
  portfolioType: ApiPortfolioType
  /** @format date-time */
  startDate?: string | null
  /** @format date-time */
  lastRebalance?: string | null
  /** @format double */
  totalFees: number
  /** @format int32 */
  numberOfActiveAccounts: number
  /** @format double */
  localCurrencyValue: number
  /** @format double */
  zarValue: number
  notionalCurrency: string | null
  rebalancingDefinition: ApiRebalancingDefinition
  taxClassification?: ApiTaxClassification
}

export interface ApiAccountDashboardFundOfFundsPortfolioApiAccountDashboardPortfolioSummary {
  name: string
  /** @format int32 */
  numberOfActiveTrades: number
  portfolios?: ApiAccountDashboardFundOfFundsPortfolio[] | null
  notionalCurrency?: string | null
  /** @format double */
  localCurrencyValue?: number | null
  /** @format double */
  zarValue?: number | null
}

export interface ApiAccountDashboardModelPortfolio {
  portfolioId: string
  portfolioName: string
  portfolioType: ApiPortfolioType
  /** @format double */
  totalFees: number
  /** @format int32 */
  numberOfActiveAccounts: number
  /** @format double */
  localCurrencyValue: number
  /** @format double */
  zarValue: number
  notionalCurrency: string | null
  rebalancingDefinition: ApiRebalancingDefinition
  taxClassification?: ApiTaxClassification
}

export interface ApiAccountDashboardModelPortfolioApiAccountDashboardPortfolioSummary {
  name: string
  /** @format int32 */
  numberOfActiveTrades: number
  portfolios?: ApiAccountDashboardModelPortfolio[] | null
  notionalCurrency?: string | null
  /** @format double */
  localCurrencyValue?: number | null
  /** @format double */
  zarValue?: number | null
}

export interface ApiAccountDashboardNote {
  noteId: string
  /** @format int32 */
  numberOfActiveAccounts: number
  /** @format double */
  localCurrencyValue: number
  notionalCurrency?: string | null
  /** @format double */
  zarValue?: number
  noteName?: string | null
  client?: string | null
  businessUnit?: string | null
  taxClassification?: ApiTaxClassification
}

export interface ApiAccountDashboardPortfolios {
  model?: ApiAccountDashboardModelPortfolioApiAccountDashboardPortfolioSummary
  selfSelect?: ApiAccountDashboardSelfSelectPortfolioApiAccountDashboardPortfolioSummary
  fundOfFunds?: ApiAccountDashboardFundOfFundsPortfolioApiAccountDashboardPortfolioSummary
}

export interface ApiAccountDashboardSelfSelectPortfolio {
  portfolioType: ApiPortfolioType
  /** @format double */
  totalFees: number
  /** @format int32 */
  numberOfActiveAccounts: number
  /** @format double */
  localCurrencyValue: number
  /** @format double */
  zarValue: number
  notionalCurrency: string | null
  rebalancingDefinition: ApiRebalancingDefinition
  taxClassification?: ApiTaxClassification
}

export interface ApiAccountDashboardSelfSelectPortfolioApiAccountDashboardPortfolioSummary {
  name: string
  /** @format int32 */
  numberOfActiveTrades: number
  portfolios?: ApiAccountDashboardSelfSelectPortfolio[] | null
  notionalCurrency?: string | null
  /** @format double */
  localCurrencyValue?: number | null
  /** @format double */
  zarValue?: number | null
}

export interface ApiAccountDashboardStrategy {
  strategyName?: string | null
  /** @format int32 */
  numberOfActiveAccounts: number
  /** @format double */
  localCurrencyValue?: number | null
  /** @format double */
  zarValue?: number
  notionalCurrency?: string | null
  trades?: ApiAccountDashboardStrategyTrade[] | null
}

export interface ApiAccountDashboardStrategyTrade {
  /** @format double */
  zarValue?: number
  /** @format double */
  localCurrencyValue?: number
  notionalCurrency?: string | null
  /** @format double */
  protectedPercentage?: number | null
  /** @format double */
  leverageRatio?: number | null
  /** @format double */
  targetVolatility?: number | null
}

export interface ApiAccountDetails {
  accountId: string
  accountSource: string
}

export interface ApiAccountDocumentationInfo {
  accountId?: string | null
  /** @format int32 */
  number?: number
  fileName?: string | null
  /** @format date-time */
  timestamp?: string
  stage?: ApiAccountDocumentationStage
}

export type ApiAccountDocumentationStage =
  | 'Other'
  | 'Draft'
  | 'PendingExecution'
  | 'PendingApproval'
  | 'Final'

export interface ApiAccountHistoryReport {
  account?: ApiRunningAccount
  accountSnapShots: ApiAccountSnapshot[]
}

export interface ApiAccountHistoryReportWithNoteData {
  noteValueSummary: ApiNoteValueSummary
  account?: ApiRunningAccount
  accountSnapShots: ApiAccountSnapshot[]
}

export type ApiAccountLockType = 'SwitchInProgress'

export type ApiAccountRunningStatus = 'New' | 'Running' | 'Suspended' | 'Closing' | 'Closed'

export interface ApiAccountSnapshot {
  /** @format date-time */
  valuationDate: string
  accountDetails: ApiAccountDetails
  /** @format double */
  accountValue: number
  /**
   * @deprecated
   * @format double
   */
  amountInflightDepositOrders?: number | null
  /** @format double */
  netContributions?: number
  /**
   * @deprecated
   * @format double
   */
  protectedExposure?: number | null
  notionalCurrency?: string | null
  /** @format double */
  protectedAmount?: number
  /** @format double */
  highWatermark?: number | null
  /** @format double */
  protectedLevel?: number | null
  /**
   * @deprecated
   * @format double
   */
  loanAmount?: number | null
  /** @format double */
  targetVolatility?: number | null
  /** @format double */
  targetMultiplier?: number | null
  /** @format double */
  impliedMultiplier?: number | null
  /** @format double */
  targetLeverageRatio?: number | null
  /** @format double */
  targetPerformanceAllocation?: number | null
  /** @format double */
  targetProtectionAllocation?: number | null
  /** @format double */
  growthFactor?: number | null
  /**
   * @deprecated
   * @format double
   */
  growthExposure?: number | null
  /** @format double */
  performanceAllocation?: number | null
  /** @format double */
  pendingPerformanceAllocation?: number | null
  /** @format double */
  protectionAllocation?: number | null
  /** @format double */
  pendingProtectionAllocation?: number | null
  /** @format double */
  loanAllocation?: number | null
  /** @format double */
  cashAllocation?: number | null
  /** @format double */
  zcbAllocation?: number | null
  /** @format double */
  dividendAccrualValue?: number | null
  /** @format double */
  accruedFees?: number | null
  /** @format double */
  gapAmount?: number | null
  /** @format double */
  bondFloor: number | null
  growthAssets?: ApiInvestmentAmount[] | null
  protectedAssets?: ApiInvestmentAmount[] | null
  currencyHoldings?: ApiCurrencyHolding[] | null
  loanHoldings?: ApiLoanHolding[] | null
  operations?:
    | (
        | ApiDepositOperation
        | ApiStrategyChangeOperation
        | ApiPortfolioChangeOperation
        | ApiPortfolioFeeChangeOperation
        | ApiWithdrawalOperation
        | ApiRebalancingOperation
        | ApiProtectionPortfolioChangeOperation
        | ApiProtectedWithdrawalOperation
        | ApiProtectedAccountClosureOperation
        | ApiSwitchInOperation
        | ApiSwitchOutOperation
        | ApiProtectedSwitchOutOperation
      )[]
    | null
  strategyTemplateId?: string | null
  currentStrategy:
    | ApiPassThroughStrategy
    | ApiCPPIStrategy
    | ApiTIPPStrategy
    | ApiVolControlStrategy
}

export interface ApiAccountState {
  accountName: string
  /** @format double */
  investment?: number
  noteId?: string | null
  businessUnitId?: string | null
  clientId?: string | null
  loanId?: string | null
  depositId?: string | null
  zcbInstrumentId?: string | null
  strategyTemplateId?: string | null
  portfolio?: ApiModelPortfolio | ApiFundOfFundsPortfolio | ApiSelfSelectPortfolio | null
  strategy?:
    | ApiPassThroughStrategy
    | ApiCPPIStrategy
    | ApiTIPPStrategy
    | ApiVolControlStrategy
    | null
  protectionWeights?: ApiPortfolioInvestment[] | null
}

export type ApiAccountStatus =
  | 'Draft'
  | 'Rejected'
  | 'Expired'
  | 'PendingEconomicsApproval'
  | 'PendingApproval'
  | 'PendingCommitment'
  | 'PendingClientCommitment'
  | 'PendingSettlement'
  | 'PendingActivation'
  | 'PendingClosure'
  | 'Activating'
  | 'Active'
  | 'Inactive'
  | 'Deleted'

export interface ApiAccountSwitchRequest {
  originatingAccountId: string
  isFullSwitch: boolean
  /** @format double */
  switchAmount?: number | null
  isProcessed?: boolean | null
}

export interface ApiAccountUserDetails {
  username: string
  email: string
  emailConfirmed: boolean
  phoneNumber: string | null
  externalLogins: string[]
  twoFactorEnabled: boolean
  hasAuthenticator: boolean
  twoFactorClientRemembered: boolean
  /** @format int32 */
  recoveryCodesLeft: number
}

export interface ApiAccountsAndNotesInProgress {
  /** @format int32 */
  numberPendingTradeApprovals: number
  /** @format int32 */
  numberPendingNoteApprovals: number
}

export interface ApiAddBusinessUnitToClient {
  businessUnitName: string
  competency: ApiCompetencyType
  disallowedStrategies: string[]
}

export interface ApiAddBusinessUnitUser {
  firstName: string
  lastName: string
  email: string
  roles?: string[] | null
  portfolioManagerCategory?: ApiPortfolioManagerCategory
}

export interface ApiAddClientUser {
  firstName: string
  lastName: string
  email: string
}

export interface ApiAddDfmUser {
  firstName: string
  lastName: string
  email: string
  portfolioManagerCategory: ApiPortfolioManagerCategory
}

export interface ApiAggregateAccountHistory {
  dates?: string[] | null
  totalValues?: number[] | null
  netContributions?: number[] | null
}

export interface ApiAggregatedOrderConfirmation {
  orderConfirmationId: string
  confirmationAuthor: string
  /** @format date-time */
  createdTime: string
  state: ApiAggregatedOrderConfirmationState
  orderId: string
  /** @format double */
  executionPrice: number
}

export type ApiAggregatedOrderConfirmationState = 'Submitted' | 'Processed' | 'Ignored'

export interface ApiAggregatedOrderCorrection {
  orderCorrectionId: string
  correctionAuthor: string
  isProcessed: boolean
  /** @format date-time */
  createdTime: string
  /** @format date-time */
  valuationCycleWhenProcessed?: string | null
  /** @format double */
  sharesToBeAllocated?: number | null
  /** @format double */
  amountToBeAllocated?: number | null
  technicalAccountTransactionId?: string | null
  individualOrderCorrections?: ApiIndividualOrderCorrection[] | null
  orderId: string
  assetId: string
  /** @format double */
  executionPrice: number
  isAppliedToAccounts: boolean
}

export interface ApiAlertsConfiguration {
  lateDistributionAlert: ApiEmailAlert
  lateOrderConfirmationAlert: ApiEmailAlert
  gapEventAlert: ApiEmailAlert
  missingMarketDataAlert: ApiEmailAlert
}

export interface ApiAlphaVantageConfiguration {
  key: string
  urlFx: string
}

export type ApiAncillaryAssetsChangeInstruction = ApiInstruction & {
  type: ApiInstructionType
  newLoanReferenceId?: string | null
  newDepositReferenceId?: string | null
  newZcbInstrumentId?: string | null
}

export interface ApiAsset {
  type: ApiAssetType
  assetId: string
  isinCode: string
  name: string
  assetClass: string
  isMarketDataReady: boolean
  marketDataProvider?: string | null
  tradingProvider?: string | null
  currencyIso: string
  /** @format int32 */
  sharePrecisionScale: number
  /** @format int32 */
  priceScalingFactor: number
  dealingFrequency?: ApiAssetDealingFrequency
  dealingState?: ApiAssetDealingState
  protectionClassification: ApiAssetProtectionClassification
  dealingCalendar: ApiDealingHolidayCalendar
  /** @format int32 */
  noticePeriodDays: number
  /** @format int32 */
  cutoffTimeHours: number
  /** @format int32 */
  cutoffTimeMinutes: number
  /** @format double */
  targetVolatility?: number | null
  multiplier?: ApiFixedMultiplier | ApiVariableMultiplier | null
  /** @format double */
  maxLeverageRatio?: number | null
  taxClassification: ApiTaxClassification
  fees?: ApiFee[] | null
  disallowedStrategies: string[]
  assetTradeStatus?: ApiTradingStatus
  assetRebalancingStatus?: ApiTradingStatus
  exDates?: ApiExDate[] | null
  isExternal?: boolean
  source?: ApiSource
  isDeleted?: boolean
}

export interface ApiAssetConstituency {
  constituents: ApiConstituentAsset[]
  code: string
  /** @format date-time */
  valueDate: string
  /** @format date-time */
  receivedTime: string
  providerType: ApiMarketDataProviderType
}

export interface ApiAssetData {
  assetId: string
  protectionClassification?: ApiAssetProtectionClassification
  publishedPrices: ApiAssetPrice[]
  nextDistribution: ApiDistributionInfo
}

export type ApiAssetDealingFrequency = 'Monthly' | 'Daily' | 'Hourly'

export type ApiAssetDealingState = 'Active' | 'SoftClosed' | 'HardClosed'

export interface ApiAssetDefaultConfiguration {
  fees?: ApiFee[] | null
  assetClasses?: string[] | null
  currencies?: string[] | null
}

export interface ApiAssetDetails {
  asset: ApiMutualFundAsset | ApiSegregatedPortfolioAsset
  assetUsage: Record<string, number>
  assetIsInUse: boolean
  threeMonthPerformance?: ApiPerformance
  sixMonthPerformance?: ApiPerformance
  oneYearMonthPerformance?: ApiPerformance
  threeYearPerformance?: ApiPerformance
  fiveYearPerformance?: ApiPerformance
}

export interface ApiAssetDetailsApiPaginationResult {
  /** @format int64 */
  totalDocuments: number
  data: ApiAssetDetails[]
}

export interface ApiAssetExDates {
  exDates?: string[] | null
}

export interface ApiAssetMarketDataPrice {
  code: string
  /** @format double */
  price: number
  /** @format date-time */
  valueDate: string
  /** @format date-time */
  receivedTime: string
  providerType: ApiMarketDataProviderType
}

export interface ApiAssetPerformanceResponse {
  assetId: string
  /** @format double */
  weight: number
  performance: ApiPerformanceResponse[] | null
}

export interface ApiAssetPrice {
  /** @format date-time */
  priceDate: string
  /** @format double */
  midPrice: number
  estimate?: boolean
  /** @format date-time */
  effectiveDate?: string | null
}

export interface ApiAssetPriceUserOverride {
  isinCode?: string | null
  /** @format double */
  priceOverride?: number
}

export interface ApiAssetPriceWithHistory {
  /** @format date-time */
  currentValuationCycle?: string
  /** @format date-time */
  nextValuationCycle?: string
  assetName?: string | null
  currency?: string | null
  isinCode?: string | null
  currentPrice?: ApiAssetPriceWithOverride
  allPrices?: ApiAssetPriceWithOverride[] | null
}

export interface ApiAssetPriceWithOverride {
  /** @format double */
  price?: number
  isManuallyOverridden?: boolean
  source?: string | null
  displayName?: string | null
  /** @format date-time */
  receivedDateTime?: string
  /** @format date-time */
  valueDate?: string
}

export type ApiAssetProtectionClassification = 'Performance' | 'Protection'

export type ApiAssetType = 'MutualFund' | 'SegregatedPortfolio'

export interface ApiAssetWeight {
  asset: ApiMutualFundAsset | ApiSegregatedPortfolioAsset
  /** @format double */
  weight: number
}

export interface ApiAssetWithConstituents {
  assetId: string
  assetName: string
  currency: string
  constituentAssets?: ApiConstituentAsset[] | null
}

export interface ApiAssetWithOrderAlert {
  asset?: ApiMutualFundAsset | ApiSegregatedPortfolioAsset | null
  hasLateOrderConfirmations?: boolean
}

export interface ApiAssetWithOrderAlertApiPaginationResult {
  /** @format int64 */
  totalDocuments: number
  data: ApiAssetWithOrderAlert[]
}

export interface ApiAssociatedAccount {
  accountId: string
  accountSource: string
  accountName: string
  accountStatus: ApiAccountRunningStatus
  /** @format double */
  accountValue: number
  /** @format double */
  netContributions: number
  /** @format double */
  accountReturn: number
  /** @format double */
  yieldPercentage: number
  /** @format double */
  capitalPercentage: number
}

export interface ApiAuthenticatorDetails {
  sharedKey: string
  authenticatorUri: string
  errors: IdentityError[] | null
}

export interface ApiBackUpRequest {
  /** @format date-time */
  fromCreationTimeInclusive: string
  /** @format date-time */
  toCreationTimeExclusive: string
}

export interface ApiBacktestRequest {
  accountId?: string | null
  portfolioInvestment?: ApiPortfolioInvestment[] | null
}

export interface ApiBacktestResponse {
  backtestTimeseries: Factor[]
  portfolioPerformance: ApiPerformanceResponse
  assetPerformance: ApiAssetPerformanceResponse[]
}

export interface ApiBusinessUnit {
  businessUnitId: string
  businessUnitName: string
  competency: ApiCompetencyType
  disallowedStrategies?: string[] | null
}

export interface ApiBusinessUnitWithUsers {
  users?: UserInformationBasic[] | null
  businessUnitId: string
  businessUnitName: string
  competency: ApiCompetencyType
  disallowedStrategies?: string[] | null
}

export type ApiCPPIStrategy = ApiStrategy & {
  type: ApiStrategyType
  /** @format double */
  protectionPercentage?: number | null
  /** @format double */
  targetVolatility?: number | null
  /** @format double */
  volatilityIndexTriggerLevel?: number | null
  /** @format double */
  shortCircuitMaxAllocation?: number | null
  /** @format double */
  shortCircuitReducedMultiplier?: number | null
  /** @format date-time */
  maturityDate?: string
  highWatermarkObservationFrequency: ApiObservationFrequency
  hasBankGuarantee: boolean
}

export interface ApiCalculatedPortfolioMultiplier {
  /** @format double */
  multiplier: number
}

export interface ApiCashInstrument {
  type: ApiCashInstrumentType
  instrumentId: string
  name: string
  currencyIso: string
  /** @format int32 */
  sharePrecisionScale: number
}

export interface ApiCashInstrumentApiPaginationResult {
  /** @format int64 */
  totalDocuments: number
  data: (ApiLoan | ApiDeposit | ApiZcbCurve)[]
}

export interface ApiCashInstrumentTransaction {
  instrumentId: string
  instrumentType: ApiCashInstrumentType
  /** @format date-time */
  maturityDate?: string | null
  transactionId: string
  /** @format date-time */
  createdDate: string
  direction: ApiOrderLegDirection
  currency: string
  /** @format double */
  value: number
  /** @format double */
  shares: number
  /** @format double */
  price?: number | null
}

export type ApiCashInstrumentType = 'Loan' | 'Deposit' | 'ZcbCurve'

export interface ApiClient {
  clientId: string
  clientName: string
  isExternal: boolean
  businessUnits: ApiBusinessUnit[]
  clientType: ApiClientType
  reinvestmentType: ApiReinvestmentType
  disallowedStrategies?: string[] | null
  defaultFees?: ApiClientDefaultFees
  defaultCashInstruments: ApiClientDefaultCashInstruments
  tradeBuildingSettings: ApiClientTradeBuildingSettings
}

export interface ApiClientDefaultCashInstruments {
  loanId: string
  depositId: string
}

export interface ApiClientDefaultFees {
  defaultPortfolioFees?: ApiFee[] | null
  defaultNoteFees?: ApiFee[] | null
  defaultStrategyFees?: ApiClientStrategyFeeCriteria[] | null
}

export interface ApiClientStrategyFeeCriteria {
  strategyTemplateId: string
  hasBankGuarantee?: boolean
  isLeveraged?: boolean
  fees: ApiFee[]
}

export interface ApiClientTradeBuildingSettings {
  /** @format double */
  minimumNoteSize: number
  /** @format double */
  minimumAdditionalTradeSize: number
  /** @format double */
  minimumTopUpSize: number
  /** @format double */
  minimumWithdrawalSize: number
  defaultNoteCounterpartyId?: string | null
}

export type ApiClientType = 'Institutional' | 'Retail'

export interface ApiClientWithUsers {
  users?: UserInformationBasic[] | null
  clientId: string
  clientName: string
  isExternal: boolean
  businessUnits: ApiBusinessUnit[]
  clientType: ApiClientType
  reinvestmentType: ApiReinvestmentType
  disallowedStrategies?: string[] | null
  defaultFees?: ApiClientDefaultFees
  defaultCashInstruments: ApiClientDefaultCashInstruments
  tradeBuildingSettings: ApiClientTradeBuildingSettings
}

export type ApiCompetencyType = 'Entry' | 'Experienced' | 'Expert'

export type ApiCompletionTriggerType = 'OncePerDay' | 'AfterEachCompletion'

export interface ApiConfirmEmail {
  /** @format uuid */
  userId: string
  confirmEmailToken: string
}

export interface ApiConfirmEmailResult {
  /** @format uuid */
  userId: string
  passwordResetToken: string | null
  userAlreadyOnBoarded: boolean
}

export interface ApiConfirmSettlementRequest {
  transferOfUnits?: ApiTransferOfUnits[] | null
}

export interface ApiConfirmedAggregatedOrder {
  orderId: string
  assetId: string
  assetName: string
  direction: ApiOrderLegDirection
  state: ApiOrderLegState
  /** @format date-time */
  createdDate: string
  /** @format date-time */
  confirmedDate: string
  /** @format double */
  value?: number | null
  /** @format double */
  shares?: number | null
  /** @format int32 */
  numberAccounts: number
  individualOrders: ApiIndividualOrderSummary[]
  correction?: ApiAggregatedOrderCorrection
  confirmation?: ApiAggregatedOrderConfirmation
  confirmationAuthor: string
  /** @format double */
  executionPrice: number
}

export interface ApiConfirmedAggregatedOrderApiPaginationResult {
  /** @format int64 */
  totalDocuments: number
  data: ApiConfirmedAggregatedOrder[]
}

export interface ApiConstituentAsset {
  instrumentLongName?: string | null
  instrumentCode?: string | null
  isin?: string | null
  currency?: string | null
  type?: string | null
  sector?: string | null
  region?: string | null
  /** @format double */
  weight?: number | null
  /** @format double */
  aum?: number | null
  /** @format double */
  amountInvestedWithGapRisk?: number | null
  /** @format double */
  amountInvestedWithoutGapRisk?: number | null
}

export interface ApiContractNote {
  /** @format date-time */
  issuedDate: string
  issuer: ApiContractNoteIssuer
  reference?: string | null
  /** @format date-time */
  executedDate: string
  /** @format double */
  executedPrice: number
  /** @format double */
  executedFxRate?: number | null
  /** @format double */
  confirmedValue: number
  /** @format double */
  confirmedShares: number
  adjustment?: ApiContractNoteAdjustment
}

export interface ApiContractNoteAdjustment {
  reason: ApiContractNoteAdjustmentReason
  /** @format double */
  adjustedValue: number
  /** @format double */
  adjustedShares: number
}

export type ApiContractNoteAdjustmentReason = 'BalancedBatch'

export type ApiContractNoteIssuer = 'Market' | 'Contractual'

export interface ApiCounterparty {
  counterpartyId: string
  sdsId: string | null
  counterpartyName: string
}

export interface ApiCurrencyData {
  currency?: string | null
  publishedPrices: ApiCurrencyPrice[]
}

export interface ApiCurrencyDepositMarketDataPrice {
  code: string
  /** @format double */
  price: number
  /** @format date-time */
  valueDate: string
  /** @format date-time */
  receivedTime: string
  providerType: ApiMarketDataProviderType
}

export interface ApiCurrencyHolding {
  currency: string
  depositReferenceId: string
  /** @format double */
  balance?: number | null
  /** @format double */
  units?: number | null
  /** @format double */
  value?: number | null
}

export interface ApiCurrencyPrice {
  /** @format date-time */
  priceDate: string
  /** @format double */
  price: number
}

export interface ApiCurvePoint {
  /** @format date-time */
  date: string
  /** @format double */
  bid?: number | null
  /** @format double */
  ask?: number | null
}

export interface ApiDashboard {
  accounts?: ApiDashboardAccount[] | null
  assets?: ApiDashboardAsset[] | null
  portfolios?: ApiDashboardPortfolio[] | null
  notes?: ApiDashboardNote[] | null
  fxRates?: ApiDashboardFxRate[] | null
  performanceLogs?: string[] | null
}

export interface ApiDashboardAccount {
  accountId: string
  accountSource: string
  notionalCurrency: string
  accountName: string
  status: ApiAccountRunningStatus
  client: ApiDashboardClient
  businessUnit: ApiDashboardBusinessUnit
  noteId: string
  noteFees?: ApiDashboardFeeDefinition[] | null
  portfolioId: string
  portfolioFees?: ApiDashboardFeeDefinition[] | null
  strategyType: ApiStrategyType
  strategyTemplateName?: string | null
  /** @format double */
  leverageRatio?: number | null
  /** @format double */
  targetVolatility?: number | null
  strategyFees?: ApiDashboardFeeDefinition[] | null
  /** @format date-time */
  latestValuationDate: string
  /** @format double */
  accountValue: number
  /** @format double */
  protectedLevel?: number | null
  growthAssets?: ApiDashboardInvestmentAmount[] | null
  protectedAssets?: ApiDashboardInvestmentAmount[] | null
  currentlyUpdating: boolean
  currentlyApproving: boolean
  currentlyClosing: boolean
  portfolioName: string
  portfolioType: ApiPortfolioType
  noteName: string
  /** @format double */
  last30DaysPeformancePercent: number
  last30DaysPerformance: AccountPerformanceOnDay[]
  isLockedForUpdates: boolean
}

export interface ApiDashboardAsset {
  assetId: string
  name: string
  currency: string
  assetClass: string
}

export interface ApiDashboardBusinessUnit {
  businessUnitId: string
  businessUnitName: string
}

export interface ApiDashboardClient {
  clientId: string
  clientName: string
}

export interface ApiDashboardFeeDefinition {
  feeType: ApiFeeType
  /** @format double */
  feeRate: number
}

export interface ApiDashboardFxRate {
  /** @format double */
  spotRate: number
  currencyBase: string
  currencyCounter: string
}

export interface ApiDashboardInvestmentAmount {
  assetId: string
  /** @format double */
  value: number
}

export interface ApiDashboardNote {
  noteId: string
  noteName: string
  isLocked: boolean
  fees?: ApiDashboardFeeDefinition[] | null
  isCollateralForLoan: boolean
}

export interface ApiDashboardPortfolio {
  portfolioId: string
  portfolioName: string
}

export interface ApiDealingHolidayCalendar {
  dealingPeriodExpectation: ApiDealingPeriodExpectation
  /** @format date-time */
  startDate: string
  /** @format date-time */
  endDate: string
  assumptions: ApiHolidayCalendarAssumptions
  holidays: string[]
}

export interface ApiDealingPeriodExpectation {
  /** @format duration */
  executionRedemption: string
  /** @format duration */
  executionSubscription: string
  /** @format duration */
  confirmationRedemption: string
  /** @format duration */
  confirmationSubscription: string
  /** @format int32 */
  settlementRedemption: number
  /** @format int32 */
  settlementSubscription: number
  /** @format duration */
  navPublication: string
}

export type ApiDeposit = ApiCashInstrument & {
  type: ApiCashInstrumentType
}

export type ApiDepositInstruction = ApiInstruction & {
  type: ApiInstructionType
  /** @format double */
  requestedValue: number
}

export type ApiDepositOperation = ApiOperation & {
  type: ApiOperationType
  reason?: ApiDepositReason
}

export type ApiDepositReason = 'None' | 'Deposit' | 'Rebate'

export interface ApiDfm {
  dfmId: string
  dfmName: string
}

export interface ApiDfmWithUsers {
  users?: UserInformationBasicDfm[] | null
  dfmId: string
  dfmName: string
}

export interface ApiDistributionAlert {
  assetId: string
  assetName: string
  isDistributionLate: boolean
  hasOnlyProviderDistribution: boolean
  isConfirmationLate: boolean
  hasOnlyProviderConfirmation: boolean
  hasUnassignedConfirmation: boolean
}

export interface ApiDistributionData {
  code: string
  /** @format date-time */
  receivedTime: string
  distributionType: ApiDistributionType
  /** @format date-time */
  declarationDate?: string | null
  /** @format date-time */
  reinvestmentDate?: string | null
  /** @format date-time */
  exDistributionDate: string
  /** @format double */
  amountPerShare: number
  isCorrection: boolean
  providerType: ApiMarketDataProviderType
}

export interface ApiDistributionInfo {
  /** @format double */
  amountPerShare: number
  /** @format date-time */
  exDividendDate: string
  /** @format date-time */
  reinvestmentDate?: string | null
}

export type ApiDistributionType = 'Dividend' | 'Interest' | 'Capital'

export type ApiDividendInstruction = ApiInstruction & {
  type: ApiInstructionType
  distributionType?: ApiDistributionType
  referenceId: string
  assetId: string
  /** @format date-time */
  exDividendDate: string
  /** @format date-time */
  reinvestmentDate?: string | null
  /** @format date-time */
  previousReinvestmentDate?: string | null
  /** @format double */
  heldShares?: number | null
  /** @format double */
  dividendAmountPerShare?: number
  /** @format double */
  previousDividendAmountPerShare?: number | null
  isCorrection?: boolean
}

export type ApiDividendProcessing = 'Reinvested' | 'Paid'

export interface ApiEditUser {
  userName: string
  firstName: string
  lastName: string
  rolesToRemove?: string[] | null
  rolesToAdd?: string[] | null
  portfolioManagerCategory?: ApiPortfolioManagerCategory
}

export interface ApiEmailAlert {
  isEnabled: boolean
  emailAddress: string | null
}

export interface ApiEmailDetails {
  /** @format uuid */
  id: string
  from?: string[] | null
  to?: string[] | null
  cc?: string[] | null
  subject?: string | null
  textBody?: string | null
}

export interface ApiEmailRequest {
  to?: string | null
  subject?: string | null
  body?: string | null
}

export interface ApiExDate {
  /** @format date-time */
  date: string
  provider: ApiMarketDataProviderType
}

export interface ApiExpectedReinvestmentData {
  assetId: string
  /** @format double */
  assetPriceScalingFactor: number
  /** @format date-time */
  exDate: string
  /** @format date-time */
  assetPriceValueDate: string
  /** @format double */
  assetPrice: number
  /** @format double */
  referenceHoldingUnits: number
  scaledDistributions: {
    /** @format double */
    Dividend?: number
    /** @format double */
    Interest?: number
    /** @format double */
    Capital?: number
  }
  /** @format double */
  totalDistributionAmount: number
  /** @format double */
  expectedReinvestmentUnits: number
}

export interface ApiExternalAccountValuationsSource {
  isEnabled: boolean
  login: string
  password: string
  url: string
  source?: ApiSource
  fakeNote: ApiNote
  fakeClient: ApiClient
}

export interface ApiExternalAccountValuationsSourcesConfiguration {
  externalSources: ApiExternalAccountValuationsSource[] | null
}

export interface ApiFee {
  /** @format uuid */
  feeId: string
  feeType: ApiFeeType
  /** @format double */
  feeRate: number
  feeDeductionFrequency: ApiFeeDeductionFrequency
  isVATApplicable: boolean
  feeBasis: ApiFeeBasis
  feeDayCount: ApiFeeDayCount
  counterPartyId: string
}

export type ApiFeeBasis = 'TotalTradeValue' | 'RiskyAssetExposure' | 'LoanAmount'

export type ApiFeeDayCount = 'Act_365' | 'Act_Act' | 'Act_360' | 'Thirty_360' | 'Thirty_365'

export type ApiFeeDeductionFrequency =
  | 'None'
  | 'Quarterly'
  | 'Monthly'
  | 'Annually'
  | 'UpFront'
  | 'Exit'

export interface ApiFeeDeductionOverride {
  /** @format date-time */
  effectiveCycle: string
  /** @format date-time */
  feeDeductionCycle: string
}

export type ApiFeeType =
  | 'GapProtectionPremium'
  | 'LoanFee'
  | 'DistributionFee'
  | 'StrategyFee'
  | 'PlatformFee'
  | 'PortfolioManagementFee'
  | 'NoteFee'
  | 'ExitFee'
  | 'TransactionFee'
  | 'Delta1PremiumFee'
  | 'RiskControlledPremiumFee'
  | 'HedgingPremiumFee'
  | 'OngoingPremium'
  | 'LifeCompanyFee'
  | 'AdviceFee'
  | 'DiscretionaryFundManagementFee'
  | 'StrategyAdviceFee'

export interface ApiFinSwitchConfiguration {
  login: string
  password: string
  companyCode: string
  bulkedInvestorCode: string
  address: string
  /** @format int32 */
  maximumNumberOfCalendarDaysInRequest: number
  /** @format int32 */
  minimumNumberSecondsBetweenCalls: number
  useIsoCurrencyCodes?: boolean | null
}

export type ApiFixedMultiplier = ApiMultiplierConfiguration & {
  multiplierType: ApiMultiplierType
  /** @format double */
  multiplier: number
}

export interface ApiForgotPassword {
  email: string
  recaptchaResponse: string | null
  remoteIP: string | null
}

export interface ApiFrontendConfiguration {
  allowTradeBuilder: boolean
}

export interface ApiFundExternalIdentifiers {
  managementCompanyCode?: string | null
  fundCode?: string | null
  productCode?: string | null
  accountNumber?: string | null
  fundManagerCounterpartyId?: string | null
}

export interface ApiFundOfFundsData {
  portfolioId: string
  investmentWeights?: InvestmentWeight[] | null
  theoreticalFundUnits?: ApiInvestmentShares[] | null
}

export type ApiFundOfFundsPortfolio = ApiPortfolio & {
  type: ApiPortfolioType
  investmentWeights?: ApiPortfolioInvestment[] | null
  /** @format date-time */
  startDate?: string | null
  portfolioOwnerId?: string | null
}

export interface ApiFxData {
  currencyPair: string
  /** @format double */
  spotRate: number
  /** @format date-time */
  spotDate: string
}

export interface ApiFxRateQuote {
  /** @format double */
  spotRate: number
  currencyBase: string
  currencyCounter: string
  /** @format date-time */
  valueDate: string
  /** @format date-time */
  receivedTime: string
  providerType: ApiMarketDataProviderType
}

export interface ApiGapPayments {
  clientId?: string | null
  clientName?: string | null
  counterPartyId?: string | null
  /** @format double */
  gapAmount?: number
}

export interface ApiGapRiskInfo {
  /** @format double */
  targetMultiplier?: number | null
  /** @format double */
  impliedMultiplier?: number | null
  /** @format double */
  ratioImpliedMultiplierOverTargetMultiplier?: number | null
  fundMultipliers?: Record<string, number>
  /** @format double */
  protectedAmount?: number
  /** @format double */
  cushion?: number | null
  /** @format double */
  gapPutStrike?: number | null
  /** @format double */
  riskyAssetTargetAllocation?: number | null
  /** @format double */
  riskyAssetCurrentAllocation?: number
  /** @format double */
  riskFreeAssetTargetAllocation?: number | null
  /** @format double */
  riskFreeAssetCurrentAllocation?: number
  /** @format double */
  loanAmount?: number
  /** @format double */
  grossTradeValue?: number
  isRebalancingTakingPlace?: boolean
  /** @format double */
  netTradeValue?: number
  /** @format double */
  checkCalculation?: number | null
}

export interface ApiGetAccountAccrualsFilter {
  noteIds?: string[] | null
  feeType?: ApiFeeType
  /** @format date-time */
  startDateInclusive?: string
  /** @format date-time */
  endDateInclusive?: string
}

export interface ApiGetNoteExportFilters {
  ids?: string[] | null
  currencyCode?: string | null
  clientType?: ApiClientType
  isNoteCollateralized?: boolean | null
}

export interface ApiHolidayCalendar {
  /** @format date-time */
  startDate: string
  /** @format date-time */
  endDate: string
  assumptions: ApiHolidayCalendarAssumptions
  holidays: string[]
}

export type ApiHolidayCalendarAssumptions = 'None' | 'Weekends'

export interface ApiIdentifierConfiguration {
  accountSettings?: ApiIdentifierSetting
  portfolioSettings?: ApiIdentifierSetting
  noteSettings?: ApiIdentifierSetting
}

export interface ApiIdentifierSetting {
  idPrefix?: string | null
  /** @format int32 */
  idPaddingLength?: number
  /** @format int32 */
  nextId?: number
  /** @format date-time */
  lastUpdateTime?: string
}

export interface ApiIndex {
  assetId: string
  name: string
}

export interface ApiIndexData {
  assetId: string
  publicationCalendar?: ApiHolidayCalendar
  prices: ApiAssetPrice[]
}

export interface ApiIndexMarketDataPrice {
  code: string
  /** @format double */
  price: number
  /** @format date-time */
  valueDate: string
  /** @format date-time */
  receivedTime: string
  providerType: ApiMarketDataProviderType
}

export interface ApiIndividualOrderCorrection {
  orderId: string
  accountId: string
  /** @format double */
  shares?: number | null
  /** @format double */
  amount?: number | null
}

export interface ApiIndividualOrderSummary {
  accountName: string
  accountStatus: ApiAccountStatus
  businessUnitName: string
  /** @format double */
  value?: number | null
  /** @format double */
  shares?: number | null
}

export interface ApiInstruction {
  type: ApiInstructionType
  accountId: string
  /** @format date-time */
  valuationCycle: string
}

export interface ApiInstructionSet {
  portfolioChanges?: ApiPortfolioChangeInstruction[] | null
  withdrawals?: ApiWithdrawalInstruction[] | null
  deposits?: ApiDepositInstruction[] | null
  switchOutInstructions?: ApiSwitchOutInstruction[] | null
}

export type ApiInstructionType =
  | 'Unknown'
  | 'NewAccount'
  | 'Deposit'
  | 'Dividend'
  | 'Withdrawal'
  | 'AccountClosure'
  | 'ExternalTransfer'
  | 'StrategyChange'
  | 'PortfolioChange'
  | 'ProtectedValueChange'
  | 'ProtectionReset'
  | 'ProtectionPortfolioChange'
  | 'NoteChange'
  | 'AncillaryAssetsChange'
  | 'ReinvestmentConfirmation'
  | 'SwitchIn'
  | 'SwitchOut'
  | 'OrderCorrection'

export interface ApiInvestmentAmount {
  assetId: string
  assetName: string
  assetClass: string
  /** @format double */
  amount: number
  /** @format double */
  units: number
}

export interface ApiInvestmentShares {
  assetId: string
  /** @format double */
  shares: number
}

export type ApiLoan = ApiCashInstrument & {
  type: ApiCashInstrumentType
}

export interface ApiLoanData {
  loanId?: string | null
  publishedPrices: ApiLoanPrice[]
}

export interface ApiLoanHolding {
  currency: string
  loanId: string
  /** @format double */
  units: number
  /** @format double */
  value?: number | null
}

export interface ApiLoanMarketDataPrice {
  code: string
  /** @format double */
  price: number
  /** @format date-time */
  valueDate: string
  /** @format date-time */
  receivedTime: string
  providerType: ApiMarketDataProviderType
}

export interface ApiLoanPrice {
  /** @format date-time */
  priceDate: string
  /** @format double */
  price: number
}

export interface ApiLogEventSimple {
  /** @format date-time */
  timestamp: string
  level: ApiLogLevel
  renderedMessage: string
  exception?: string | null
}

export type ApiLogLevel = 'Verbose' | 'Debug' | 'Information' | 'Warning' | 'Error' | 'Fatal'

export interface ApiLogRequest {
  /** @format date-time */
  fromTimeExclusive?: string
  /** @format date-time */
  toTimeInclusive?: string
  levels?: ApiLogLevel[] | null
}

export interface ApiLoginUser {
  username: string
  password: string
  rememberMe: boolean
}

export interface ApiMarketAumValue {
  code: string
  /** @format date-time */
  receivedTime: string
  /** @format date-time */
  valueDate: string
  /** @format double */
  aum?: number
  providerType: ApiMarketDataProviderType
}

export interface ApiMarketDataConfiguration {
  /** @format duration */
  marketDataCutOffBeforeValuationCycleExpiry: string | null
}

export type ApiMarketDataProviderType = 'FinSwitch' | 'Absa' | 'Dominion' | 'AlphaVantage' | 'None'

export interface ApiMarketDataSet {
  providerType: ApiMarketDataProviderType
  aumValues: ApiMarketAumValue[] | null
  assetPrices: ApiAssetMarketDataPrice[] | null
  fxRates: ApiFxRateQuote[] | null
  currencyDepositPrices: ApiCurrencyDepositMarketDataPrice[] | null
  loanPrices: ApiLoanMarketDataPrice[] | null
  indexPrices: ApiIndexMarketDataPrice[] | null
  distributions: ApiDistributionData[] | null
  assetConstituencies: ApiAssetConstituency[] | null
}

export interface ApiMarketDataSetRequest {
  /** @format date-time */
  fromCreationTimeInclusive: string
  /** @format date-time */
  toCreationTimeExclusive: string
}

export interface ApiMarketDataSnapshot {
  /** @format date-time */
  snap: string
  assets?: ApiAssetData[] | null
  indexes?: ApiIndexData[] | null
  fx?: ApiFxData[] | null
  currencies?: ApiCurrencyData[] | null
  loans?: ApiLoanData[] | null
  zcbCurves?: ApiZcbCurveData[] | null
  fundOfFunds?: ApiFundOfFundsData[] | null
}

export interface ApiModelParametersMessage {
  /** @format date-time */
  effectiveCycle: string
  valuationModel?: ApiValuationModelIdentity
  notionalCurrency?: string | null
  /** @format int32 */
  notionalPrecision?: number | null
  /** @format int32 */
  notionalUnitPrecision?: number | null
  /** @format double */
  vatRate: number
  valuationHolidayCalendar?: ApiHolidayCalendar
  /** @deprecated */
  loanId?: string | null
  /** @format int32 */
  loanUnitPrecision?: number | null
  feeDeductionOverrides?: ApiFeeDeductionOverride[] | null
}

export type ApiModelPortfolio = ApiPortfolio & {
  type: ApiPortfolioType
  portfolioOwnerId?: string | null
}

export interface ApiModelPortfolioApiPaginationResult {
  /** @format int64 */
  totalDocuments: number
  data: ApiModelPortfolio[]
}

export interface ApiModelPortfolioMinimal {
  portfolioType?: ApiPortfolioType
  portfolioId: string
  portfolioName?: string | null
  taxClassification?: ApiTaxClassification
  disallowedStrategies?: string[] | null
}

export interface ApiModelPortfolioUsage {
  portfolioId: string
  /** @format double */
  totalValue: number
  totalValueByClient: Record<string, number>
  totalValueByBusinessUnit: Record<string, number>
}

export interface ApiMultiplierConfiguration {
  multiplierType: ApiMultiplierType
  /** @format double */
  shortLambda: number
  /** @format double */
  longLambda: number
}

export type ApiMultiplierType = 'Variable' | 'Fixed'

export type ApiMutualFundAsset = ApiAsset & {
  type: ApiAssetType
  fundManager?: string | null
  externalIdentifiers?: ApiFundExternalIdentifiers
}

export type ApiNewAccountInstruction = ApiInstruction & {
  type: ApiInstructionType
  initialisation?:
    | (
        | ApiNewAccountInstruction
        | ApiDepositInstruction
        | ApiPortfolioChangeInstruction
        | ApiAccountClosureInstruction
        | ApiWithdrawalInstruction
        | ApiProtectedValueChangeInstruction
        | ApiStrategyChangeInstruction
        | ApiProtectionPortfolioChangeInstruction
        | ApiAncillaryAssetsChangeInstruction
        | ApiSwitchInInstruction
        | ApiSwitchOutInstruction
        | ApiDividendInstruction
        | ApiReinvestmentConfirmationInstruction
        | ApiNoteChangeInstruction
      )[]
    | null
}

export interface ApiNewAggregatedOrderConfirmation {
  orderId: string
  /** @format double */
  executionPrice: number
}

export interface ApiNewAggregatedOrderCorrection {
  orderId: string
  assetId: string
  /** @format double */
  executionPrice: number
  isAppliedToAccounts: boolean
}

export interface ApiNewBusinessUnit {
  businessUnitIdOverride?: string | null
  businessUnitName: string
  competency: ApiCompetencyType
  disallowedStrategies?: string[] | null
}

export interface ApiNewClient {
  clientIdOverride?: string | null
  clientName: string
  businessUnits: ApiNewBusinessUnit[]
  clientType: ApiClientType
  reinvestmentType: ApiReinvestmentType
  disallowedStrategies?: string[] | null
  defaultFees?: ApiClientDefaultFees
  defaultCashInstruments: ApiClientDefaultCashInstruments
  tradeBuildingSettings: ApiClientTradeBuildingSettings
}

export interface ApiNewDfm {
  dfmName: string
}

export interface ApiNewPortfolio {
  portfolioType?: ApiPortfolioType
  portfolioName?: string | null
  rebalancingDefinition: ApiRebalancingDefinition
  targetWeights: ApiPortfolioInvestment[]
  allowedBusinessUnitIds?: string[] | null
  fees?: ApiFee[] | null
  /** @format double */
  multiplier?: number | null
  /** @format date-time */
  dateAdded?: string | null
  disallowedStrategies?: string[] | null
  investmentWeights?: ApiPortfolioInvestment[] | null
  /** @format date-time */
  startDate?: string | null
  portfolioOwnerId?: string | null
}

export interface ApiNewReinvestmentConfirmation {
  assetId: string
  /** @format double */
  shares: number
  /** @format date-time */
  reinvestmentDate: string
  /** @format date-time */
  exDate: string
}

export interface ApiNewStrategyTemplate {
  strategyTemplateIdOverride?: string | null
  strategyName: string
  strategyType: ApiStrategyType
  protectionAssetId?: string | null
  /** @format int32 */
  sortOrder?: number
  defaultHighWatermarkObservationFrequency?: ApiObservationFrequency
  highWatermarkObservationFrequency?: ApiObservationFrequency
  /** @format double */
  minProtectionLevel?: number | null
  /** @format double */
  maxProtectionLevel?: number | null
  /** @format double */
  defaultProtectionLevel?: number | null
  /** @format double */
  protectionLevel?: number | null
  /** @format double */
  minLeverageRatio?: number | null
  /** @format double */
  maxLeverageRatio?: number | null
  /** @format double */
  defaultLeverageRatio?: number | null
  /** @format double */
  leverageRatio?: number | null
  /** @format double */
  minTargetVolatility?: number | null
  /** @format double */
  maxTargetVolatility?: number | null
  /** @format double */
  defaultTargetVolatility?: number | null
  targetVolatilityMappings?: DecimalDecimalTuple[] | null
  /** @format double */
  volatilityIndexTriggerLevel?: number | null
  /** @format double */
  shortCircuitMaxAllocation?: number | null
  /** @format double */
  shortCircuitReducedMultiplier?: number | null
  /** @format double */
  targetVolatility?: number | null
  /** @format int32 */
  minNumberOfMonthsToTimeToMaturity?: number | null
  /** @format int32 */
  maxNumberOfMonthsToTimeToMaturity?: number | null
}

export interface ApiNote {
  noteId: string
  noteName: string
  isExternal: boolean
  /** @format date-time */
  startDate: string
  /** @format date-time */
  endDate?: string | null
  dividendProcessing: ApiDividendProcessing
  taxClassification?: ApiTaxClassification
  businessUnitId: string
  counterPartyId: string
  fees?: ApiFee[] | null
  /** @format int32 */
  topupNumber?: number | null
  associatedTrades?: ApiAssociatedAccount[] | null
  isCollateralForLoan?: boolean
}

export type ApiNoteChangeInstruction = ApiInstruction & {
  type: ApiInstructionType
  note: ApiNoteChangeRequest
}

export interface ApiNoteChangeRequest {
  noteId: string
  dividendProcessing: ApiDividendProcessing
  fees?: ApiFee[] | null
}

export interface ApiNoteData {
  noteId: string
  noteTaxClassification: ApiTaxClassification
  newCalculatedNoteTaxClassifications: ApiTaxClassification
  /** @format double */
  currentCalculatedNoteSize: number
  /** @format double */
  newCurrentCalculatedNoteSize: number
}

export interface ApiNoteDefaultConfiguration {
  counterPartyIds?: string[] | null
}

export interface ApiNoteInProgress {
  noteId: string
  noteName: string
  noteStatus: ApiNoteStatus
  client: string
  businessUnitId: string
  counterpartyId: string
  /** @format date-time */
  startDate: string
  /** @format date-time */
  endDate?: string | null
  dividendProcessing: ApiDividendProcessing
  taxClassification: ApiTaxClassification
  taxClassificationBreakDown: {
    /** @format double */
    Yield?: number
    /** @format double */
    Capital?: number
  }
  /** @format double */
  currentValue: number
  /** @format double */
  newValue: number
  ongoingInstructionType: ApiNoteInstructionType
  /** @format double */
  instructionAmount: number
  /** @format int32 */
  numberActiveTrades: number
  /** @format int32 */
  numberClosedTrades: number
  associatedTrades: ApiNoteInProgressAssociatedTrade[]
  canBeRejectedByUser: boolean
  /** @format date-time */
  dateActionIsRequiredBy?: string | null
  isCollateralForLoan: boolean
}

export interface ApiNoteInProgressApiPaginationResult {
  /** @format int64 */
  totalDocuments: number
  data: ApiNoteInProgress[]
}

export interface ApiNoteInProgressAssociatedTrade {
  accountId: string
  accountName: string
  /** @format double */
  instructionAmount: number
  /** @format int32 */
  instructionDocumentNumber: number
}

export interface ApiNoteInstructionSubmission {
  noteId: string
  instructionType: ApiNoteInstructionType
  accountAmounts: Record<string, number>
}

export type ApiNoteInstructionType = 'Deposit' | 'Withdrawal'

export interface ApiNotePrices {
  /** @format double */
  basePortfolioValue?: number
  /** @format double */
  currentPortfolioValue?: number
  /** @format double */
  noteUnits?: number
  /** @format double */
  baseCostPerUnit?: number
  /** @format double */
  notePrice?: number
}

export type ApiNoteStatus =
  | 'Active'
  | 'Expired'
  | 'PendingApproval'
  | 'PendingCommitment'
  | 'PendingClientCommitment'
  | 'PendingSettlement'
  | 'PendingActivation'
  | 'Activating'

export interface ApiNoteValueSummary {
  /** @format int32 */
  numberActiveTrades?: number
  /** @format int32 */
  numberClosedTrades?: number
  totalValues?: Record<string, number>
}

export type ApiObservationFrequency =
  | 'None'
  | 'Daily'
  | 'Weekly'
  | 'Monthly'
  | 'Quarterly'
  | 'SemiAnnually'
  | 'Annually'

export interface ApiOnboardingDetails {
  /** @format uuid */
  userId: string
  confirmEmailToken: string
  newPassword: string
}

export interface ApiOperation {
  type: ApiOperationType
  operationId: string
  /** @format date-time */
  generatedDate: string
  /** @format date-time */
  targetDate?: string | null
  state: ApiOperationState
  information?: string | null
  orders?: ApiOrderBatch[] | null
  cashTransactions?: ApiCashInstrumentTransaction[] | null
  associatedInstruction?:
    | ApiNewAccountInstruction
    | ApiDepositInstruction
    | ApiPortfolioChangeInstruction
    | ApiAccountClosureInstruction
    | ApiWithdrawalInstruction
    | ApiProtectedValueChangeInstruction
    | ApiStrategyChangeInstruction
    | ApiProtectionPortfolioChangeInstruction
    | ApiAncillaryAssetsChangeInstruction
    | ApiSwitchInInstruction
    | ApiSwitchOutInstruction
    | ApiDividendInstruction
    | ApiReinvestmentConfirmationInstruction
    | ApiNoteChangeInstruction
    | null
}

export type ApiOperationState = 'Queued' | 'Processing' | 'Completed' | 'Rejected'

export type ApiOperationType =
  | 'Unknown'
  | 'Deposit'
  | 'PortfolioChange'
  | 'PortfolioSubstitution'
  | 'FeeRateChange'
  | 'FeeDeduction'
  | 'Dividend'
  | 'ReinvestmentConfirmation'
  | 'SyntheticTransfer'
  | 'Withdrawal'
  | 'AccountClosure'
  | 'StrategyChange'
  | 'ExternalTransfer'
  | 'Rebalancing'
  | 'Redemption'
  | 'Defeasance'
  | 'ReconciliationTransfer'
  | 'TriggeredFeeDeduction'
  | 'TargetVolatilityChange'
  | 'ProtectionPortfolioChange'
  | 'ProtectedValueChange'
  | 'ProtectionPercentageChange'
  | 'ProtectionReset'
  | 'ProtectedFeeDeduction'
  | 'ProtectedWithdrawal'
  | 'ProtectedAccountClosure'
  | 'GapPayment'
  | 'NoteChange'
  | 'AncillaryAssetsChange'
  | 'SwitchIn'
  | 'SwitchOut'
  | 'ProtectedSwitchOut'
  | 'OrderCorrection'
  | 'PortfolioFeeChange'

export interface ApiOrderBatch {
  orderBatchId: string
  /** @format date-time */
  createdDate: string
  aggregateState: ApiOrderBatchAggregateState
  /** @format date-time */
  alignmentDate?: string | null
  legs: ApiOrderLeg[]
}

export type ApiOrderBatchAggregateState = 'New' | 'InProgress' | 'Complete'

export interface ApiOrderLeg {
  assetId: string
  /** @format date-time */
  createdDate: string
  direction: ApiOrderLegDirection
  state: ApiOrderLegState
  /** @format double */
  value?: number | null
  currency?: string | null
  /** @format double */
  shares?: number | null
  /** @format double */
  estimatedValue?: number | null
  /** @format date-time */
  placedDate?: string | null
  /** @format date-time */
  requestedExecutionDate?: string | null
  /** @format date-time */
  requestedEffectiveDate?: string | null
  /** @format date-time */
  expectedExecutionDate?: string | null
  contractNote?: ApiContractNote
}

export type ApiOrderLegDirection = 'Subscription' | 'Redemption'

export type ApiOrderLegState =
  | 'New'
  | 'Requested'
  | 'Placed'
  | 'Confirmed'
  | 'Settled'
  | 'Rejected'
  | 'Cancelled'

export type ApiOrderTradingAgent = 'FinSwitch' | 'Absa'

export interface ApiOrganisation {
  organisationType: ApiOrganisationType
  organisationId: string
  organisationName: string
}

export type ApiOrganisationType =
  | 'Unknown'
  | 'Administrator'
  | 'Bank'
  | 'Client'
  | 'BusinessUnit'
  | 'Dfm'

export interface ApiOutstandingAggregatedOrder {
  orderId: string
  assetId: string
  assetName: string
  direction: ApiOrderLegDirection
  state: ApiOrderLegState
  /** @format date-time */
  createdDate: string
  /** @format double */
  value?: number | null
  /** @format double */
  shares?: number | null
  /** @format double */
  estimatedPrice: number
  isConfirmationLate: boolean
  confirmation?: ApiAggregatedOrderConfirmation
  /** @format int32 */
  numberAccounts: number
  individualOrders: ApiIndividualOrderSummary[]
}

export interface ApiOverrideInfo {
  /** @format date-time */
  noOverrideStartTime?: string | null
  /** @format date-time */
  noOverrideEndTime?: string | null
  /** @format date-time */
  currentTime?: string
  areOverridesAllowed?: boolean
}

export interface ApiOverridenAssetPrice {
  /** @format date-time */
  overrideDateTime?: string
  /** @format date-time */
  valuationCycle?: string
  /** @format date-time */
  valueDate?: string
  overrideAuthor?: string | null
  overrideAuthorDisplayName?: string | null
  isinCode?: string | null
  /** @format double */
  newPrice?: number
}

export type ApiPassThroughStrategy = ApiStrategy & {
  type: ApiStrategyType
  /** @format double */
  volatilityIndexTriggerLevel?: number | null
  /** @format double */
  shortCircuitMaxAllocation?: number | null
}

export interface ApiPaymentsConfiguration {
  /** @format int32 */
  clientWithdrawalsPaymentLag: number
  /** @format int32 */
  clientDepositsPaymentLag: number
  /** @format int32 */
  fundSettlementSellPaymentLag: number
  /** @format int32 */
  fundSettlementBuyPaymentLag: number
  /** @format int32 */
  bankDeductionPaymentLag: number
  /** @format int32 */
  gapAmountPaymentLag: number
  /** @format int32 */
  gapPremiumPaymentLag: number
}

export interface ApiPerformance {
  /** @format double */
  totalReturn?: number | null
  /** @format double */
  ytdReturn?: number | null
  /** @format double */
  rollingYtdReturn?: number | null
  /** @format double */
  realisedVolatility?: number | null
  /** @format double */
  sharpeRatio?: number | null
  /** @format double */
  maxDrawdown?: number | null
  /** @format double */
  annualisedRollingYtdPerformance?: number | null
  /** @format double */
  annualisedTotalPerformance?: number | null
  /** @format double */
  annualisedVolatility?: number | null
}

export type ApiPerformancePeriod =
  | 'Full'
  | 'SixMonth'
  | 'OneYear'
  | 'ThreeYear'
  | 'FiveYear'
  | 'TenYear'

export interface ApiPerformanceResponse {
  period: ApiPerformancePeriod
  /** @format double */
  totalReturn: number | null
  /** @format double */
  ytdReturn: number | null
  /** @format double */
  rollingYtdReturn: number | null
  /** @format double */
  realisedVolatility: number | null
  /** @format double */
  sharpeRatio: number | null
  /** @format double */
  maxDrawdown: number | null
  /** @format double */
  annualisedRollingYtdPerformance: number | null
  /** @format double */
  annualisedTotalPerformance: number | null
  /** @format double */
  annualisedVolatility: number | null
}

export interface ApiPortfolio {
  type: ApiPortfolioType
  rebalancingDefinition: ApiRebalancingDefinition
  targetWeights: ApiAssetWeight[]
  fees?: ApiFee[] | null
  /** @format date-time */
  dateAdded?: string | null
  /** @format double */
  multiplier?: number | null
  taxClassification?: ApiTaxClassification
  disallowedStrategies?: string[] | null
  allowedBusinessUnitIds?: string[] | null
  pendingChange?: ApiPortfolioAuditEvent
}

export interface ApiPortfolioAuditEvent {
  eventType?: PortfolioAuditEventType
  /** @format date-time */
  eventDate?: string
  userName?: string | null
  auditedPortfolioData?: ApiSavedPortfolio
}

export type ApiPortfolioChangeInstruction = ApiInstruction & {
  type: ApiInstructionType
  portfolioId?: string | null
  selfSelectPortfolio?: ApiSelfSelectPortfolio
}

export type ApiPortfolioChangeOperation = ApiOperation & {
  type: ApiOperationType
}

export type ApiPortfolioFeeChangeOperation = ApiOperation & {
  type: ApiOperationType
}

export interface ApiPortfolioInvestment {
  assetId: string
  /** @format double */
  weight: number
}

export type ApiPortfolioManagerCategory = 'None' | 'Cat1' | 'Cat2'

export type ApiPortfolioStatus =
  | 'Active'
  | 'PendingApprovalNew'
  | 'PendingApprovalEdit'
  | 'RejectedNew'
  | 'RejectedEdit'

export type ApiPortfolioStatusFilter = 'All' | 'Active' | 'Inactive'

export type ApiPortfolioType = 'None' | 'ModelPortfolio' | 'SelfSelect' | 'FundOfFunds'

export interface ApiPricingModelConfiguration {
  /** @format int32 */
  gapRiskPricingPaths: number
  /** @format int32 */
  rollingSimulationYears?: number | null
  /** @format int32 */
  maxTermSimulationYears?: number | null
  /** @format double */
  volatility?: number | null
  /** @format int32 */
  rebalanceDays?: number | null
}

export interface ApiProjectionRequest {
  accountId?: string | null
  portfolioInvestment?: ApiPortfolioInvestment[] | null
}

export interface ApiProjectionResponse {
  percentile20UnitisedPriceTimeseries: Factor[]
  percentile50UnitisedPriceTimeseries: Factor[]
  percentile80UnitisedPriceTimeseries: Factor[]
}

export type ApiProtectedAccountClosureOperation = ApiOperation & {
  type: ApiOperationType
  /** @format double */
  completedValue?: number | null
  /** @format double */
  protectedValue: number
  /** @format double */
  gapAmount?: number | null
}

export type ApiProtectedSwitchOutOperation = ApiOperation & {
  type: ApiOperationType
  isFullSwitchOut?: boolean
  /** @format double */
  completedValue?: number | null
  /** @format double */
  protectedValue: number
  /** @format double */
  gapAmount?: number | null
  transferredFees?: ApiTransferredFee[] | null
}

export type ApiProtectedValueChangeInstruction = ApiInstruction & {
  type: ApiInstructionType
  /** @format double */
  value: number
}

export type ApiProtectedWithdrawalOperation = ApiOperation & {
  type: ApiOperationType
  /** @format double */
  completedValue?: number | null
  /** @format double */
  protectedValue: number
  /** @format double */
  gapAmount?: number | null
}

export type ApiProtectionPortfolioChangeInstruction = ApiInstruction & {
  type: ApiInstructionType
  targetWeights: ApiPortfolioInvestment[]
}

export type ApiProtectionPortfolioChangeOperation = ApiOperation & {
  type: ApiOperationType
}

export interface ApiRebalancingDefinition {
  type: ApiRebalancingType
  frequency?: ApiRebalancingFrequency
  /** @format double */
  weightsTolerance?: number | null
}

export type ApiRebalancingFrequency = 'None' | 'Monthly' | 'Quarterly' | 'SemiAnnually' | 'Annually'

export type ApiRebalancingOperation = ApiOperation & {
  type: ApiOperationType
}

export type ApiRebalancingType = 'None' | 'Frequency' | 'Weight' | 'CalendarFrequency'

export interface ApiRecaptchaConfiguration {
  disabled?: boolean
}

export interface ApiReconciliationConfiguration {
  /** @format double */
  assetAbsoluteMagnitudeTolerance?: number | null
  /** @format double */
  overallAbsoluteMagnitudeTolerance?: number | null
  /** @format double */
  activePremiumRelativeTolerance?: number | null
  /** @format double */
  protectedValueRelativeTolerance?: number | null
}

export interface ApiReinvestmentConfirmation {
  /** @format uuid */
  confirmationId: string
  tradingAgent: ApiOrderTradingAgent
  assetId: string
  /** @format double */
  shares: number
  /** @format date-time */
  reinvestmentDate: string
  /** @format date-time */
  exDate: string | null
  referenceNumber: string | null
  /** @format double */
  executedPrice: number | null
  /** @format double */
  value: number | null
  user: string | null
}

export type ApiReinvestmentConfirmationInstruction = ApiInstruction & {
  type: ApiInstructionType
  assetId: string
  /** @format date-time */
  reinvestmentDate: string
  /** @format date-time */
  exDate: string
  /** @format double */
  shares: number
}

export type ApiReinvestmentType = 'ReinvestOnly' | 'ReinvestAndDividend'

export interface ApiRenameFundManagerRequest {
  managementCompanyCode?: string | null
  newName?: string | null
}

export interface ApiRenameFundManagerResult {
  /** @format int32 */
  count?: number
  assetIds?: string[] | null
}

export interface ApiResetAuthenticator {
  /** @format uuid */
  userID: string
}

export interface ApiResult {
  status: ApiResultStatus
  message: string | null
  data: any
}

export type ApiResultStatus = 'Success' | 'Error'

export interface ApiRunningAccount {
  accountId: string
  accountSource: string
  accountName: string
  /** @format date-time */
  dateOpened?: string
  status: ApiAccountRunningStatus
  client?: ApiClient
  businessUnit?: ApiBusinessUnit
  note?: ApiNote
  portfolio?: ApiModelPortfolio | ApiFundOfFundsPortfolio | ApiSelfSelectPortfolio | null
  strategy?:
    | ApiPassThroughStrategy
    | ApiCPPIStrategy
    | ApiTIPPStrategy
    | ApiVolControlStrategy
    | null
  strategyTemplateName?: string | null
  protectionWeights?: ApiPortfolioInvestment[] | null
  tradeDocumentation?: ApiTradeDocumentation[] | null
  currentlyUpdating: boolean
  currentlyApproving: boolean
  currentlyClosing: boolean
}

export interface ApiSaveNewAccountActionResult {
  success?: boolean
  validationErrors?: string[] | null
  newAccountId?: string | null
  updatedAccount?: ApiTradingAccount
}

export interface ApiSavedPortfolio {
  portfolioId: string
  portfolioName?: string | null
  status?: ApiPortfolioStatus
  type: ApiPortfolioType
  rebalancingDefinition: ApiRebalancingDefinition
  targetWeights: ApiAssetWeight[]
  fees?: ApiFee[] | null
  /** @format date-time */
  dateAdded?: string | null
  /** @format double */
  multiplier?: number | null
  taxClassification?: ApiTaxClassification
  disallowedStrategies?: string[] | null
  allowedBusinessUnitIds?: string[] | null
  pendingChange?: ApiPortfolioAuditEvent
}

export interface ApiSchedulingConfiguration {
  isTaskCalculationGraphEnabled: boolean
  calculationGraph?: ApiTaskCalculationGraph
}

export type ApiSegregatedPortfolioAsset = ApiAsset & {
  type: ApiAssetType
  clientId: string
  /** @format date-time */
  startDate: string
}

export type ApiSelfSelectPortfolio = ApiPortfolio & {
  type: ApiPortfolioType
}

export interface ApiSetTwoFactorEnabled {
  userId: string
  enabled: boolean
}

export interface ApiSnapshotBuilderConfiguration {
  /** @format int32 */
  lengthAssetTimeSeries: number
  /** @format int32 */
  lengthCurrencyTimeSeries: number
  /** @format int32 */
  lengthLoanTimeSeries: number
  /** @format int32 */
  lengthAumValueTimeSeries: number
}

export type ApiSource = 'Absa' | 'Dominion'

export interface ApiStrategy {
  type: ApiStrategyType
  /** @format double */
  leverageRatio?: number | null
  fees?: ApiFee[] | null
}

export type ApiStrategyChangeInstruction = ApiInstruction & {
  type: ApiInstructionType
  strategy: ApiPassThroughStrategy | ApiCPPIStrategy | ApiTIPPStrategy | ApiVolControlStrategy
}

export type ApiStrategyChangeOperation = ApiOperation & {
  type: ApiOperationType
}

export interface ApiStrategyTemplate {
  strategyTemplateId: string
  strategyName: string
  strategyType: ApiStrategyType
  protectionAssetId?: string | null
  /** @format int32 */
  sortOrder?: number
  defaultHighWatermarkObservationFrequency?: ApiObservationFrequency
  highWatermarkObservationFrequency?: ApiObservationFrequency
  /** @format double */
  minProtectionLevel?: number | null
  /** @format double */
  maxProtectionLevel?: number | null
  /** @format double */
  defaultProtectionLevel?: number | null
  /** @format double */
  protectionLevel?: number | null
  /** @format double */
  minLeverageRatio?: number | null
  /** @format double */
  maxLeverageRatio?: number | null
  /** @format double */
  defaultLeverageRatio?: number | null
  /** @format double */
  leverageRatio?: number | null
  /** @format double */
  minTargetVolatility?: number | null
  /** @format double */
  maxTargetVolatility?: number | null
  /** @format double */
  defaultTargetVolatility?: number | null
  targetVolatilityMappings?: DecimalDecimalTuple[] | null
  /** @format double */
  volatilityIndexTriggerLevel?: number | null
  /** @format double */
  shortCircuitMaxAllocation?: number | null
  /** @format double */
  shortCircuitReducedMultiplier?: number | null
  /** @format double */
  targetVolatility?: number | null
  /** @format int32 */
  minNumberOfMonthsToTimeToMaturity?: number | null
  /** @format int32 */
  maxNumberOfMonthsToTimeToMaturity?: number | null
}

export type ApiStrategyType = 'PassThrough' | 'TIPP' | 'CPPI' | 'VolControl'

export type ApiSwitchInInstruction = ApiInstruction & {
  type: ApiInstructionType
  originatingAccountId: string
  /** @format double */
  switchAmount: number
  transferredFees?: ApiTransferredFee[] | null
}

export type ApiSwitchInOperation = ApiOperation & {
  type: ApiOperationType
}

export type ApiSwitchOutInstruction = ApiInstruction & {
  type: ApiInstructionType
  targetAccountId: string
  isFullSwitch: boolean
  /** @format double */
  switchAmount?: number | null
}

export type ApiSwitchOutOperation = ApiOperation & {
  type: ApiOperationType
  isFullSwitchOut?: boolean
  /** @format double */
  completedValue?: number | null
  transferredFees?: ApiTransferredFee[] | null
}

export interface ApiSystemTimesConfiguration {
  marketDataOverrideAllowedPostStartTime: ApiTimeWithTimeZone
  marketDataOverrideAllowedPostCutOffTime: ApiTimeWithTimeZone
  justBeforeTheMarketDataSnapshotIsCreated?: ApiTimeWithTimeZone
  justAfterTheMarketDataSnapshotIsCreated?: ApiTimeWithTimeZone
  justBeforeTheFinSwitchOrdersAreDownloaded?: ApiTimeWithTimeZone
  justAfterTheFinSwitchOrdersAreDownloaded?: ApiTimeWithTimeZone
  afterTheFinSwitchOrdersAreProcessed?: ApiTimeWithTimeZone
  justAfterAbsaHasUploadedOrderConfirmations?: ApiTimeWithTimeZone
  afterReportsHaveRun?: ApiTimeWithTimeZone
  afterGapRiskIsReady?: ApiTimeWithTimeZone
}

export type ApiTIPPStrategy = ApiStrategy & {
  type: ApiStrategyType
  /** @format double */
  protectionPercentage?: number | null
  /** @format double */
  targetVolatility?: number | null
  /** @format double */
  volatilityIndexTriggerLevel?: number | null
  /** @format double */
  shortCircuitMaxAllocation?: number | null
  /** @format double */
  shortCircuitReducedMultiplier?: number | null
  highWatermarkObservationFrequency: ApiObservationFrequency
  hasBankGuarantee: boolean
}

export interface ApiTaskCalculationGraph {
  /** @format duration */
  schedulerTimeOut: string
  /** @format duration */
  executorTimeOut?: string
  /** @format duration */
  delayBetweenTaskHouseKeepingManagerRuns?: string
  /** @format duration */
  delayBetweenTaskSchedulerRuns: string
  /** @format duration */
  delayBetweenTaskExecutorRuns: string
  /** @format int32 */
  maximumNumberMissedHeartbeats: number
  /** @format int32 */
  maximumNumberDaysToKeepTaskLogs: number
  taskDefinitions: ApiTaskDefinition[]
}

export interface ApiTaskCompletionDependency {
  taskName: string
  /** @format int32 */
  daysLag: number
}

export interface ApiTaskDefinition {
  taskName: string
  isTaskEnabled: boolean
  taskType: string
  taskTrigger: ApiTaskTriggerCompletion | ApiTaskTriggerPeriodic
  description: string | null
  /** @format duration */
  taskTimeOut: string | null
  taskRetryPolicy: ApiTaskRetryPolicy
  priority: ApiTaskPriority
}

export interface ApiTaskExecution {
  taskName?: string | null
  /** @format uuid */
  taskExecutionId?: string
  taskInstanceKey?: string | null
  scheduleLog?: ApiTaskLog
  startLog?: ApiTaskLog
  endLog?: ApiTaskLog
  /** @format date-time */
  firstUpdateTime?: string
  /** @format date-time */
  lastUpdateTime?: string
  taskState?: ApiTaskState
}

export interface ApiTaskLog {
  logId?: string | null
  taskExecutionId?: string | null
  taskInstanceKey?: string | null
  taskName?: string | null
  taskState?: ApiTaskState
  /** @format date-time */
  logTime?: string
  /** @format date-time */
  valuationCycle?: string
  /** @format date-time */
  valuationSnap?: string
  message?: string | null
}

export type ApiTaskPriority = 'VeryLow' | 'Low' | 'Medium' | 'High' | 'VeryHigh'

export interface ApiTaskRetryPolicy {
  /** @format int32 */
  numberRetries: number
  /** @format duration */
  waitTimeBetweenRetries: string | null
}

export type ApiTaskState = 'Scheduled' | 'Started' | 'Failed' | 'Succeeded'

export interface ApiTaskTrigger {
  type: ApiTaskTriggerType
}

export type ApiTaskTriggerCompletion = ApiTaskTrigger & {
  type: ApiTaskTriggerType
  dependencies: ApiTaskCompletionDependency[]
  completionTriggerType: ApiCompletionTriggerType
}

export type ApiTaskTriggerPeriodic = ApiTaskTrigger & {
  type: ApiTaskTriggerType
  cronExpressions: string[]
  timeZone: string
}

export type ApiTaskTriggerType = 'Completion' | 'Periodic'

export type ApiTaxClassification = 'Yield' | 'Capital'

export interface ApiTenantConfiguration {
  tenantName: string
  tradeConfiguration: ApiTradeConfiguration
  schedulingConfiguration: ApiSchedulingConfiguration
  finSwitchConfiguration: ApiFinSwitchConfiguration
  alphaVantageConfiguration: ApiAlphaVantageConfiguration
  snapshotBuilderConfiguration: ApiSnapshotBuilderConfiguration
  paymentsConfiguration: ApiPaymentsConfiguration
  externalAccountValuationsSourcesConfiguration: ApiExternalAccountValuationsSourcesConfiguration
  frontendConfiguration?: ApiFrontendConfiguration
  marketDataConfiguration?: ApiMarketDataConfiguration
  pricingModelConfiguration?: ApiPricingModelConfiguration
  systemTimesConfiguration?: ApiSystemTimesConfiguration
  alertsConfiguration?: ApiAlertsConfiguration
}

export interface ApiTimeOverrideStatus {
  /** @format date-time */
  valuationCycleOverride: string
  /** @format date-time */
  valuationSnapOverride: string
}

export interface ApiTimeWithTimeZone {
  dailyTime?: string | null
  timeZone?: string | null
}

export interface ApiTradeActivation {
  comments?: string | null
}

export interface ApiTradeApproval {
  comments?: string | null
}

export interface ApiTradeBacktestResponse {
  backtestTimeseries: Factor[]
  tradePerformance: ApiPerformanceResponse
}

export interface ApiTradeConfiguration {
  tradeIdentifier: string
  pipelineDefinitionName: string
  valuationCycleSpecification: ApiValuationCycleSpecification
  valuationCycleTimeZone: string
  /** @format duration */
  newInformationExpiry: string
  /** @format int32 */
  virtualPrecision: number
  /** @format int32 */
  daysToCommitToTrade: number
  /** @format duration */
  valuationCycleExpiry: string
  /** @format duration */
  valuationCycleOffset?: string | null
  /** @format date-time */
  valuationCycleOverride?: string | null
  /** @format date-time */
  valuationSnapOverride?: string | null
  technicalAccountDepositId: string
  pickupDirectory?: string | null
  valuationEnabled?: boolean | null
  /** @format int32 */
  valuationLookbackDays?: number | null
  /** @format int32 */
  numberOfMonteCarloProjectionPaths?: number | null
  cleanupEnabled?: boolean | null
  identifierConfiguration?: ApiIdentifierConfiguration
  noteDefaultConfiguration?: ApiNoteDefaultConfiguration
  assetDefaultConfiguration?: ApiAssetDefaultConfiguration
  instructionsNotRequiringFullApproval?: ApiInstructionType[] | null
  cashInstrumentReferenceRates?: string[] | null
}

export interface ApiTradeDocumentation {
  displayName?: string | null
  fileName?: string | null
  relativeUrl?: string | null
  /** @format double */
  size?: number | null
}

export interface ApiTradeEconomics {
  portfolioOverrideFees?: ApiFee[] | null
  strategyOverrideFees?: ApiFee[] | null
  noteOverrideFees?: ApiFee[] | null
  loanIdOverride?: string | null
  depositIdOverride?: string | null
  noteCounterpartyId?: string | null
}

export interface ApiTradePerformanceCalculation {
  accountId?: string | null
  strategy?:
    | ApiPassThroughStrategy
    | ApiCPPIStrategy
    | ApiTIPPStrategy
    | ApiVolControlStrategy
    | null
  portfolioInvestment?: ApiPortfolioInvestment[] | null
  protectionWeights?: ApiPortfolioInvestment[] | null
  noteId?: string | null
  depositId?: string | null
  loanId?: string | null
}

export interface ApiTradeRejection {
  comments?: string | null
}

export interface ApiTradingAccount {
  /** @format int32 */
  version: number
  accountId: string
  accountName: string
  status: ApiAccountStatus
  /** @format date-time */
  requestedStartDate?: string | null
  /** @format date-time */
  dateOpened?: string | null
  currentAccountState?: ApiAccountState
  pendingAccountState?: ApiAccountBuilderState
  approvalState?: ApiAccountApprovalState
  tradeDocumentation?: ApiTradeDocumentation[] | null
  note: ApiNote
  client: ApiClient
  businessUnit: ApiBusinessUnit
  currency?: string | null
  hasInProgressOperations: boolean
  newAccount?: boolean
  isActionRequiredByCurrentUser: boolean
  canBeRejectedByUser: boolean
  /** @format date-time */
  dateActionIsRequiredBy?: string | null
  isLockedForUpdates: boolean
}

export interface ApiTradingAccountApiPaginationResult {
  /** @format int64 */
  totalDocuments: number
  data: ApiTradingAccount[]
}

export type ApiTradingProviderType = 'FinSwitch' | 'Absa' | 'None'

export type ApiTradingStatus = 'Open' | 'SubscriptionOnly' | 'RedemptionOnly' | 'Closed'

export interface ApiTransferBusinessUnitOwnership {
  fromBusinessUnitId: string
  toBusinessUnitId: string
  password: string
}

export interface ApiTransferBusinessUnitOwnershipResult {
  errors?: string[] | null
  success?: boolean
}

export interface ApiTransferOfUnits {
  assetId?: string | null
  /** @format double */
  units?: number
  /** @format double */
  originalPurchasePrice?: number | null
}

export interface ApiTransferredFee {
  definition: ApiFee
  /** @format double */
  value: number
  /** @format double */
  vatValue: number
}

export interface ApiTwoFactorLoginUser {
  verificationCode: string
  isRecovery: boolean
}

export interface ApiUnapprovedAccount {
  /** @format int32 */
  version?: number | null
  accountId?: string | null
  accountName: string
  /** @format date-time */
  requestedStartDate?: string | null
  noteId: string
  loanId?: string | null
  depositId?: string | null
  zcbInstrumentId?: string | null
  /** @format double */
  investment?: number | null
  transferUnits?: ApiTransferOfUnits[] | null
  strategy?:
    | ApiPassThroughStrategy
    | ApiCPPIStrategy
    | ApiTIPPStrategy
    | ApiVolControlStrategy
    | null
  strategyTemplateId?: string | null
  portfolioId?: string | null
  selfSelectPortfolio?: ApiSelfSelectPortfolio
  protectionPortfolioWeights?: ApiPortfolioInvestment[] | null
  switchRequest?: ApiAccountSwitchRequest
}

export interface ApiUnapprovedAccountUpdate {
  /** @format int32 */
  version?: number | null
  accountId?: string | null
  accountName?: string | null
  noteId?: string | null
  loanId?: string | null
  depositId?: string | null
  zcbInstrumentId?: string | null
  /** @format double */
  depositValue?: number | null
  /** @format double */
  withdrawalValue?: number | null
  /** @format double */
  protectedValue?: number | null
  strategy?:
    | ApiPassThroughStrategy
    | ApiCPPIStrategy
    | ApiTIPPStrategy
    | ApiVolControlStrategy
    | null
  strategyTemplateId?: string | null
  portfolioId?: string | null
  selfSelectPortfolio?: ApiSelfSelectPortfolio
  protectionPortfolioWeights?: ApiPortfolioInvestment[] | null
  switchOut?: ApiSwitchOutInstruction
  switchRequest?: ApiAccountSwitchRequest
}

export interface ApiUpdateAccountActionResult {
  success?: boolean
  validationErrors?: string[] | null
  updatedAccount?: ApiTradingAccount
}

export type ApiValuationCycleSpecification = 'Daily'

export interface ApiValuationModelIdentity {
  modelName: string
  modelVersion: string
}

export interface ApiValuationModelResourceMetadata {
  valuationModelIdentity: string
  isValid: boolean
  modules?: string[] | null
}

export type ApiVariableMultiplier = ApiMultiplierConfiguration & {
  multiplierType: ApiMultiplierType
  /** @format int32 */
  shortTermVolatilityWindow: number
  /** @format int32 */
  longTermVolatilityWindow: number
  /** @format double */
  volatilityTrigger: number
  /** @format double */
  standardMultiplier: number
  /** @format double */
  reducedMultiplier: number
}

export interface ApiVerifyAuthenticator {
  verificationCode: string
}

export type ApiVolControlStrategy = ApiStrategy & {
  type: ApiStrategyType
  /** @format double */
  targetVolatility?: number | null
  /** @format double */
  volatilityIndexTriggerLevel?: number | null
  /** @format double */
  shortCircuitMaxAllocation?: number | null
}

export type ApiWithdrawalInstruction = ApiInstruction & {
  type: ApiInstructionType
  /** @format double */
  requestedValue: number
}

export type ApiWithdrawalOperation = ApiOperation & {
  type: ApiOperationType
  /** @format double */
  completedValue?: number | null
}

export type ApiZcbCurve = ApiCashInstrument & {
  type: ApiCashInstrumentType
}

export interface ApiZcbCurveData {
  zcbInstrumentId?: string | null
  points: ApiCurvePoint[]
}

export interface AssetConcentrationReport {
  valuationCycle: ValuationCycleIdentifier
  valuationSnap: ValuationSnapIdentifier
  reportType: string
  reportVersion?: string | null
  entries?: AssetConcentrationReportEntry[] | null
  metadata?: DocumentMetadata
}

export interface AssetConcentrationReportEntry {
  assetId?: string | null
  assetName?: string | null
  assetClass?: string | null
  assetCurrency?: string | null
  fundManager?: string | null
  /** @format double */
  amountInvestedWithGapRisk?: number
  /** @format double */
  amountInvestedWithoutGapRisk?: number
  /** @format double */
  amountInvestedTotal?: number
  /** @format double */
  aum?: number | null
  currency?: string | null
  /** @format double */
  totalInFlightSellOrdersAmount?: number | null
}

export interface AssetDefaultConfiguration {
  fees?: Fee[] | null
  assetClasses?: string[] | null
  currencies?: string[] | null
}

export type AssetProtectionClassification = 'Performance' | 'Protection'

export interface AuditLog {
  type?: EventType
  metadata?: DocumentMetadata
}

export interface BasicApiResult {
  validationErrors?: string[] | null
  success?: boolean
  errorMessage?: string | null
}

export interface BlockHeader {
  type: BlockType
  /** @format int32 */
  version: number
  /** @format byte */
  parentHash: string
  /** @format byte */
  ommerHash?: string | null
  /** @format byte */
  stateRoot: string
  /** @format int32 */
  number: number
  /** @format byte */
  nonce: string
}

export type BlockType = 'Default' | 'Genesis' | 'Termination' | 'Invalid'

export interface CashInstrumentTransaction {
  instrumentId: string
  instrumentType: CashInstrumentType
  /** @format date-time */
  maturityDate?: string | null
  transactionId: string
  /** @format date-time */
  createdDate: string
  direction: OrderLegDirection
  currency: string
  /** @format double */
  value: number
  /** @format double */
  shares: number
  /** @format double */
  price?: number | null
}

export type CashInstrumentType = 'Loan' | 'Deposit' | 'ZcbCurve'

/**
 * Changes the note tax classification.
 */
export interface ChangeNoteApiTaxClassification {
  noteId?: string | null
  newTaxClassification?: ApiTaxClassification
}

export interface ChangePasswordCommand {
  userName: string
  oldPassword: string
  newPassword: string
}

export type ClientType = 'Institutional' | 'Retail'

export type ComponentChangedState = 'Changed' | 'Unchanged'

export type ConfigurationType =
  | 'AlphaAdvantage'
  | 'ExternalValuationSources'
  | 'FinSwitch'
  | 'FrontEnd'
  | 'MarketData'
  | 'Payments'
  | 'PricingModel'
  | 'Recaptcha'
  | 'Reconciliation'
  | 'Scheduling'
  | 'Security'
  | 'SnapshotBuilding'
  | 'SystemTimes'
  | 'Trade'
  | 'Alerts'

export interface ContractNote {
  /** @format date-time */
  issuedDate: string
  issuer: ContractNoteIssuer
  reference?: string | null
  /** @format date-time */
  executedDate: string
  /** @format double */
  executedPrice: number
  /** @format double */
  executedFxRate?: number | null
  /** @format double */
  confirmedValue: number
  /** @format double */
  confirmedShares: number
}

export type ContractNoteIssuer = 'Market' | 'Contractual'

export interface CurrencyHolding {
  currency?: string
  depositReferenceId?: string | null
  /** @format double */
  balance?: number | null
  /** @format double */
  units?: number | null
  /** @format double */
  value?: number | null
}

export interface CustomAssetScenarioConfiguration {
  singleAssetLadder?: number[] | null
  otherAssetsLadder?: number[] | null
  metadata?: DocumentMetadata
}

export interface CustomAssetScenarioResult {
  values?: Record<string, ScenarioVector[] | null>
  valuationCycle?: ValuationCycleIdentifier
  scenarioName?: string | null
  /** @format date-time */
  creationTime?: string
  metadata?: DocumentMetadata
}

export interface CustomFundManagerScenarioConfiguration {
  singleFundManagerLadder?: number[] | null
  otherFundManagersLadder?: number[] | null
  metadata?: DocumentMetadata
}

export interface CustomFundManagerScenarioResult {
  values?: Record<string, ScenarioVector[] | null>
  valuationCycle?: ValuationCycleIdentifier
  scenarioName?: string | null
  /** @format date-time */
  creationTime?: string
  metadata?: DocumentMetadata
}

export interface DealingState {
  changedState?: ComponentChangedState
  operations?: Operation[] | null
  orphanedContractNotes?: ExternalContractNote[] | null
  overriddenContractNotes?: ExternalContractNote[] | null
  displacedContractNotes?: ContractNote[] | null
}

export interface DecimalDecimalTuple {
  /** @format double */
  item1?: number
  /** @format double */
  item2?: number
}

export interface DiagnosticsInformation {
  tenants?: TenancyEntry[] | null
  loadedAssemblies?: string[] | null
}

export type DividendProcessing = 'Reinvested' | 'Paid'

export type DocumentDataType = 'Json' | 'Bson' | 'Xml'

export interface DocumentMetadata {
  /** @format uuid */
  documentId: string
  /** @format uuid */
  batchId: string
  /** @format date-time */
  created: string
  /** @format date-time */
  modified: string
  /** @format int32 */
  version?: number
  state?: DocumentState
}

export type DocumentState = 'Ok' | 'Revoked' | 'Draft'

export type ErrorReason = 'None' | 'UnableToCompleteInstruction'

export type ErrorSeverity = 'Warning' | 'Error' | 'Fatal'

export type ErrorSource = 'Instruction' | 'MarketData' | 'Valuation' | 'Other'

export type ErrorVisibility = 'Private' | 'Public'

export type EventType =
  | 'DbAdd'
  | 'DbUpdate'
  | 'DbReplace'
  | 'DbDelete'
  | 'PasswordResetRequested'
  | 'PasswordReset'
  | 'ChangePassword'
  | 'UserDetailsChanged'
  | 'EmailChanged'
  | 'UserCreated'
  | 'UserConfirmed'
  | 'UserDisabled'
  | 'UserLockedOut'
  | 'PasswordChanged'
  | 'IncorrectPasswordUsed'
  | 'UserLogInUnsuccessful'
  | 'UserPartiallyLoggedIn'
  | 'UserLoggedIn'
  | 'UserLoggedOut'
  | 'TwoFactorSetup'
  | 'SaveTrade'
  | 'UpdateTrade'
  | 'SubmitTrade'
  | 'ApproveTrade'
  | 'CommitToTrade'
  | 'ActivateTrade'
  | 'RejectTrade'
  | 'ExpireTrade'
  | 'DeleteTrade'
  | 'RevertDraft'
  | 'RemoveDraft'
  | 'DeactivateUser'
  | 'ActivateUser'
  | 'AddExchangeFile'
  | 'CloseTrade'

export type ExchangeFileType =
  | 'TechnicalAccountSharesTransactions'
  | 'TechnicalAccountCurrencyTransactions'
  | 'OrdersScheduledAggregated'
  | 'OrdersScheduledCounterparty'
  | 'OrdersScheduledSegregatedPortfolioAggregated'
  | 'OrdersScheduledSegregatedPortfolioCounterparty'
  | 'OrdersScheduledFinSwitch'
  | 'OrdersConfirmedAggregated'
  | 'OrdersConfirmedCounterparty'
  | 'OrdersConfirmedFinSwitch'
  | 'OrdersConfirmedSegregatedPortfolioAggregated'
  | 'OrdersConfirmedSegregatedPortfolioCounterparty'
  | 'OrdersLoanScheduledAggregated'
  | 'OrdersLoanScheduledCounterparty'
  | 'OrdersDepositScheduledAggregated'
  | 'OrdersDepositScheduledCounterparty'
  | 'OrdersZcbScheduledAggregated'
  | 'OrdersZcbScheduledCounterparty'
  | 'OrdersDistributionsAggregated'
  | 'OrdersDistributionsCounterparty'
  | 'AssetHoldingsCounterpartyAggregated'
  | 'AssetHoldingsAggregated'
  | 'TechnicalAccountSharesTransactionsHoldings'
  | 'TechnicalAccountCurrencyTransactionsHoldings'
  | 'CurrencyHoldingsAggregated'
  | 'CurrencyHoldingsCounterpartyAggregated'
  | 'LoanHoldingsAggregated'
  | 'LoanHoldingsCounterpartyAggregated'
  | 'PricesMutualFunds'
  | 'PricesSegregatedPortfolios'
  | 'PricesFinSwitch'
  | 'PricesHistoricalFinSwitch'
  | 'FxRatesAlphaVantage'
  | 'DistributionsFinSwitch'
  | 'Curve'
  | 'PricesCurrencyDeposits'
  | 'PricesLoans'
  | 'PricesCurrencyDepositsExport'
  | 'PricesLoansExport'
  | 'PricesIndexes'
  | 'PaymentsFundSettlement'
  | 'PaymentsAccountDeduction'
  | 'PaymentsBankDeduction'
  | 'PaymentsCounterpartyFundDistribution'
  | 'PaymentsTotalFundDistribution'
  | 'PaymentsFeeAccrual'
  | 'PaymentsFeeAccrualGapPremiumExternal'
  | 'PaymentsGapPremium'
  | 'PaymentsGapAmount'
  | 'AssetGapRisk'
  | 'ClientDocumentation'
  | 'ExternalAccountValuations'
  | 'FundsDetails'
  | 'FundsConstituents'
  | 'FundConstituents'
  | 'RiskReport'
  | 'HoldingsReport'
  | 'PaymentsSegregatedPortfolioSettlement'
  | 'OrdersConfirmedSegregatedPortfolioAbsa'
  | 'NoteHoldings'
  | 'NoteStatements'
  | 'NoteTaxReportCapitalGainCsvFull'
  | 'NoteTaxReportCapitalGainJsonFull'
  | 'NoteTaxReportIncomeCsvFull'
  | 'NoteTaxReportIncomeJsonFull'
  | 'NoteTaxReportCapitalGainCsvInterim'
  | 'NoteTaxReportCapitalGainJsonInterim'
  | 'NoteTaxReportIncomeCsvInterim'
  | 'NoteTaxReportIncomeJsonInterim'
  | 'NoteTaxReportCapitalGainCsvYTD'
  | 'NoteTaxReportCapitalGainJsonYTD'
  | 'NoteTaxReportIncomeCsvYTD'
  | 'NoteTaxReportIncomeJsonYTD'
  | 'UnitTransfersFullyAggregated'
  | 'UnitTransfersCounterpartyAggregated'
  | 'OrdersCorrectionFundAggregated'
  | 'OrdersCorrectionFundCounterparty'
  | 'OrdersNoteCounterpartyTransfer'
  | 'FeesCsvReport'
  | 'PortfolioFactSheet'

export interface ExternalContractNote {
  orderId: string
  orderBatchId: string
  assetId: string
  /** @format date-time */
  issuedDate: string
  issuer: ContractNoteIssuer
  reference?: string | null
  /** @format date-time */
  executedDate: string
  /** @format double */
  executedPrice: number
  /** @format double */
  executedFxRate?: number | null
  /** @format double */
  confirmedValue: number
  /** @format double */
  confirmedShares: number
}

export interface Factor {
  /** @format date-time */
  timestamp?: string
  /** @format double */
  value?: number
}

export interface Fee {
  /** @format uuid */
  feeId: string
  feeType: FeeType
  /** @format double */
  feeRate: number
  feeDeductionFrequency: FeeDeductionFrequency
  isVATApplicable: boolean
  feeBasis: FeeBasis
  feeDayCount: FeeDayCount
  counterPartyId: string
}

export type FeeBasis = 'TotalTradeValue' | 'RiskyAssetExposure' | 'LoanAmount'

export type FeeDayCount = 'Act_365' | 'Act_Act' | 'Act_360' | 'Thirty_360' | 'Thirty_365'

export type FeeDeductionFrequency =
  | 'None'
  | 'Quarterly'
  | 'Monthly'
  | 'Annually'
  | 'UpFront'
  | 'Exit'

export interface FeeDeductionState {
  /** @format date-time */
  startDate: string
  /** @format date-time */
  nextDeductionDate: string
  /** @format int32 */
  counter: number
}

export interface FeeEconomics {
  /** @format double */
  accruedFee?: number | null
  states?: FeeState[] | null
}

export type FeeLevel = 'Note' | 'Strategy' | 'Portfolio'

export interface FeeState {
  /** @format double */
  accruedFee: number
  /** @format double */
  accrual?: number | null
  /** @format double */
  vatAccruedFee?: number | null
  /** @format double */
  vatAccrual?: number | null
  /** @format date-time */
  accrualPaymentDate?: string | null
  deductionState?: FeeDeductionState
  definition: Fee
  level: FeeLevel
  isActive: boolean
  /** @format uuid */
  feeInstanceId?: string | null
}

export type FeeType =
  | 'GapProtectionPremium'
  | 'LoanFee'
  | 'DistributionFee'
  | 'StrategyFee'
  | 'PlatformFee'
  | 'PortfolioManagementFee'
  | 'NoteFee'
  | 'ExitFee'
  | 'TransactionFee'
  | 'Delta1PremiumFee'
  | 'RiskControlledPremiumFee'
  | 'HedgingPremiumFee'
  | 'OngoingPremium'
  | 'LifeCompanyFee'
  | 'AdviceFee'
  | 'DiscretionaryFundManagementFee'
  | 'StrategyAdviceFee'

export interface FundManagerDrawdownScenarioConfiguration {
  ladder?: number[] | null
  metadata?: DocumentMetadata
}

export interface FundManagerDrawdownScenarioResult {
  values?: Record<string, ScenarioVector[] | null>
  valuationCycle?: ValuationCycleIdentifier
  scenarioName?: string | null
  /** @format date-time */
  creationTime?: string
  metadata?: DocumentMetadata
}

export interface FundManagerLadderScenarioConfiguration {
  ladder?: number[] | null
  metadata?: DocumentMetadata
}

export interface FundManagerLadderScenarioResult {
  values?: Record<string, ScenarioPoint[] | null>
  valuationCycle?: ValuationCycleIdentifier
  scenarioName?: string | null
  /** @format date-time */
  creationTime?: string
  metadata?: DocumentMetadata
}

export interface GetAccountsFilters {
  ids?: string[] | null
  currencyCode?: string | null
  clientType?: ClientType
  accountRunningStatus?: AccountRunningStatus
  portfolioType?: PortfolioType
  strategyType?: StrategyType
  isNoteCollateralized?: boolean | null
}

/**
 * Gets the note data after instructions.
 */
export interface GetApiNoteDataAfterInstructions {
  /** The instructions to apply. */
  apiInstructions?:
    | (
        | ApiNewAccountInstruction
        | ApiDepositInstruction
        | ApiPortfolioChangeInstruction
        | ApiAccountClosureInstruction
        | ApiWithdrawalInstruction
        | ApiProtectedValueChangeInstruction
        | ApiStrategyChangeInstruction
        | ApiProtectionPortfolioChangeInstruction
        | ApiAncillaryAssetsChangeInstruction
        | ApiSwitchInInstruction
        | ApiSwitchOutInstruction
        | ApiDividendInstruction
        | ApiReinvestmentConfirmationInstruction
        | ApiNoteChangeInstruction
      )[]
    | null
  /** The account identifier. */
  accountId?: string | null
}

/**
 * A request for the QHub.Api.Contracts.Instructions.ApiNoteData tax classification after new account.
 */
export interface GetApiNoteTaxClassificationAfterNewAccount {
  /** @format int32 */
  version?: number | null
  accountId?: string | null
  accountName: string
  /** @format date-time */
  requestedStartDate?: string | null
  noteId: string
  loanId?: string | null
  depositId?: string | null
  zcbInstrumentId?: string | null
  /** @format double */
  investment?: number | null
  transferUnits?: ApiTransferOfUnits[] | null
  strategy?:
    | ApiPassThroughStrategy
    | ApiCPPIStrategy
    | ApiTIPPStrategy
    | ApiVolControlStrategy
    | null
  strategyTemplateId?: string | null
  portfolioId?: string | null
  selfSelectPortfolio?: ApiSelfSelectPortfolio
  protectionPortfolioWeights?: ApiPortfolioInvestment[] | null
  switchRequest?: ApiAccountSwitchRequest
}

export interface GetUserNameCommand {
  firstName: string
  lastName: string
}

export interface GetUserNameResponse {
  userName: string
}

export interface HighWatermarkObservationStatus {
  /** @format date-time */
  startDate?: string
  /** @format date-time */
  nextObservation?: string
  /** @format int32 */
  observationCounter?: number
}

export interface HoldingReconciliationReport {
  valuationCycle: ValuationCycleIdentifier
  valuationSnap: ValuationSnapIdentifier
  reportType: string
  reportVersion?: string | null
  entries?: HoldingReconciliationReportEntry[] | null
  metadata?: DocumentMetadata
}

export interface HoldingReconciliationReportEntry {
  assetName?: string | null
  assetId?: string | null
  executionAgent?: string | null
  /** @format double */
  internalHoldings?: number
  /** @format double */
  executionAgentHoldings?: number
  /** @format double */
  lastAssetPrice?: number | null
}

export interface HoldingsAndTransferBalancesReconciliation {
  entries?: HoldingsAndTransferBalancesReconciliationEntry[] | null
}

export interface HoldingsAndTransferBalancesReconciliationEntry {
  assetId?: string | null
  assetName?: string | null
  fundCode?: string | null
  /** @format double */
  internalHoldings?: number
  /** @format double */
  executionAgentHoldings?: number
  /** @format double */
  availableTransferBalance?: number
}

export interface IdentifierConfiguration {
  accountSettings?: IdentifierSetting
  portfolioSettings?: IdentifierSetting
  noteSettings?: IdentifierSetting
}

export interface IdentifierSetting {
  idPrefix?: string | null
  /** @format int32 */
  idPaddingLength?: number
  /** @format int32 */
  nextId?: number
  /** @format date-time */
  lastUpdateTime?: string
}

export interface IdentityError {
  code?: string | null
  description?: string | null
}

/**
 * A mediator command to request import of the specified tenant from the specified name.
 */
export interface ImportTenantCommand {
  /** The tenant name. */
  tenant?: string | null
  /** The import name. */
  name?: string | null
  /** The base path for imports. */
  basePath?: string | null
  /** Set to true to first drop the collection before import. */
  drop?: boolean
}

export interface IndexDescription {
  collectionName?: string | null
  indexName?: string | null
  isUnique?: boolean
  keys?: string | null
  partialFilterExpression?: string | null
}

export type IndexStatus = 'None' | 'Ready' | 'Expired'

export type InformationSource =
  | 'Custodian'
  | 'Distributor'
  | 'HedgingCounterparty'
  | 'Internal'
  | 'PreviousState'

export interface InitialAccountState {
  lastValuationCycle?: ValuationCycleIdentifier
  portfolioState?: PortfolioState
  portfolioDefinition?: PortfolioDefinition
  strategyDefinition?: StrategyDefinition
  note?: NoteEconomics
  ancillaryAssetsDefinition?: AncillaryAssetsDefinition
  economics?: AccountEconomics
  fees?: FeeEconomics
  protection?: ProtectionEconomics
  rebalancingStatus?: RebalancingStatus
  operations?: Operation[] | null
  lastActivity?: ValuationCycleIdentifier
}

export interface Instruction {
  type: InstructionType
  instructionId: string
  valuationCycle: ValuationCycleIdentifier
}

export interface InstructionRevocationFilter {
  valuationCycle?: ValuationCycleIdentifier
  types?: InstructionType[] | null
  instructionId?: string | null
  externalId?: string | null
}

export type InstructionType =
  | 'Unknown'
  | 'NewAccount'
  | 'Deposit'
  | 'Dividend'
  | 'Withdrawal'
  | 'AccountClosure'
  | 'ExternalTransfer'
  | 'StrategyChange'
  | 'PortfolioChange'
  | 'ProtectedValueChange'
  | 'ProtectionReset'
  | 'ProtectionPortfolioChange'
  | 'NoteChange'
  | 'AncillaryAssetsChange'
  | 'ReinvestmentConfirmation'
  | 'SwitchIn'
  | 'SwitchOut'
  | 'OrderCorrection'
  | 'PortfolioFeeChange'

export interface InvestmentHolding {
  assetId: string
  /** @format double */
  shares: number
  /** @format double */
  value?: number | null
  /** @format double */
  accruedFeeShares?: number | null
  /** @format double */
  syntheticShares?: number | null
  /** @format double */
  syntheticValue?: number | null
  /** @format double */
  ringfencedShares?: number | null
  /** @format double */
  varianceShort?: number | null
  /** @format double */
  varianceLong?: number | null
}

export interface InvestmentShares {
  assetId: string
  /** @format double */
  shares: number
  /** @format double */
  value?: number | null
}

export interface InvestmentWeight {
  assetId: string
  /** @format double */
  weight: number
}

export interface JsonBlob {
  json: string
}

export interface JsonNode {
  options?: JsonNodeOptions
  parent?: JsonNode
  root?: JsonNode
}

export interface JsonNodeOptions {
  propertyNameCaseInsensitive?: boolean
}

export interface LoanHolding {
  currency?: string
  loanId?: string | null
  /** @format double */
  units?: number
  /** @format double */
  value?: number | null
}

export interface MaxDrawdownReport {
  valuationCycle: ValuationCycleIdentifier
  valuationSnap: ValuationSnapIdentifier
  reportType: string
  reportVersion?: string | null
  entries?: {
    MutualFund?: MaxDrawdownReportEntry[]
    Equity?: MaxDrawdownReportEntry[]
    SegregatedPortfolio?: MaxDrawdownReportEntry[]
    ModelPortfolio?: MaxDrawdownReportEntry[]
    FundManager?: MaxDrawdownReportEntry[]
  } | null
  metadata?: DocumentMetadata
}

export interface MaxDrawdownReportEntry {
  itemId?: string | null
  itemName?: string | null
  itemType?: MaxDrawdownReportEntryType
  /** @format double */
  maxDrawdown1D?: number | null
  /** @format double */
  maxDrawdown3D?: number | null
  /** @format double */
  maxDrawdown1W?: number | null
  /** @format double */
  maxDrawdown1M?: number | null
  /** @format double */
  maxDrawdown1Y?: number | null
  isTherePosition?: boolean
  /** @format double */
  gapPutStrike?: number | null
  fundManager?: string | null
  protectionClassification?: AssetProtectionClassification
}

export type MaxDrawdownReportEntryType =
  | 'MutualFund'
  | 'Equity'
  | 'SegregatedPortfolio'
  | 'ModelPortfolio'
  | 'FundManager'

export interface NewUserCommand {
  userName: string
  password: string
  roles: string[]
  email: string
  firstName: string
  lastName: string
  organisation: ApiOrganisation
  requiresConfirmation: boolean
  requiresTwoFactor: boolean
  portfolioManagerCategory?: ApiPortfolioManagerCategory
}

export interface NoteDefaultConfiguration {
  counterPartyIds?: string[] | null
}

export interface NoteEconomics {
  noteId: string
  dividendProcessing: DividendProcessing
}

export interface Operation {
  type: OperationType
  operationId: string
  /** @format date-time */
  generatedDate: string
  /** @format date-time */
  targetDate?: string | null
  state: OperationState
  information?: string | null
  orders?: OrderBatch[] | null
  cashTransactions?: CashInstrumentTransaction[] | null
}

export type OperationState = 'Queued' | 'Processing' | 'Completed' | 'Rejected'

export type OperationType =
  | 'Unknown'
  | 'Deposit'
  | 'PortfolioChange'
  | 'PortfolioSubstitution'
  | 'FeeRateChange'
  | 'FeeDeduction'
  | 'AccruedFee'
  | 'Dividend'
  | 'ReinvestmentConfirmation'
  | 'SyntheticTransfer'
  | 'Withdrawal'
  | 'AccountClosure'
  | 'StrategyChange'
  | 'ExternalTransfer'
  | 'Rebalancing'
  | 'Redemption'
  | 'Defeasance'
  | 'ReconciliationTransfer'
  | 'TriggeredFeeDeduction'
  | 'ActivePremiumReconciliation'
  | 'ProtectedValueReconciliation'
  | 'TargetVolatilityChange'
  | 'ProtectedValueChange'
  | 'ProtectionPercentageChange'
  | 'ProtectionReset'
  | 'ProtectedFeeDeduction'
  | 'ProtectedWithdrawal'
  | 'ProtectedAccountClosure'
  | 'ProtectionPortfolioChange'
  | 'GapPayment'
  | 'NoteChange'
  | 'AncillaryAssetsChange'
  | 'SwitchIn'
  | 'SwitchOut'
  | 'ProtectedSwitchOut'
  | 'OrderCorrection'
  | 'PortfolioFeeChange'

export interface OrderBatch {
  orderBatchId: string
  /** @format date-time */
  createdDate: string
  aggregateState: OrderBatchAggregateState
  /** @format date-time */
  alignmentDate?: string | null
  legs: OrderLeg[]
}

export type OrderBatchAggregateState = 'New' | 'InProgress' | 'Complete'

export interface OrderLeg {
  assetId: string
  state: OrderLegState
  depositReferenceId?: string | null
  loanReferenceId?: string | null
  /** @format double */
  cashValue?: number | null
  /** @format double */
  loanValue?: number | null
  /** @format double */
  cashShares?: number | null
  /** @format double */
  loanShares?: number | null
  /** @format double */
  cashCostUnits?: number | null
  /** @format double */
  loanCostUnits?: number | null
  orderId: string
  /** @format date-time */
  createdDate: string
  direction: OrderLegDirection
  currency?: string | null
  /** @format double */
  value?: number | null
  /** @format double */
  shares?: number | null
  /** @format double */
  estimatedPrice?: number
  /** @format date-time */
  placedValuationCycle?: string | null
  /** @format date-time */
  requestedExecutionDate?: string | null
  /** @format date-time */
  requestedEffectiveDate?: string | null
  /** @format date-time */
  expectedExecutionDate?: string | null
  contractNote?: ContractNote
}

export type OrderLegDirection = 'Subscription' | 'Redemption'

export type OrderLegState =
  | 'New'
  | 'Requested'
  | 'Placed'
  | 'Confirmed'
  | 'Settled'
  | 'Rejected'
  | 'Cancelled'

export type PortfolioAuditEventType = 'NewSubmission' | 'EditSubmission' | 'Approval' | 'Rejection'

export interface PortfolioDefinition {
  type: PortfolioType
  /** @format date-time */
  dateAdded?: string | null
  allowedBusinessUnitIds?: string[] | null
  /** @format double */
  multiplier?: number | null
  rebalancingDefinition: RebalancingDefinition
  targetWeights: InvestmentWeight[]
  fees?: Fee[] | null
}

export interface PortfolioState {
  holdings?: InvestmentHolding[] | null
  currencyHoldings?: CurrencyHolding[] | null
  loanHoldings?: LoanHolding[] | null
  zcbHoldings?: ZcbHolding[] | null
}

export type PortfolioType = 'None' | 'ModelPortfolio' | 'SelfSelect' | 'FundOfFunds'

export interface ProtectionAdjustment {
  /** @format date-time */
  issuedDate: string
  /** @format date-time */
  riskNormalizationDate?: string | null
  reasons?: AdjustmentReason[] | null
  ongoingReasons?: AdjustmentOngoingReason[] | null
}

export interface ProtectionEconomics {
  status: AccountProtectedStatus
  /** @format double */
  protectedValue?: number
  /** @format double */
  bondFloor?: number | null
  /** @format double */
  impliedMultiplier?: number | null
  /** @format double */
  highWatermark?: number | null
  highWatermarkObservationStatus?: HighWatermarkObservationStatus
  /** @format double */
  gapAmount?: number | null
  /** @format double */
  gapAmountDue?: number | null
  /** @format double */
  defeasedAccountValue?: number | null
  adjustments?: ProtectionAdjustment[] | null
  /** @format double */
  targetMultiplier?: number | null
  targetProtectionWeights?: InvestmentWeight[] | null
}

export interface RebalancingDefinition {
  type: RebalancingType
  frequency?: RebalancingFrequency
  /** @format double */
  weightsTolerance?: number | null
}

export type RebalancingFrequency = 'None' | 'Monthly' | 'Quarterly' | 'SemiAnnually' | 'Annually'

export interface RebalancingStatus {
  rebalancingDefinition: RebalancingDefinition
  /** @format date-time */
  startDate?: string | null
  /** @format date-time */
  nextRebalancing?: string | null
  /** @format int32 */
  rebalancingCounter: number
}

export type RebalancingType = 'None' | 'Frequency' | 'Weight' | 'CalendarFrequency'

export interface ReconciledAccountState {
  portfolioState?: PortfolioState
  portfolioDefinition?: PortfolioDefinition
  strategyDefinition?: StrategyDefinition
  economics?: AccountEconomics
  note?: NoteEconomics
  ancillaryAssetsDefinition?: AncillaryAssetsDefinition
  fees?: FeeEconomics
  protection?: ProtectionEconomics
  rebalancingStatus?: RebalancingStatus
  operations?: Operation[] | null
  lastActivity?: ValuationCycleIdentifier
}

export interface ReconciliationConfiguration {
  type?: ConfigurationType
  /** @format double */
  assetAbsoluteMagnitudeTolerance?: number | null
  /** @format double */
  overallAbsoluteMagnitudeTolerance?: number | null
  /** @format double */
  activePremiumRelativeTolerance?: number | null
  /** @format double */
  protectedValueRelativeTolerance?: number | null
  metadata?: DocumentMetadata
}

export type ReconciliationResult = 'Accepted' | 'NotRequired' | 'Deferred' | 'Rejected'

export type ReconciliationWarning = 'None' | 'SignificantDifference'

export interface RemoveUserFromRoleCommand {
  userName: string
  role: string
}

export interface ReplayAction {
  type: ReplayActionType
  actionId: string
  /** @format date-time */
  generatedDate: string
  /** @format date-time */
  valuationDate: string
}

export type ReplayActionType = 'ManualAdjustment' | 'CancelOperation'

export type ReplayAudience = 'All' | 'ValuationOnly'

export interface ReplayInstruction {
  valuationCycle: ValuationCycleIdentifier
  method: ReplayInstructionMethod
  audience?: ReplayAudience
  waitMethodology?: ReplayWaitMethodology
  reconciliationMethodology?: ReplayReconciliationMethodology
  state: ReplayOperationState
  reason?: string | null
  revocationFilter?: InstructionRevocationFilter
  replacementInstruction?: Instruction
}

export type ReplayInstructionMethod = 'Inject' | 'Replace' | 'Revoke'

export type ReplayOperationState = 'New' | 'Deferred' | 'Applied' | 'Rejected'

export type ReplayReconciliationMethodology = 'Default' | 'RaiseOrders' | 'SuppressOrders'

export interface ReplayReconciliationOperation {
  accountId: string
  operation?: Operation
}

export type ReplayWaitMethodology =
  | 'Default'
  | 'WaitUntilAfterActivity'
  | 'Immediate'
  | 'RejectIfActivity'

export interface ReplayedAccountState {
  portfolioState?: PortfolioState
  portfolioDefinition?: PortfolioDefinition
  strategyDefinition?: StrategyDefinition
  note?: NoteEconomics
  ancillaryAssetsDefinition?: AncillaryAssetsDefinition
  economics?: AccountEconomics
  fees?: FeeEconomics
  protection?: ProtectionEconomics
  rebalancingStatus?: RebalancingStatus
  operations?: Operation[] | null
  lastActivity?: ValuationCycleIdentifier
}

export type ReportingStatus = 'None' | 'Ready' | 'Expired'

export interface ResetPasswordCommand {
  /** @format uuid */
  userId: string
  token: string
  password: string
}

export interface ScenarioCoordinate {
  /** @format double */
  bump: number
  label?: string | null
}

export interface ScenarioPoint {
  coordinate?: ScenarioCoordinate
  /** @format double */
  value?: number
}

export interface ScenarioVector {
  coordinate?: ScenarioCoordinate
  points?: ScenarioPoint[] | null
}

export interface SchedulingConfiguration {
  type?: ConfigurationType
  isTaskCalculationGraphEnabled?: boolean
  calculationGraph?: TaskCalculationGraph
  metadata?: DocumentMetadata
}

export interface ServiceInformation {
  currentUser?: string | null
  publicUri?: string | null
  webHostEnvironment?: string | null
  smtpHost?: string | null
  /** @format date-time */
  systemTime?: string
  applicationTime?: TenantTimeInformation[] | null
  serverName?: string | null
  assemblyVersion?: string | null
  fileVersion?: string | null
  informationalVersion?: string | null
}

export interface SingleAssetDrawdownScenarioConfiguration {
  ladder?: number[] | null
  metadata?: DocumentMetadata
}

export interface SingleAssetDrawdownScenarioResult {
  values?: Record<string, ScenarioVector[] | null>
  valuationCycle?: ValuationCycleIdentifier
  scenarioName?: string | null
  /** @format date-time */
  creationTime?: string
  metadata?: DocumentMetadata
}

export interface SingleAssetLadderScenarioConfiguration {
  ladder?: number[] | null
  metadata?: DocumentMetadata
}

export interface SingleAssetLadderScenarioResult {
  values?: Record<string, ScenarioPoint[] | null>
  valuationCycle?: ValuationCycleIdentifier
  scenarioName?: string | null
  /** @format date-time */
  creationTime?: string
  metadata?: DocumentMetadata
}

/**
 * A model for SSO configuration.
 */
export interface SsoConfig {
  /** Gets the SSO button text. */
  buttonText: string
  /** Gets the UI app/client identifier. */
  clientId: string
  /** Gets the authentication tenant/domain identifier. */
  tenantId: string
}

export interface StrategyDefinition {
  type: StrategyType
  /** @format double */
  leverageRatio?: number | null
  fees?: Fee[] | null
}

export type StrategyType = 'PassThrough' | 'TIPP' | 'CPPI' | 'VolControl'

/**
 * Controller action result allowing streamed writing to response body
 */
export type StreamedResult = object

export interface TaskCalculationGraph {
  /** @format duration */
  schedulerTimeOut?: string
  /** @format duration */
  executorTimeOut?: string
  /** @format duration */
  delayBetweenTaskHouseKeepingManagerRuns?: string
  /** @format duration */
  delayBetweenTaskSchedulerRuns?: string
  /** @format duration */
  delayBetweenTaskExecutorRuns?: string
  /** @format int32 */
  maximumNumberMissedHeartbeats?: number
  /** @format int32 */
  maximumNumberDaysToKeepTaskLogs?: number
  taskDefinitions?: TaskDefinition[] | null
}

export interface TaskDefinition {
  taskName: string
  isTaskEnabled: boolean
  taskType: string
  taskTrigger: TaskTrigger
  description: string | null
  /** @format duration */
  taskTimeOut: string | null
  taskRetryPolicy: TaskRetryPolicy
  priority: TaskPriority
}

export type TaskPriority = 'VeryLow' | 'Low' | 'Medium' | 'High' | 'VeryHigh'

export interface TaskRetryPolicy {
  /** @format int32 */
  numberRetries: number
  /** @format duration */
  waitTimeBetweenRetries: string | null
}

export interface TaskTrigger {
  type: TaskTriggerType
}

export type TaskTriggerType = 'Completion' | 'Periodic'

export type TaxClassification = 'Yield' | 'Capital'

export interface TenancyEntry {
  tenantName: string
  error?: string | null
  valuationModels?: ApiValuationModelResourceMetadata[] | null
}

export interface TenantTimeInformation {
  tenantName?: string | null
  /** @format date-time */
  currentSnap?: string
  /** @format date-time */
  currentCycle?: string
}

/**
 * A record to use for an example/test result.
 */
export interface TestResult {
  /** The name. */
  name?: string | null
  /**
   * The value.
   * @format int32
   */
  value?: number
  /** The message. */
  message?: string | null
  /** True if successful */
  success?: boolean
}

export interface TradeConfiguration {
  type?: ConfigurationType
  tradeIdentifier?: string | null
  pipelineDefinitionName?: string | null
  valuationCycleSpecification?: ValuationCycleSpecification
  valuationCycleTimeZone?: string | null
  /** @format duration */
  newInformationExpiry?: string | null
  /** @format int32 */
  virtualPrecision?: number
  /** @format int32 */
  daysToCommitToTrade?: number
  /** @format duration */
  valuationCycleExpiry?: string
  /** @format duration */
  valuationCycleOffset?: string | null
  /** @format date-time */
  valuationCycleOverride?: string | null
  /** @format date-time */
  valuationSnapOverride?: string | null
  technicalAccountDepositId?: string | null
  pickupDirectory?: string | null
  valuationEnabled?: boolean | null
  /** @format int32 */
  valuationLookbackDays?: number | null
  /** @format int32 */
  numberOfMonteCarloProjectionPaths?: number | null
  cleanupEnabled?: boolean | null
  identifierConfiguration?: IdentifierConfiguration
  noteDefaultConfiguration?: NoteDefaultConfiguration
  assetDefaultConfiguration?: AssetDefaultConfiguration
  instructionsNotRequiringFullApproval?: InstructionType[] | null
  cashInstrumentReferenceRates?: string[] | null
  metadata?: DocumentMetadata
}

export interface TransferOperation {
  shares: InvestmentShares[]
  type: OperationType
  operationId: string
  /** @format date-time */
  generatedDate: string
  /** @format date-time */
  targetDate?: string | null
  state: OperationState
  information?: string | null
  orders?: OrderBatch[] | null
  cashTransactions?: CashInstrumentTransaction[] | null
}

export interface UserInformation {
  /** @format uuid */
  userId: string
  firstName: string
  lastName: string
  userName: string
  email: string
  inactive: boolean
  isLockedOut: boolean
  status: UserStatus
  /** @format date-time */
  lastLoginDate?: string | null
  roles: string[]
  organisation: ApiOrganisation
  clients: ApiClient[]
  emailConfirmed: boolean
  twoFactorEnabled: boolean
  dfms: ApiDfm[]
  portfolioManagerCategory?: ApiPortfolioManagerCategory
}

export interface UserInformationBasic {
  /** @format uuid */
  userId: string
  userName: string
  firstName: string
  lastName: string
  email: string
  inactive: boolean
  status: UserStatus
  /** @format date-time */
  lastLoginDate?: string | null
  roles: string[]
  portfolioManagerCategory?: ApiPortfolioManagerCategory
}

export interface UserInformationBasicDfm {
  /** @format uuid */
  userId: string
  userName: string
  firstName: string
  lastName: string
  email: string
  inactive: boolean
  status: UserStatus
  /** @format date-time */
  lastLoginDate?: string | null
  roles: string[]
  portfolioManagerCategory?: ApiPortfolioManagerCategory
}

export type UserStatus = 'Active' | 'Pending' | 'Locked' | 'Inactive' | 'Closed'

export interface ValuationCycleExpiryIdentifier {
  /** @format date-time */
  expires: string
}

export interface ValuationCycleIdentifier {
  /** @format date-time */
  juncture: string
}

export type ValuationCycleSpecification = 'Daily'

export interface ValuationDiagnosticsState {
  dataType: DocumentDataType
  data: string
}

export interface ValuationError {
  source: ErrorSource
  reason?: ErrorReason
  severity: ErrorSeverity
  visibility?: ErrorVisibility
  referenceIdentifier?: string | null
  message: string
}

export interface ValuationIndexStatus {
  valuationSnap: ValuationSnapIdentifier
  status: IndexStatus
  metadata?: DocumentMetadata
}

export interface ValuationInput {
  type: ValuationInputType
  /** @format date-time */
  submitted: string
  processingDate?: ValuationCycleIdentifier
  source: InformationSource
  error?: string | null
  origin?: JsonBlob
  originResponse?: JsonBlob
}

export type ValuationInputType =
  | 'Invalid'
  | 'MarketData'
  | 'MarketDataModifications'
  | 'ModelParameters'
  | 'ExternalView'
  | 'ReplayDefinition'
  | 'Instructions'
  | 'ContractNotes'

export interface ValuationModelIdentity {
  modelName: string
  modelVersion: string
}

export interface ValuationOutput {
  type: ValuationOutputType
}

export type ValuationOutputType = 'Generic'

export interface ValuationReportingStatus {
  valuationSnap: ValuationSnapIdentifier
  reportType: string
  status: ReportingStatus
  metadata?: DocumentMetadata
}

export type ValuationResultState = 'Accepted' | 'Overridden' | 'Faulted' | 'Rejected'

export type ValuationResultType = 'Primary' | 'Secondary' | 'Replayed'

export interface ValuationSnapIdentifier {
  /** @format date-time */
  snapDate: string
}

export interface ValuedAccountState {
  resultType: ValuationResultType
  /** @format date-time */
  timeStamp: string
  valuationModel: ValuationModelIdentity
  resultState: ValuationResultState
  portfolioState?: PortfolioState
  portfolioDefinition?: PortfolioDefinition
  strategyDefinition?: StrategyDefinition
  note?: NoteEconomics
  ancillaryAssetsDefinition?: AncillaryAssetsDefinition
  economics: AccountEconomics
  fees?: FeeEconomics
  protection?: ProtectionEconomics
  rebalancingStatus?: RebalancingStatus
  operations?: Operation[] | null
  lastActivity?: ValuationCycleIdentifier
  errors?: ValuationError[] | null
  diagnosticState?: ValuationDiagnosticsState
}

export interface ZcbHolding {
  instrumentId?: string | null
  /** @format double */
  units?: number
  /** @format double */
  value?: number | null
  /** @format double */
  bidPrice?: number | null
  /** @format double */
  askPrice?: number | null
}

export type QueryParamsType = Record<string | number, any>
export type ResponseFormat = keyof Omit<Body, 'body' | 'bodyUsed'>

export interface FullRequestParams extends Omit<RequestInit, 'body'> {
  /** set parameter to `true` for call `securityWorker` for this request */
  secure?: boolean
  /** request path */
  path: string
  /** content type of request body */
  type?: ContentType
  /** query params */
  query?: QueryParamsType
  /** format of response (i.e. response.json() -> format: "json") */
  format?: ResponseFormat
  /** request body */
  body?: unknown
  /** base url */
  baseUrl?: string
  /** request cancellation token */
  cancelToken?: CancelToken
}

export type RequestParams = Omit<FullRequestParams, 'body' | 'method' | 'query' | 'path'>

export interface ApiConfig<SecurityDataType = unknown> {
  baseUrl?: string
  baseApiParams?: Omit<RequestParams, 'baseUrl' | 'cancelToken' | 'signal'>
  securityWorker?: (
    securityData: SecurityDataType | null
  ) => Promise<RequestParams | void> | RequestParams | void
  customFetch?: typeof fetch
}

export interface HttpResponse<D extends unknown, E extends unknown = unknown> extends Response {
  data: D
  error: E
}

type CancelToken = Symbol | string | number

export enum ContentType {
  Json = 'application/json',
  FormData = 'multipart/form-data',
  UrlEncoded = 'application/x-www-form-urlencoded'
}

export class HttpClient<SecurityDataType = unknown> {
  public baseUrl: string = ''
  private securityData: SecurityDataType | null = null
  private securityWorker?: ApiConfig<SecurityDataType>['securityWorker']
  private abortControllers = new Map<CancelToken, AbortController>()
  private customFetch = (...fetchParams: Parameters<typeof fetch>) => fetch(...fetchParams)

  private baseApiParams: RequestParams = {
    credentials: 'same-origin',
    headers: {},
    redirect: 'follow',
    referrerPolicy: 'no-referrer'
  }

  constructor(apiConfig: ApiConfig<SecurityDataType> = {}) {
    Object.assign(this, apiConfig)
  }

  public setSecurityData = (data: SecurityDataType | null) => {
    this.securityData = data
  }

  protected encodeQueryParam(key: string, value: any) {
    const encodedKey = encodeURIComponent(key)
    return `${encodedKey}=${encodeURIComponent(typeof value === 'number' ? value : `${value}`)}`
  }

  protected addQueryParam(query: QueryParamsType, key: string) {
    return this.encodeQueryParam(key, query[key])
  }

  protected addArrayQueryParam(query: QueryParamsType, key: string) {
    const value = query[key]
    return value.map((v: any) => this.encodeQueryParam(key, v)).join('&')
  }

  protected toQueryString(rawQuery?: QueryParamsType): string {
    const query = rawQuery || {}
    const keys = Object.keys(query).filter(key => 'undefined' !== typeof query[key])
    return keys
      .map(key =>
        Array.isArray(query[key])
          ? this.addArrayQueryParam(query, key)
          : this.addQueryParam(query, key)
      )
      .join('&')
  }

  protected addQueryParams(rawQuery?: QueryParamsType): string {
    const queryString = this.toQueryString(rawQuery)
    return queryString ? `?${queryString}` : ''
  }

  private contentFormatters: Record<ContentType, (input: any) => any> = {
    [ContentType.Json]: (input: any) =>
      input !== null && (typeof input === 'object' || typeof input === 'string')
        ? JSON.stringify(input)
        : input,
    [ContentType.FormData]: (input: any) =>
      Object.keys(input || {}).reduce((formData, key) => {
        const property = input[key]
        formData.append(
          key,
          property instanceof Blob
            ? property
            : typeof property === 'object' && property !== null
            ? JSON.stringify(property)
            : `${property}`
        )
        return formData
      }, new FormData()),
    [ContentType.UrlEncoded]: (input: any) => this.toQueryString(input)
  }

  protected mergeRequestParams(params1: RequestParams, params2?: RequestParams): RequestParams {
    return {
      ...this.baseApiParams,
      ...params1,
      ...(params2 || {}),
      headers: {
        ...(this.baseApiParams.headers || {}),
        ...(params1.headers || {}),
        ...((params2 && params2.headers) || {})
      }
    }
  }

  protected createAbortSignal = (cancelToken: CancelToken): AbortSignal | undefined => {
    if (this.abortControllers.has(cancelToken)) {
      const abortController = this.abortControllers.get(cancelToken)
      if (abortController) {
        return abortController.signal
      }
      return void 0
    }

    const abortController = new AbortController()
    this.abortControllers.set(cancelToken, abortController)
    return abortController.signal
  }

  public abortRequest = (cancelToken: CancelToken) => {
    const abortController = this.abortControllers.get(cancelToken)

    if (abortController) {
      abortController.abort()
      this.abortControllers.delete(cancelToken)
    }
  }

  public request = async <T = any, E = any>({
    body,
    secure,
    path,
    type,
    query,
    format,
    baseUrl,
    cancelToken,
    ...params
  }: FullRequestParams): Promise<HttpResponse<T, E>> => {
    const secureParams =
      ((typeof secure === 'boolean' ? secure : this.baseApiParams.secure) &&
        this.securityWorker &&
        (await this.securityWorker(this.securityData))) ||
      {}
    const requestParams = this.mergeRequestParams(params, secureParams)
    const queryString = query && this.toQueryString(query)
    const payloadFormatter = this.contentFormatters[type || ContentType.Json]
    const responseFormat = format || requestParams.format

    return this.customFetch(
      `${baseUrl || this.baseUrl || ''}${path}${queryString ? `?${queryString}` : ''}`,
      {
        ...requestParams,
        headers: {
          ...(requestParams.headers || {}),
          ...(type && type !== ContentType.FormData ? { 'Content-Type': type } : {})
        },
        signal: cancelToken ? this.createAbortSignal(cancelToken) : requestParams.signal,
        body: typeof body === 'undefined' || body === null ? null : payloadFormatter(body)
      }
    ).then(async response => {
      const r = response as HttpResponse<T, E>
      r.data = null as unknown as T
      r.error = null as unknown as E

      const data = !responseFormat
        ? r
        : await response[responseFormat]()
            .then(data => {
              if (r.ok) {
                r.data = data
              } else {
                r.error = data
              }
              return r
            })
            .catch(e => {
              r.error = e
              return r
            })

      if (cancelToken) {
        this.abortControllers.delete(cancelToken)
      }

      if (!response.ok) throw data
      return data
    })
  }
}

/**
 * @title Frontend Web API
 * @version v1
 */
export class Api<SecurityDataType extends unknown> extends HttpClient<SecurityDataType> {
  tenant = {
    /**
     * No description
     *
     * @tags Account
     * @name SaveCreate
     * @summary Save draft account.
     * @request POST:/{tenant}/account/save
     */
    saveCreate: (tenant: string, data: ApiUnapprovedAccount, params: RequestParams = {}) =>
      this.request<ApiSaveNewAccountActionResult, string[]>({
        path: `/${tenant}/account/save`,
        method: 'POST',
        body: data,
        type: ContentType.Json,
        format: 'json',
        ...params
      }),

    /**
     * No description
     *
     * @tags Account
     * @name UpdateSaveCreate
     * @summary Save draft account update.
     * @request POST:/{tenant}/account/update/save
     */
    updateSaveCreate: (
      tenant: string,
      data: ApiUnapprovedAccountUpdate,
      params: RequestParams = {}
    ) =>
      this.request<ApiUpdateAccountActionResult, string>({
        path: `/${tenant}/account/update/save`,
        method: 'POST',
        body: data,
        type: ContentType.Json,
        format: 'json',
        ...params
      }),

    /**
     * No description
     *
     * @tags Account
     * @name SubmitCreate
     * @summary Submit a new draft account for approval.
     * @request POST:/{tenant}/account/submit/{accountIdentifier}
     */
    submitCreate: (accountIdentifier: string, tenant: string, params: RequestParams = {}) =>
      this.request<void, string>({
        path: `/${tenant}/account/submit/${accountIdentifier}`,
        method: 'POST',
        ...params
      }),

    /**
     * No description
     *
     * @tags Account
     * @name ApproveEconomicsCreate
     * @summary Approve the economics of the account.
     * @request POST:/{tenant}/account/approve/economics/{accountIdentifier}
     */
    approveEconomicsCreate: (
      accountIdentifier: string,
      tenant: string,
      data: ApiTradeEconomics,
      params: RequestParams = {}
    ) =>
      this.request<void, string>({
        path: `/${tenant}/account/approve/economics/${accountIdentifier}`,
        method: 'POST',
        body: data,
        type: ContentType.Json,
        ...params
      }),

    /**
     * No description
     *
     * @tags Account
     * @name ApproveCreate
     * @summary Approve an account.
     * @request POST:/{tenant}/account/approve/{accountIdentifier}
     */
    approveCreate: (
      accountIdentifier: string,
      tenant: string,
      data: ApiTradeApproval,
      params: RequestParams = {}
    ) =>
      this.request<void, any>({
        path: `/${tenant}/account/approve/${accountIdentifier}`,
        method: 'POST',
        body: data,
        type: ContentType.Json,
        ...params
      }),

    /**
     * No description
     *
     * @tags Account
     * @name RejectCreate
     * @summary Reject an account.
     * @request POST:/{tenant}/account/reject/{accountIdentifier}
     */
    rejectCreate: (
      accountIdentifier: string,
      tenant: string,
      data: ApiTradeRejection,
      params: RequestParams = {}
    ) =>
      this.request<void, any>({
        path: `/${tenant}/account/reject/${accountIdentifier}`,
        method: 'POST',
        body: data,
        type: ContentType.Json,
        ...params
      }),

    /**
     * No description
     *
     * @tags Account
     * @name CommitCreate
     * @summary Commit to an account.
     * @request POST:/{tenant}/account/commit/{accountIdentifier}
     */
    commitCreate: (accountIdentifier: string, tenant: string, params: RequestParams = {}) =>
      this.request<void, any>({
        path: `/${tenant}/account/commit/${accountIdentifier}`,
        method: 'POST',
        ...params
      }),

    /**
     * No description
     *
     * @tags Account
     * @name CommitClientCreate
     * @summary Client commit to an account.
     * @request POST:/{tenant}/account/commit/client/{accountIdentifier}
     */
    commitClientCreate: (accountIdentifier: string, tenant: string, params: RequestParams = {}) =>
      this.request<void, any>({
        path: `/${tenant}/account/commit/client/${accountIdentifier}`,
        method: 'POST',
        ...params
      }),

    /**
     * No description
     *
     * @tags Account
     * @name ConfirmCreate
     * @summary Confirm settlement to an account.
     * @request POST:/{tenant}/account/confirm/{accountIdentifier}
     */
    confirmCreate: (
      accountIdentifier: string,
      tenant: string,
      data: ApiConfirmSettlementRequest,
      params: RequestParams = {}
    ) =>
      this.request<void, any>({
        path: `/${tenant}/account/confirm/${accountIdentifier}`,
        method: 'POST',
        body: data,
        type: ContentType.Json,
        ...params
      }),

    /**
     * No description
     *
     * @tags Account
     * @name ActivateCreate
     * @summary Activate account.
     * @request POST:/{tenant}/account/activate/{accountIdentifier}
     */
    activateCreate: (
      accountIdentifier: string,
      tenant: string,
      data: ApiTradeActivation,
      params: RequestParams = {}
    ) =>
      this.request<void, any>({
        path: `/${tenant}/account/activate/${accountIdentifier}`,
        method: 'POST',
        body: data,
        type: ContentType.Json,
        ...params
      }),

    /**
     * No description
     *
     * @tags Account
     * @name CloseCreate
     * @summary Close account.
     * @request POST:/{tenant}/account/close/{accountIdentifier}
     */
    closeCreate: (accountIdentifier: string, tenant: string, params: RequestParams = {}) =>
      this.request<void, any>({
        path: `/${tenant}/account/close/${accountIdentifier}`,
        method: 'POST',
        ...params
      }),

    /**
     * No description
     *
     * @tags Account
     * @name DeleteCreate
     * @summary Delete account.
     * @request POST:/{tenant}/account/delete/{accountIdentifier}
     */
    deleteCreate: (accountIdentifier: string, tenant: string, params: RequestParams = {}) =>
      this.request<void, any>({
        path: `/${tenant}/account/delete/${accountIdentifier}`,
        method: 'POST',
        ...params
      }),

    /**
     * No description
     *
     * @tags Account
     * @name DeleterevertdraftCreate
     * @summary Delete or revert a draft account.
     * @request POST:/{tenant}/account/deleterevertdraft/{accountIdentifier}
     */
    deleterevertdraftCreate: (
      accountIdentifier: string,
      tenant: string,
      params: RequestParams = {}
    ) =>
      this.request<void, any>({
        path: `/${tenant}/account/deleterevertdraft/${accountIdentifier}`,
        method: 'POST',
        ...params
      }),

    /**
     * No description
     *
     * @tags Account
     * @name AccountDetail
     * @summary Get an account by identifier.
     * @request GET:/{tenant}/account/{accountSource}/{accountIdentifier}
     */
    accountDetail: (
      accountSource: string,
      accountIdentifier: string,
      tenant: string,
      params: RequestParams = {}
    ) =>
      this.request<ApiAccountHistoryReportWithNoteData, any>({
        path: `/${tenant}/account/${accountSource}/${accountIdentifier}`,
        method: 'GET',
        format: 'json',
        ...params
      }),

    /**
     * No description
     *
     * @tags Account
     * @name SummaryDetail
     * @summary Get an account by identifier.
     * @request GET:/{tenant}/account/summary/{accountSource}/{accountIdentifier}
     */
    summaryDetail: (
      accountSource: string,
      accountIdentifier: string,
      tenant: string,
      params: RequestParams = {}
    ) =>
      this.request<ApiAccountHistoryReport, any>({
        path: `/${tenant}/account/summary/${accountSource}/${accountIdentifier}`,
        method: 'GET',
        format: 'json',
        ...params
      }),

    /**
     * No description
     *
     * @tags Account
     * @name AccountDetail2
     * @summary Get accounts.
     * @request GET:/{tenant}/account
     * @originalName accountDetail
     * @duplicate
     */
    accountDetail2: (
      tenant: string,
      query?: {
        NoteIds?: string
        CurrencyCode?: string
        ClientType?: ApiClientType
        AccountRunningStatus?: ApiAccountRunningStatus
        PortfolioType?: ApiPortfolioType
        StrategyType?: ApiStrategyType
        IsNoteCollateralized?: boolean
      },
      params: RequestParams = {}
    ) =>
      this.request<ApiDashboard, any>({
        path: `/${tenant}/account`,
        method: 'GET',
        query: query,
        format: 'json',
        ...params
      }),

    /**
     * No description
     *
     * @tags Account
     * @name DashboardDetail
     * @summary Get the dashboard.
     * @request GET:/{tenant}/account/dashboard
     */
    dashboardDetail: (
      tenant: string,
      query?: {
        SortField?: string
        SortAscending?: boolean
        CurrencyCode?: string
        ClientType?: ApiClientType
        NoteIds?: string
        IsNoteCollateralized?: boolean
      },
      params: RequestParams = {}
    ) =>
      this.request<ApiAccountDashboard, any>({
        path: `/${tenant}/account/dashboard`,
        method: 'GET',
        query: query,
        format: 'json',
        ...params
      }),

    /**
     * No description
     *
     * @tags Account
     * @name RunningDetail
     * @summary Get running accounts.
     * @request GET:/{tenant}/account/running
     */
    runningDetail: (
      tenant: string,
      query?: {
        Clients?: string
        ClientsList?: string[]
        BusinessUnits?: string
        BusinessUnitsList?: string[]
        Notes?: string
        NotesList?: string[]
        Currencies?: string
        CurrenciesList?: string[]
        Portfolios?: string
        PortfoliosList?: string[]
        Strategies?: string
        StrategiesList?: string[]
        /** @format int32 */
        PageSize?: number
        /** @format int32 */
        PageNumber?: number
        SortField?: string
        SortAscending?: boolean
      },
      params: RequestParams = {}
    ) =>
      this.request<ApiAccountDashboardAccountApiPaginationResult, any>({
        path: `/${tenant}/account/running`,
        method: 'GET',
        query: query,
        format: 'json',
        ...params
      }),

    /**
     * No description
     *
     * @tags Account
     * @name ExportCreate
     * @summary Gets the running trade export in csv format.
     * @request POST:/{tenant}/account/export
     */
    exportCreate: (tenant: string, data: GetAccountsFilters, params: RequestParams = {}) =>
      this.request<File, any>({
        path: `/${tenant}/account/export`,
        method: 'POST',
        body: data,
        type: ContentType.Json,
        format: 'json',
        ...params
      }),

    /**
     * No description
     *
     * @tags Account
     * @name AccrualsExportCreate
     * @summary Gets the running trades accruals export in csv format.
     * @request POST:/{tenant}/account/accruals/export
     */
    accrualsExportCreate: (
      tenant: string,
      data: ApiGetAccountAccrualsFilter,
      params: RequestParams = {}
    ) =>
      this.request<File, any>({
        path: `/${tenant}/account/accruals/export`,
        method: 'POST',
        body: data,
        type: ContentType.Json,
        format: 'json',
        ...params
      }),

    /**
     * No description
     *
     * @tags Account
     * @name ExportJsonCreate
     * @summary Get running trade export in json format.
     * @request POST:/{tenant}/account/export/json
     */
    exportJsonCreate: (tenant: string, data: GetAccountsFilters, params: RequestParams = {}) =>
      this.request<AccountExportReport[], any>({
        path: `/${tenant}/account/export/json`,
        method: 'POST',
        body: data,
        type: ContentType.Json,
        format: 'json',
        ...params
      }),

    /**
     * No description
     *
     * @tags Account
     * @name InprogressDetail
     * @summary Gets the in progress trades.
     * @request GET:/{tenant}/account/inprogress
     */
    inprogressDetail: (
      tenant: string,
      query?: {
        WildcardString?: string
        Status?: string
        FilterNewAccounts?: boolean
        /** @format int32 */
        PageSize?: number
        /** @format int32 */
        PageNumber?: number
        SortField?: string
        SortAscending?: boolean
      },
      params: RequestParams = {}
    ) =>
      this.request<ApiTradingAccountApiPaginationResult, any>({
        path: `/${tenant}/account/inprogress`,
        method: 'GET',
        query: query,
        format: 'json',
        ...params
      }),

    /**
     * No description
     *
     * @tags Account
     * @name InprogressDetail2
     * @summary Gets the in progress account.
     * @request GET:/{tenant}/account/inprogress/{accountIdentifier}
     * @originalName inprogressDetail
     * @duplicate
     */
    inprogressDetail2: (accountIdentifier: string, tenant: string, params: RequestParams = {}) =>
      this.request<ApiTradingAccount, any>({
        path: `/${tenant}/account/inprogress/${accountIdentifier}`,
        method: 'GET',
        format: 'json',
        ...params
      }),

    /**
     * No description
     *
     * @tags Account
     * @name FirstaccountdateDetail
     * @summary Return the date when the first account started.
     * @request GET:/{tenant}/account/firstaccountdate
     */
    firstaccountdateDetail: (tenant: string, params: RequestParams = {}) =>
      this.request<string, any>({
        path: `/${tenant}/account/firstaccountdate`,
        method: 'GET',
        format: 'json',
        ...params
      }),

    /**
     * No description
     *
     * @tags Account
     * @name AllaccountdetailsDetail
     * @summary Get all accounts for which we have an account report snapshot on a certain day.
     * @request GET:/{tenant}/account/allaccountdetails
     */
    allaccountdetailsDetail: (tenant: string, params: RequestParams = {}) =>
      this.request<ApiAccountDetails[], any>({
        path: `/${tenant}/account/allaccountdetails`,
        method: 'GET',
        format: 'json',
        ...params
      }),

    /**
     * No description
     *
     * @tags Account
     * @name SnapshotsRangeDetail
     * @summary Get an accounts report snapshot.
     * @request GET:/{tenant}/account/snapshots/range/{accountSource}/{accountId}/{startDate}/{endDate}
     */
    snapshotsRangeDetail: (
      accountSource: string,
      accountId: string,
      startDate: string,
      endDate: string,
      tenant: string,
      params: RequestParams = {}
    ) =>
      this.request<ApiAccountSnapshot[], any>({
        path: `/${tenant}/account/snapshots/range/${accountSource}/${accountId}/${startDate}/${endDate}`,
        method: 'GET',
        format: 'json',
        ...params
      }),

    /**
     * No description
     *
     * @tags Account
     * @name SnapshotsDetail
     * @summary Get an accounts report snapshot.
     * @request GET:/{tenant}/account/snapshots/{date}
     */
    snapshotsDetail: (date: string, tenant: string, params: RequestParams = {}) =>
      this.request<ApiAccountSnapshot[], any>({
        path: `/${tenant}/account/snapshots/${date}`,
        method: 'GET',
        format: 'json',
        ...params
      }),

    /**
     * No description
     *
     * @tags Account
     * @name SnapshotsLatestDetail
     * @summary Get the latest account snapshot.
     * @request GET:/{tenant}/account/snapshots/{accountSource}/{accountIdentifier}/latest
     */
    snapshotsLatestDetail: (
      accountSource: string,
      accountIdentifier: string,
      tenant: string,
      params: RequestParams = {}
    ) =>
      this.request<ApiAccountSnapshot, any>({
        path: `/${tenant}/account/snapshots/${accountSource}/${accountIdentifier}/latest`,
        method: 'GET',
        format: 'json',
        ...params
      }),

    /**
     * No description
     *
     * @tags Account
     * @name StaticDetail
     * @summary Get all accounts.
     * @request GET:/{tenant}/account/static
     */
    staticDetail: (tenant: string, params: RequestParams = {}) =>
      this.request<ApiTradingAccount[], any>({
        path: `/${tenant}/account/static`,
        method: 'GET',
        format: 'json',
        ...params
      }),

    /**
     * No description
     *
     * @tags Account
     * @name StaticDetail2
     * @summary Get trade static by account name.
     * @request GET:/{tenant}/account/static/{accountName}
     * @originalName staticDetail
     * @duplicate
     */
    staticDetail2: (accountName: string, tenant: string, params: RequestParams = {}) =>
      this.request<ApiTradingAccount, any>({
        path: `/${tenant}/account/static/${accountName}`,
        method: 'GET',
        format: 'json',
        ...params
      }),

    /**
     * No description
     *
     * @tags Account
     * @name PricesCreate
     * @summary Gets the note prices adjusted for the specified unit transfers.
     * @request POST:/{tenant}/account/prices/{accountId}
     */
    pricesCreate: (
      accountId: string,
      tenant: string,
      data: ApiTransferOfUnits[],
      params: RequestParams = {}
    ) =>
      this.request<ApiNotePrices, any>({
        path: `/${tenant}/account/prices/${accountId}`,
        method: 'POST',
        body: data,
        type: ContentType.Json,
        format: 'json',
        ...params
      }),

    /**
     * No description
     *
     * @tags Account
     * @name LocksRemoveCreate
     * @summary Remove a lock on an account
     * @request POST:/{tenant}/account/locks/{accountId}/{lockType}/remove
     */
    locksRemoveCreate: (
      accountId: string,
      lockType: ApiAccountLockType,
      tenant: string,
      params: RequestParams = {}
    ) =>
      this.request<void, any>({
        path: `/${tenant}/account/locks/${accountId}/${lockType}/remove`,
        method: 'POST',
        ...params
      }),

    /**
     * No description
     *
     * @tags Account
     * @name ExportPendingfeesDetail
     * @summary Get the pending fees report.
     * @request GET:/{tenant}/account/export/pendingfees
     */
    exportPendingfeesDetail: (tenant: string, params: RequestParams = {}) =>
      this.request<string, any>({
        path: `/${tenant}/account/export/pendingfees`,
        method: 'GET',
        format: 'json',
        ...params
      }),

    /**
     * No description
     *
     * @tags AccountValuation
     * @name AccountDetail3
     * @summary Get the most recent valuation block for a particular account on a particular valuation cycle.
     * @request GET:/{tenant}/v/{date}/account/{accountId}
     * @originalName accountDetail
     * @duplicate
     */
    accountDetail3: (date: string, accountId: string, tenant: string, params: RequestParams = {}) =>
      this.request<AccountValuationBlock[], any>({
        path: `/${tenant}/v/${date}/account/${accountId}`,
        method: 'GET',
        format: 'json',
        ...params
      }),

    /**
     * No description
     *
     * @tags AccountValuation
     * @name HistoryDetail
     * @summary Get the history of an account.
     * @request GET:/{tenant}/v/{accountId}/history
     */
    historyDetail: (accountId: string, tenant: string, params: RequestParams = {}) =>
      this.request<AccountValuationBlock[], any>({
        path: `/${tenant}/v/${accountId}/history`,
        method: 'GET',
        format: 'json',
        ...params
      }),

    /**
     * No description
     *
     * @tags AccountValuation
     * @name DatesDetail
     * @summary Get the history of an account.
     * @request GET:/{tenant}/v/dates
     */
    datesDetail: (tenant: string, params: RequestParams = {}) =>
      this.request<string[], any>({
        path: `/${tenant}/v/dates`,
        method: 'GET',
        format: 'json',
        ...params
      }),

    /**
     * No description
     *
     * @tags Asset
     * @name AssetDetail
     * @summary Gets all assets.
     * @request GET:/{tenant}/asset
     */
    assetDetail: (tenant: string, params: RequestParams = {}) =>
      this.request<(ApiMutualFundAsset | ApiSegregatedPortfolioAsset)[], any>({
        path: `/${tenant}/asset`,
        method: 'GET',
        format: 'json',
        ...params
      }),

    /**
     * No description
     *
     * @tags Asset
     * @name ListDetail
     * @summary Gets the asset list.
     * @request GET:/{tenant}/asset/list
     */
    listDetail: (
      tenant: string,
      query?: {
        WildcardString?: string
        /** @format int32 */
        PageSize?: number
        /** @format int32 */
        PageNumber?: number
        SortField?: string
        SortAscending?: boolean
      },
      params: RequestParams = {}
    ) =>
      this.request<ApiAssetDetailsApiPaginationResult, any>({
        path: `/${tenant}/asset/list`,
        method: 'GET',
        query: query,
        format: 'json',
        ...params
      }),

    /**
     * No description
     *
     * @tags Asset
     * @name DetailsDetail
     * @summary Gets the asset details.
     * @request GET:/{tenant}/asset/{assetId}/details
     */
    detailsDetail: (assetId: string, tenant: string, params: RequestParams = {}) =>
      this.request<ApiAssetDetails, any>({
        path: `/${tenant}/asset/${assetId}/details`,
        method: 'GET',
        format: 'json',
        ...params
      }),

    /**
     * No description
     *
     * @tags Asset
     * @name HistoryDetail2
     * @summary Gets the asset price history.
     * @request GET:/{tenant}/asset/{assetId}/history
     * @originalName historyDetail
     * @duplicate
     */
    historyDetail2: (assetId: string, tenant: string, params: RequestParams = {}) =>
      this.request<ApiAssetPriceWithHistory, any>({
        path: `/${tenant}/asset/${assetId}/history`,
        method: 'GET',
        format: 'json',
        ...params
      }),

    /**
     * No description
     *
     * @tags Asset
     * @name MutualfundsDetail
     * @summary Gets all mutual fund assets.
     * @request GET:/{tenant}/asset/mutualfunds
     */
    mutualfundsDetail: (tenant: string, params: RequestParams = {}) =>
      this.request<(ApiMutualFundAsset | ApiSegregatedPortfolioAsset)[], any>({
        path: `/${tenant}/asset/mutualfunds`,
        method: 'GET',
        format: 'json',
        ...params
      }),

    /**
     * No description
     *
     * @tags Asset
     * @name SegregatedportfoliosDetail
     * @summary Gets all segregated portfolio assets.
     * @request GET:/{tenant}/asset/segregatedportfolios
     */
    segregatedportfoliosDetail: (tenant: string, params: RequestParams = {}) =>
      this.request<ApiSegregatedPortfolioAsset[], any>({
        path: `/${tenant}/asset/segregatedportfolios`,
        method: 'GET',
        format: 'json',
        ...params
      }),

    /**
     * No description
     *
     * @tags Asset
     * @name AssetDetail2
     * @summary Gets the asset by identifier.
     * @request GET:/{tenant}/asset/{assetId}
     * @originalName assetDetail
     * @duplicate
     */
    assetDetail2: (assetId: string, tenant: string, params: RequestParams = {}) =>
      this.request<ApiMutualFundAsset | ApiSegregatedPortfolioAsset, any>({
        path: `/${tenant}/asset/${assetId}`,
        method: 'GET',
        format: 'json',
        ...params
      }),

    /**
     * No description
     *
     * @tags Asset
     * @name MutualfundCreate
     * @summary Adds the mutual fund asset.
     * @request POST:/{tenant}/asset/mutualfund
     */
    mutualfundCreate: (tenant: string, data: ApiMutualFundAsset, params: RequestParams = {}) =>
      this.request<void, any>({
        path: `/${tenant}/asset/mutualfund`,
        method: 'POST',
        body: data,
        type: ContentType.Json,
        ...params
      }),

    /**
     * No description
     *
     * @tags Asset
     * @name MutualfundUpdate
     * @summary Updates the mutual fund asset.
     * @request PUT:/{tenant}/asset/mutualfund
     */
    mutualfundUpdate: (tenant: string, data: ApiMutualFundAsset, params: RequestParams = {}) =>
      this.request<void, any>({
        path: `/${tenant}/asset/mutualfund`,
        method: 'PUT',
        body: data,
        type: ContentType.Json,
        ...params
      }),

    /**
     * No description
     *
     * @tags Asset
     * @name FundManagerUpdate
     * @summary Renames the fund manager (display name) across every fund under a ManCo code.
     * @request PUT:/{tenant}/asset/fund-manager
     */
    fundManagerUpdate: (
      tenant: string,
      data: ApiRenameFundManagerRequest,
      params: RequestParams = {}
    ) =>
      this.request<ApiRenameFundManagerResult, any>({
        path: `/${tenant}/asset/fund-manager`,
        method: 'PUT',
        body: data,
        type: ContentType.Json,
        format: 'json',
        ...params
      }),

    /**
     * No description
     *
     * @tags Asset
     * @name TradingProviderUpdate
     * @summary Updates the asset trading provider.
     * @request PUT:/{tenant}/asset/{assetId}/TradingProvider/{newTradingProvider}
     */
    tradingProviderUpdate: (
      assetId: string,
      newTradingProvider: ApiTradingProviderType,
      tenant: string,
      params: RequestParams = {}
    ) =>
      this.request<void, any>({
        path: `/${tenant}/asset/${assetId}/TradingProvider/${newTradingProvider}`,
        method: 'PUT',
        ...params
      }),

    /**
     * No description
     *
     * @tags Asset
     * @name MarketDataProviderUpdate
     * @summary Updates the asset market data provider.
     * @request PUT:/{tenant}/asset/{assetId}/MarketDataProvider/{newMarketDataProvider}
     */
    marketDataProviderUpdate: (
      assetId: string,
      newMarketDataProvider: ApiMarketDataProviderType,
      tenant: string,
      params: RequestParams = {}
    ) =>
      this.request<void, any>({
        path: `/${tenant}/asset/${assetId}/MarketDataProvider/${newMarketDataProvider}`,
        method: 'PUT',
        ...params
      }),

    /**
     * No description
     *
     * @tags Asset
     * @name SegregatedportfolioCreate
     * @summary Adds the segregated portfolio asset.
     * @request POST:/{tenant}/asset/segregatedportfolio
     */
    segregatedportfolioCreate: (
      tenant: string,
      data: ApiSegregatedPortfolioAsset,
      params: RequestParams = {}
    ) =>
      this.request<void, any>({
        path: `/${tenant}/asset/segregatedportfolio`,
        method: 'POST',
        body: data,
        type: ContentType.Json,
        ...params
      }),

    /**
     * No description
     *
     * @tags Asset
     * @name SegregatedportfolioUpdate
     * @summary Updates the segregated portfolio asset.
     * @request PUT:/{tenant}/asset/segregatedportfolio
     */
    segregatedportfolioUpdate: (
      tenant: string,
      data: ApiSegregatedPortfolioAsset,
      params: RequestParams = {}
    ) =>
      this.request<void, any>({
        path: `/${tenant}/asset/segregatedportfolio`,
        method: 'PUT',
        body: data,
        type: ContentType.Json,
        ...params
      }),

    /**
     * No description
     *
     * @tags Asset
     * @name DefaultsDetail
     * @summary Gets the asset defaults.
     * @request GET:/{tenant}/asset/defaults
     */
    defaultsDetail: (tenant: string, params: RequestParams = {}) =>
      this.request<ApiAssetDefaultConfiguration, any>({
        path: `/${tenant}/asset/defaults`,
        method: 'GET',
        format: 'json',
        ...params
      }),

    /**
     * No description
     *
     * @tags Asset
     * @name UploadCreate
     * @summary Uploads the assets and market data.
     * @request POST:/{tenant}/asset/upload
     */
    uploadCreate: (tenant: string, params: RequestParams = {}) =>
      this.request<void, any>({
        path: `/${tenant}/asset/upload`,
        method: 'POST',
        ...params
      }),

    /**
     * No description
     *
     * @tags Asset
     * @name ExdatesAddCreate
     * @summary Updates all the Absa ex-dates in the asset.
     * @request POST:/{tenant}/asset/{assetId}/exdates/add
     */
    exdatesAddCreate: (
      assetId: string,
      tenant: string,
      data: ApiAssetExDates,
      params: RequestParams = {}
    ) =>
      this.request<void, any>({
        path: `/${tenant}/asset/${assetId}/exdates/add`,
        method: 'POST',
        body: data,
        type: ContentType.Json,
        ...params
      }),

    /**
     * No description
     *
     * @tags Asset
     * @name IndexesDetail
     * @summary Gets all indexes.
     * @request GET:/{tenant}/asset/indexes
     */
    indexesDetail: (tenant: string, params: RequestParams = {}) =>
      this.request<ApiIndex[], any>({
        path: `/${tenant}/asset/indexes`,
        method: 'GET',
        format: 'json',
        ...params
      }),

    /**
     * No description
     *
     * @tags Asset
     * @name IndexCreate
     * @summary Adds an index definition.
     * @request POST:/{tenant}/asset/index
     */
    indexCreate: (tenant: string, data: ApiIndex, params: RequestParams = {}) =>
      this.request<void, any>({
        path: `/${tenant}/asset/index`,
        method: 'POST',
        body: data,
        type: ContentType.Json,
        ...params
      }),

    /**
     * No description
     *
     * @tags Asset
     * @name ListOrderAlertDetail
     * @summary Returns the filtered and paginated list of assets including a late order confirmation flag.
     * @request GET:/{tenant}/asset/list/order/alert
     */
    listOrderAlertDetail: (
      tenant: string,
      query?: {
        WildcardString?: string
        /** @format int32 */
        PageSize?: number
        /** @format int32 */
        PageNumber?: number
      },
      params: RequestParams = {}
    ) =>
      this.request<ApiAssetWithOrderAlertApiPaginationResult, any>({
        path: `/${tenant}/asset/list/order/alert`,
        method: 'GET',
        query: query,
        format: 'json',
        ...params
      }),

    /**
     * No description
     *
     * @tags Asset
     * @name MarketdatareadyCreate
     * @summary Mark a given asset as market data ready.
     * @request POST:/{tenant}/asset/{assetId}/marketdataready
     */
    marketdatareadyCreate: (assetId: string, tenant: string, params: RequestParams = {}) =>
      this.request<void, any>({
        path: `/${tenant}/asset/${assetId}/marketdataready`,
        method: 'POST',
        ...params
      }),

    /**
 * No description
 *
 * @tags Asset
 * @name SoftdeleteCreate
 * @summary Soft-deletes an asset (e.g. a removed or amalgamated fund) so it no longer generates
missing market data alerts. Reversible via M:QHub.Api.Controllers.FrontEnd.AssetController.RestoreAsset(System.String,System.Threading.CancellationToken).
 * @request POST:/{tenant}/asset/{assetId}/softdelete
 */
    softdeleteCreate: (assetId: string, tenant: string, params: RequestParams = {}) =>
      this.request<void, any>({
        path: `/${tenant}/asset/${assetId}/softdelete`,
        method: 'POST',
        ...params
      }),

    /**
     * No description
     *
     * @tags Asset
     * @name RestoreCreate
     * @summary Restores a previously soft-deleted asset.
     * @request POST:/{tenant}/asset/{assetId}/restore
     */
    restoreCreate: (assetId: string, tenant: string, params: RequestParams = {}) =>
      this.request<void, any>({
        path: `/${tenant}/asset/${assetId}/restore`,
        method: 'POST',
        ...params
      }),

    /**
     * No description
     *
     * @tags BusinessUnit
     * @name BusinessunitDetail
     * @summary Gets the business unit.
     * @request GET:/{tenant}/businessunit/{businessUnitId}
     */
    businessunitDetail: (businessUnitId: string, tenant: string, params: RequestParams = {}) =>
      this.request<ApiBusinessUnit, any>({
        path: `/${tenant}/businessunit/${businessUnitId}`,
        method: 'GET',
        format: 'json',
        ...params
      }),

    /**
     * No description
     *
     * @tags BusinessUnit
     * @name UsersCreate
     * @summary Adds the user to business unit.
     * @request POST:/{tenant}/businessunit/{businessUnitId}/users
     */
    usersCreate: (
      businessUnitId: string,
      tenant: string,
      data: ApiAddBusinessUnitUser,
      params: RequestParams = {}
    ) =>
      this.request<void, any>({
        path: `/${tenant}/businessunit/${businessUnitId}/users`,
        method: 'POST',
        body: data,
        type: ContentType.Json,
        ...params
      }),

    /**
     * No description
     *
     * @tags BusinessUnit
     * @name UsersDetail
     * @summary Gets the business unit with users.
     * @request GET:/{tenant}/businessunit/{businessUnitId}/users
     */
    usersDetail: (businessUnitId: string, tenant: string, params: RequestParams = {}) =>
      this.request<ApiBusinessUnitWithUsers, any>({
        path: `/${tenant}/businessunit/${businessUnitId}/users`,
        method: 'GET',
        format: 'json',
        ...params
      }),

    /**
     * No description
     *
     * @tags BusinessUnit
     * @name TransferCreate
     * @summary Transfers the ownership to business unit.
     * @request POST:/{tenant}/businessunit/transfer
     */
    transferCreate: (
      tenant: string,
      data: ApiTransferBusinessUnitOwnership,
      params: RequestParams = {}
    ) =>
      this.request<ApiTransferBusinessUnitOwnershipResult, any>({
        path: `/${tenant}/businessunit/transfer`,
        method: 'POST',
        body: data,
        type: ContentType.Json,
        format: 'json',
        ...params
      }),

    /**
     * No description
     *
     * @tags CashInstrument
     * @name CashinstrumentDetail
     * @summary Gets all cash instruments.
     * @request GET:/{tenant}/cashinstrument
     */
    cashinstrumentDetail: (tenant: string, params: RequestParams = {}) =>
      this.request<(ApiLoan | ApiDeposit | ApiZcbCurve)[], any>({
        path: `/${tenant}/cashinstrument`,
        method: 'GET',
        format: 'json',
        ...params
      }),

    /**
     * No description
     *
     * @tags CashInstrument
     * @name ListDetail2
     * @summary Gets the cash instruments list.
     * @request GET:/{tenant}/cashinstrument/list
     * @originalName listDetail
     * @duplicate
     */
    listDetail2: (
      tenant: string,
      query?: {
        WildcardString?: string
        CashInstrumentType?: ApiCashInstrumentType
        /** @format int32 */
        PageSize?: number
        /** @format int32 */
        PageNumber?: number
        SortField?: string
        SortAscending?: boolean
      },
      params: RequestParams = {}
    ) =>
      this.request<ApiCashInstrumentApiPaginationResult, any>({
        path: `/${tenant}/cashinstrument/list`,
        method: 'GET',
        query: query,
        format: 'json',
        ...params
      }),

    /**
     * No description
     *
     * @tags CashInstrument
     * @name LoanCreate
     * @summary Adds a loan.
     * @request POST:/{tenant}/cashinstrument/loan
     */
    loanCreate: (tenant: string, data: ApiLoan, params: RequestParams = {}) =>
      this.request<void, any>({
        path: `/${tenant}/cashinstrument/loan`,
        method: 'POST',
        body: data,
        type: ContentType.Json,
        ...params
      }),

    /**
     * No description
     *
     * @tags CashInstrument
     * @name LoanUpdateCreate
     * @summary Updates a loan.
     * @request POST:/{tenant}/cashinstrument/loan/update
     */
    loanUpdateCreate: (tenant: string, data: ApiLoan, params: RequestParams = {}) =>
      this.request<void, any>({
        path: `/${tenant}/cashinstrument/loan/update`,
        method: 'POST',
        body: data,
        type: ContentType.Json,
        ...params
      }),

    /**
     * No description
     *
     * @tags CashInstrument
     * @name DepositCreate
     * @summary Adds a deposit.
     * @request POST:/{tenant}/cashinstrument/deposit
     */
    depositCreate: (tenant: string, data: ApiDeposit, params: RequestParams = {}) =>
      this.request<void, any>({
        path: `/${tenant}/cashinstrument/deposit`,
        method: 'POST',
        body: data,
        type: ContentType.Json,
        ...params
      }),

    /**
     * No description
     *
     * @tags CashInstrument
     * @name DepositUpdateCreate
     * @summary Updates a deposit.
     * @request POST:/{tenant}/cashinstrument/deposit/update
     */
    depositUpdateCreate: (tenant: string, data: ApiDeposit, params: RequestParams = {}) =>
      this.request<void, any>({
        path: `/${tenant}/cashinstrument/deposit/update`,
        method: 'POST',
        body: data,
        type: ContentType.Json,
        ...params
      }),

    /**
     * No description
     *
     * @tags CashInstrument
     * @name ZcbcurveCreate
     * @summary Adds a ZCB curve.
     * @request POST:/{tenant}/cashinstrument/zcbcurve
     */
    zcbcurveCreate: (tenant: string, data: ApiZcbCurve, params: RequestParams = {}) =>
      this.request<void, any>({
        path: `/${tenant}/cashinstrument/zcbcurve`,
        method: 'POST',
        body: data,
        type: ContentType.Json,
        ...params
      }),

    /**
     * No description
     *
     * @tags CashInstrument
     * @name ZcbcurveUpdateCreate
     * @summary Updates a ZCB curve.
     * @request POST:/{tenant}/cashinstrument/zcbcurve/update
     */
    zcbcurveUpdateCreate: (tenant: string, data: ApiZcbCurve, params: RequestParams = {}) =>
      this.request<void, any>({
        path: `/${tenant}/cashinstrument/zcbcurve/update`,
        method: 'POST',
        body: data,
        type: ContentType.Json,
        ...params
      }),

    /**
     * No description
     *
     * @tags Client
     * @name ClientCreate
     * @summary Adds the client.
     * @request POST:/{tenant}/client
     */
    clientCreate: (tenant: string, data: ApiNewClient, params: RequestParams = {}) =>
      this.request<string, any>({
        path: `/${tenant}/client`,
        method: 'POST',
        body: data,
        type: ContentType.Json,
        format: 'json',
        ...params
      }),

    /**
     * No description
     *
     * @tags Client
     * @name ClientDetail
     * @summary Gets all clients.
     * @request GET:/{tenant}/client
     */
    clientDetail: (tenant: string, params: RequestParams = {}) =>
      this.request<ApiClient[], any>({
        path: `/${tenant}/client`,
        method: 'GET',
        format: 'json',
        ...params
      }),

    /**
     * No description
     *
     * @tags Client
     * @name ClientUpdate
     * @summary Updates the client.
     * @request PUT:/{tenant}/client
     */
    clientUpdate: (tenant: string, data: ApiClient, params: RequestParams = {}) =>
      this.request<void, any>({
        path: `/${tenant}/client`,
        method: 'PUT',
        body: data,
        type: ContentType.Json,
        ...params
      }),

    /**
     * No description
     *
     * @tags Client
     * @name UsersDetail2
     * @summary Gets all clients.
     * @request GET:/{tenant}/client/users
     * @originalName usersDetail
     * @duplicate
     */
    usersDetail2: (tenant: string, params: RequestParams = {}) =>
      this.request<ApiClientWithUsers[], any>({
        path: `/${tenant}/client/users`,
        method: 'GET',
        format: 'json',
        ...params
      }),

    /**
     * No description
     *
     * @tags Client
     * @name ClientDetail2
     * @summary Gets the client.
     * @request GET:/{tenant}/client/{clientId}
     * @originalName clientDetail
     * @duplicate
     */
    clientDetail2: (clientId: string, tenant: string, params: RequestParams = {}) =>
      this.request<ApiClient, any>({
        path: `/${tenant}/client/${clientId}`,
        method: 'GET',
        format: 'json',
        ...params
      }),

    /**
     * No description
     *
     * @tags Client
     * @name UsersDetail3
     * @summary Gets the client with users.
     * @request GET:/{tenant}/client/{clientId}/users
     * @originalName usersDetail
     * @duplicate
     */
    usersDetail3: (clientId: string, tenant: string, params: RequestParams = {}) =>
      this.request<ApiClientWithUsers, any>({
        path: `/${tenant}/client/${clientId}/users`,
        method: 'GET',
        format: 'json',
        ...params
      }),

    /**
     * No description
     *
     * @tags Client
     * @name UsersCreate2
     * @summary Adds the user to client.
     * @request POST:/{tenant}/client/{clientId}/users
     * @originalName usersCreate
     * @duplicate
     */
    usersCreate2: (
      clientId: string,
      tenant: string,
      data: ApiAddClientUser,
      params: RequestParams = {}
    ) =>
      this.request<void, any>({
        path: `/${tenant}/client/${clientId}/users`,
        method: 'POST',
        body: data,
        type: ContentType.Json,
        ...params
      }),

    /**
     * No description
     *
     * @tags Client
     * @name BusinessUnitsCreate
     * @summary Adds the business unit.
     * @request POST:/{tenant}/client/{clientId}/businessUnits
     */
    businessUnitsCreate: (
      clientId: string,
      tenant: string,
      data: ApiAddBusinessUnitToClient,
      params: RequestParams = {}
    ) =>
      this.request<void, any>({
        path: `/${tenant}/client/${clientId}/businessUnits`,
        method: 'POST',
        body: data,
        type: ContentType.Json,
        ...params
      }),

    /**
     * No description
     *
     * @tags Client
     * @name BusinessUnitsUpdate
     * @summary Updates the business unit.
     * @request PUT:/{tenant}/client/{clientId}/businessUnits
     */
    businessUnitsUpdate: (
      clientId: string,
      tenant: string,
      data: ApiBusinessUnit,
      params: RequestParams = {}
    ) =>
      this.request<void, any>({
        path: `/${tenant}/client/${clientId}/businessUnits`,
        method: 'PUT',
        body: data,
        type: ContentType.Json,
        ...params
      }),

    /**
     * No description
     *
     * @tags Client
     * @name BusinessUnitsDelete
     * @summary Updates the business unit.
     * @request DELETE:/{tenant}/client/{clientId}/businessUnits/{businessUnitId}
     */
    businessUnitsDelete: (
      clientId: string,
      businessUnitId: string,
      tenant: string,
      params: RequestParams = {}
    ) =>
      this.request<void, any>({
        path: `/${tenant}/client/${clientId}/businessUnits/${businessUnitId}`,
        method: 'DELETE',
        ...params
      }),

    /**
     * No description
     *
     * @tags Counterparty
     * @name CounterpartyidsDetail
     * @summary Gets all the counterparty identifiers.
     * @request GET:/{tenant}/counterparty/counterpartyids
     */
    counterpartyidsDetail: (tenant: string, params: RequestParams = {}) =>
      this.request<string[], any>({
        path: `/${tenant}/counterparty/counterpartyids`,
        method: 'GET',
        format: 'json',
        ...params
      }),

    /**
     * No description
     *
     * @tags Counterparty
     * @name GetTenant
     * @summary Gets all the counterparties.
     * @request GET:/{tenant}/counterparty/all
     */
    getTenant: (tenant: string, params: RequestParams = {}) =>
      this.request<ApiCounterparty[], any>({
        path: `/${tenant}/counterparty/all`,
        method: 'GET',
        format: 'json',
        ...params
      }),

    /**
     * No description
     *
     * @tags Counterparty
     * @name PostTenant
     * @summary Adds a counterparty.
     * @request POST:/{tenant}/counterparty/add
     */
    postTenant: (tenant: string, data: ApiCounterparty, params: RequestParams = {}) =>
      this.request<void, any>({
        path: `/${tenant}/counterparty/add`,
        method: 'POST',
        body: data,
        type: ContentType.Json,
        ...params
      }),

    /**
     * No description
     *
     * @tags Counterparty
     * @name UpdateUpdate
     * @summary Updates a counterparty.
     * @request PUT:/{tenant}/counterparty/update
     */
    updateUpdate: (tenant: string, data: ApiCounterparty, params: RequestParams = {}) =>
      this.request<void, any>({
        path: `/${tenant}/counterparty/update`,
        method: 'PUT',
        body: data,
        type: ContentType.Json,
        ...params
      }),

    /**
     * No description
     *
     * @tags DataUpload
     * @name ModelparametersCreate
     * @summary POST a typed model QHub.Api.Contracts.Messaging.ApiModelParametersMessage
     * @request POST:/{tenant}/upload/modelparameters
     */
    modelparametersCreate: (
      tenant: string,
      data: ApiModelParametersMessage,
      params: RequestParams = {}
    ) =>
      this.request<void, any>({
        path: `/${tenant}/upload/modelparameters`,
        method: 'POST',
        body: data,
        type: ContentType.Json,
        ...params
      }),

    /**
     * No description
     *
     * @tags DataUpload
     * @name ExchangefileCreate
     * @summary Uploads a text based exchange file into the system.
     * @request POST:/{tenant}/upload/exchangefile/{contentType}/{fileType}/{fileName}/{referenceDate}
     */
    exchangefileCreate: (
      contentType: string,
      fileType: ExchangeFileType,
      fileName: string,
      referenceDate: string,
      tenant: string,
      params: RequestParams = {}
    ) =>
      this.request<any, any>({
        path: `/${tenant}/upload/exchangefile/${contentType}/${fileType}/${fileName}/${referenceDate}`,
        method: 'POST',
        format: 'json',
        ...params
      }),

    /**
     * No description
     *
     * @tags Dfm
     * @name PostTenant2
     * @summary Adds a DFM.
     * @request POST:/{tenant}/dfm
     * @originalName postTenant
     * @duplicate
     */
    postTenant2: (tenant: string, data: ApiNewDfm, params: RequestParams = {}) =>
      this.request<string, any>({
        path: `/${tenant}/dfm`,
        method: 'POST',
        body: data,
        type: ContentType.Json,
        format: 'json',
        ...params
      }),

    /**
     * No description
     *
     * @tags Dfm
     * @name PutTenant
     * @summary Updates the DFM.
     * @request PUT:/{tenant}/dfm
     */
    putTenant: (tenant: string, data: ApiDfm, params: RequestParams = {}) =>
      this.request<void, any>({
        path: `/${tenant}/dfm`,
        method: 'PUT',
        body: data,
        type: ContentType.Json,
        ...params
      }),

    /**
     * No description
     *
     * @tags Dfm
     * @name UsersCreate3
     * @summary Adds the user to DFM.
     * @request POST:/{tenant}/dfm/{dfmId}/users
     * @originalName usersCreate
     * @duplicate
     */
    usersCreate3: (
      dfmId: string,
      tenant: string,
      data: ApiAddDfmUser,
      params: RequestParams = {}
    ) =>
      this.request<void, any>({
        path: `/${tenant}/dfm/${dfmId}/users`,
        method: 'POST',
        body: data,
        type: ContentType.Json,
        ...params
      }),

    /**
     * No description
     *
     * @tags Dfm
     * @name UsersDetail4
     * @summary Gets the DFM with users.
     * @request GET:/{tenant}/dfm/{dfmId}/users
     * @originalName usersDetail
     * @duplicate
     */
    usersDetail4: (dfmId: string, tenant: string, params: RequestParams = {}) =>
      this.request<ApiDfmWithUsers, any>({
        path: `/${tenant}/dfm/${dfmId}/users`,
        method: 'GET',
        format: 'json',
        ...params
      }),

    /**
     * No description
     *
     * @tags Distributions
     * @name PostTenant3
     * @summary Adds a distribution.
     * @request POST:/{tenant}/distributions/add
     * @originalName postTenant
     * @duplicate
     */
    postTenant3: (tenant: string, data: ApiDistributionData[], params: RequestParams = {}) =>
      this.request<void, any>({
        path: `/${tenant}/distributions/add`,
        method: 'POST',
        body: data,
        type: ContentType.Json,
        ...params
      }),

    /**
     * No description
     *
     * @tags Distributions
     * @name DistributionsDetail
     * @summary Gets all the distributions for an asset.
     * @request GET:/{tenant}/distributions/{assetId}
     */
    distributionsDetail: (assetId: string, tenant: string, params: RequestParams = {}) =>
      this.request<ApiDistributionData[], any>({
        path: `/${tenant}/distributions/${assetId}`,
        method: 'GET',
        format: 'json',
        ...params
      }),

    /**
     * No description
     *
     * @tags Distributions
     * @name ReinvestmentsAddCreate
     * @summary Adds a reinvestment confirmation.
     * @request POST:/{tenant}/distributions/reinvestments/add
     */
    reinvestmentsAddCreate: (
      tenant: string,
      data: ApiNewReinvestmentConfirmation,
      params: RequestParams = {}
    ) =>
      this.request<void, any>({
        path: `/${tenant}/distributions/reinvestments/add`,
        method: 'POST',
        body: data,
        type: ContentType.Json,
        ...params
      }),

    /**
     * No description
     *
     * @tags Distributions
     * @name ReinvestmentsDetail
     * @summary Gets all the distributions for an asset.
     * @request GET:/{tenant}/distributions/reinvestments/{assetId}
     */
    reinvestmentsDetail: (assetId: string, tenant: string, params: RequestParams = {}) =>
      this.request<ApiReinvestmentConfirmation[], any>({
        path: `/${tenant}/distributions/reinvestments/${assetId}`,
        method: 'GET',
        format: 'json',
        ...params
      }),

    /**
     * No description
     *
     * @tags Distributions
     * @name ReinvestmentsDataDetail
     * @summary Gets all the expected confirmation data for an asset and an ex date.
     * @request GET:/{tenant}/distributions/reinvestments/data/{assetId}/{exDate}
     */
    reinvestmentsDataDetail: (
      assetId: string,
      exDate: string,
      tenant: string,
      params: RequestParams = {}
    ) =>
      this.request<ApiExpectedReinvestmentData, any>({
        path: `/${tenant}/distributions/reinvestments/data/${assetId}/${exDate}`,
        method: 'GET',
        format: 'json',
        ...params
      }),

    /**
     * No description
     *
     * @tags Distributions
     * @name ReinvestmentsAssignUpdate
     * @summary Adds a reinvestment confirmation and submit the corresponding instruction to the valuation engine.
     * @request PUT:/{tenant}/distributions/reinvestments/assign/{confirmationId}/{exDate}
     */
    reinvestmentsAssignUpdate: (
      confirmationId: string,
      exDate: string,
      tenant: string,
      params: RequestParams = {}
    ) =>
      this.request<void, any>({
        path: `/${tenant}/distributions/reinvestments/assign/${confirmationId}/${exDate}`,
        method: 'PUT',
        ...params
      }),

    /**
     * No description
     *
     * @tags Distributions
     * @name AssetswithalertsDetail
     * @summary Gets all asset ids that have any alert attached to them.
     * @request GET:/{tenant}/distributions/assetswithalerts
     */
    assetswithalertsDetail: (tenant: string, params: RequestParams = {}) =>
      this.request<ApiDistributionAlert[], any>({
        path: `/${tenant}/distributions/assetswithalerts`,
        method: 'GET',
        format: 'json',
        ...params
      }),

    /**
     * No description
     *
     * @tags Documentation
     * @name AccountSummaryDetail
     * @summary Get account documentation.
     * @request GET:/{tenant}/documentation/account/{accountId}/summary
     */
    accountSummaryDetail: (accountId: string, tenant: string, params: RequestParams = {}) =>
      this.request<ApiAccountDocumentationInfo[], any>({
        path: `/${tenant}/documentation/account/${accountId}/summary`,
        method: 'GET',
        format: 'json',
        ...params
      }),

    /**
     * No description
     *
     * @tags Documentation
     * @name NoteSummaryDetail
     * @summary Get account documentation by note
     * @request GET:/{tenant}/documentation/note/{noteId}/summary
     */
    noteSummaryDetail: (noteId: string, tenant: string, params: RequestParams = {}) =>
      this.request<ApiAccountDocumentationInfo[], any>({
        path: `/${tenant}/documentation/note/${noteId}/summary`,
        method: 'GET',
        format: 'json',
        ...params
      }),

    /**
     * No description
     *
     * @tags Documentation
     * @name AccountDetail4
     * @summary Get account documentation
     * @request GET:/{tenant}/documentation/account/{accountId}/{documentNumber}
     * @originalName accountDetail
     * @duplicate
     */
    accountDetail4: (
      accountId: string,
      documentNumber: number,
      tenant: string,
      params: RequestParams = {}
    ) =>
      this.request<StreamedResult, any>({
        path: `/${tenant}/documentation/account/${accountId}/${documentNumber}`,
        method: 'GET',
        format: 'json',
        ...params
      }),

    /**
     * No description
     *
     * @tags Documentation
     * @name DocumentationDetail
     * @summary Get a document.
     * @request GET:/{tenant}/documentation/{fileName}
     */
    documentationDetail: (fileName: string, tenant: string, params: RequestParams = {}) =>
      this.request<StreamedResult, any>({
        path: `/${tenant}/documentation/${fileName}`,
        method: 'GET',
        format: 'json',
        ...params
      }),

    /**
     * No description
     *
     * @tags Documentation
     * @name DocumentationCreate
     * @summary Upload a document.
     * @request POST:/{tenant}/documentation/{fileName}
     */
    documentationCreate: (fileName: string, tenant: string, params: RequestParams = {}) =>
      this.request<void, any>({
        path: `/${tenant}/documentation/${fileName}`,
        method: 'POST',
        ...params
      }),

    /**
     * No description
     *
     * @tags FrontEndOrder
     * @name CorrectionCreate
     * @summary Save an order correction request
     * @request POST:/{tenant}/order/correction
     */
    correctionCreate: (
      tenant: string,
      data: ApiNewAggregatedOrderCorrection,
      params: RequestParams = {}
    ) =>
      this.request<void, any>({
        path: `/${tenant}/order/correction`,
        method: 'POST',
        body: data,
        type: ContentType.Json,
        ...params
      }),

    /**
     * No description
     *
     * @tags FrontEndOrder
     * @name ConfirmationCreate
     * @summary Save a manual order confirmation request
     * @request POST:/{tenant}/order/confirmation
     */
    confirmationCreate: (
      tenant: string,
      data: ApiNewAggregatedOrderConfirmation,
      params: RequestParams = {}
    ) =>
      this.request<void, any>({
        path: `/${tenant}/order/confirmation`,
        method: 'POST',
        body: data,
        type: ContentType.Json,
        ...params
      }),

    /**
     * No description
     *
     * @tags FrontEndOrder
     * @name OutstandingDetail
     * @summary Get all the outstanding orders.
     * @request GET:/{tenant}/order/outstanding/{assetId}
     */
    outstandingDetail: (assetId: string, tenant: string, params: RequestParams = {}) =>
      this.request<ApiOutstandingAggregatedOrder[], any>({
        path: `/${tenant}/order/outstanding/${assetId}`,
        method: 'GET',
        format: 'json',
        ...params
      }),

    /**
     * No description
     *
     * @tags FrontEndOrder
     * @name ConfirmedDetail
     * @summary Get all the confirmed orders.
     * @request GET:/{tenant}/order/confirmed
     */
    confirmedDetail: (
      tenant: string,
      query?: {
        AssetId?: string
        /** @format date-time */
        CreationStartDateInclusive?: string
        /** @format date-time */
        CreationEndDateInclusive?: string
        IncludeRedemptionOrders?: boolean
        IncludeSubscriptionOrders?: boolean
        /** @format int32 */
        PageSize?: number
        /** @format int32 */
        PageNumber?: number
      },
      params: RequestParams = {}
    ) =>
      this.request<ApiConfirmedAggregatedOrderApiPaginationResult, any>({
        path: `/${tenant}/order/confirmed`,
        method: 'GET',
        query: query,
        format: 'json',
        ...params
      }),

    /**
     * No description
     *
     * @tags NonOrganizedMedia
     * @name QueueDepthDetail
     * @summary Get the current unprocessed queue depth for a valuation cycle.
     * @request GET:/{tenant}/nom/queue/{date}/depth
     */
    queueDepthDetail: (date: string, tenant: string, params: RequestParams = {}) =>
      this.request<number, any>({
        path: `/${tenant}/nom/queue/${date}/depth`,
        method: 'GET',
        format: 'json',
        ...params
      }),

    /**
     * No description
     *
     * @tags NonOrganizedMedia
     * @name PostTenant4
     * @summary Upload a single QHub.Api.Contracts.Messaging.ApiNomMessage.
     * @request POST:/{tenant}/nom/one
     * @originalName postTenant
     * @duplicate
     */
    postTenant4: (tenant: string, params: RequestParams = {}) =>
      this.request<void, any>({
        path: `/${tenant}/nom/one`,
        method: 'POST',
        ...params
      }),

    /**
     * No description
     *
     * @tags NonOrganizedMedia
     * @name ManyCreate
     * @summary Upload multiple QHub.Api.Contracts.Messaging.ApiNomMessage.
     * @request POST:/{tenant}/nom/many
     */
    manyCreate: (tenant: string, params: RequestParams = {}) =>
      this.request<void, any>({
        path: `/${tenant}/nom/many`,
        method: 'POST',
        ...params
      }),

    /**
     * No description
     *
     * @tags NonOrganizedMedia
     * @name InstructionCreate
     * @summary Add an instruction to the valuation queue
     * @request POST:/{tenant}/nom/instruction
     */
    instructionCreate: (
      tenant: string,
      data:
        | ApiNewAccountInstruction
        | ApiDepositInstruction
        | ApiPortfolioChangeInstruction
        | ApiAccountClosureInstruction
        | ApiWithdrawalInstruction
        | ApiProtectedValueChangeInstruction
        | ApiStrategyChangeInstruction
        | ApiProtectionPortfolioChangeInstruction
        | ApiAncillaryAssetsChangeInstruction
        | ApiSwitchInInstruction
        | ApiSwitchOutInstruction
        | ApiDividendInstruction
        | ApiReinvestmentConfirmationInstruction
        | ApiNoteChangeInstruction,
      params: RequestParams = {}
    ) =>
      this.request<void, any>({
        path: `/${tenant}/nom/instruction`,
        method: 'POST',
        body: data,
        type: ContentType.Json,
        ...params
      }),

    /**
     * No description
     *
     * @tags Note
     * @name ExportCreate2
     * @summary Gets the note export.
     * @request POST:/{tenant}/note/export
     * @originalName exportCreate
     * @duplicate
     */
    exportCreate2: (tenant: string, data: ApiGetNoteExportFilters, params: RequestParams = {}) =>
      this.request<File, any>({
        path: `/${tenant}/note/export`,
        method: 'POST',
        body: data,
        type: ContentType.Json,
        format: 'json',
        ...params
      }),

    /**
     * No description
     *
     * @tags Note
     * @name HoldingsExportDetail
     * @summary Gets the note holdings export for date.
     * @request GET:/{tenant}/note/holdings/{date}/export
     */
    holdingsExportDetail: (date: string, tenant: string, params: RequestParams = {}) =>
      this.request<File, any>({
        path: `/${tenant}/note/holdings/${date}/export`,
        method: 'GET',
        format: 'json',
        ...params
      }),

    /**
     * No description
     *
     * @tags Note
     * @name ExportFilterDetail
     * @summary Gets the note export.
     * @request GET:/{tenant}/note/export/filter
     */
    exportFilterDetail: (
      tenant: string,
      query?: {
        CounterpartyIds?: string[]
        /** @format date-time */
        StartDateInclusive?: string
        /** @format date-time */
        EndDateInclusive?: string
        /** @format int32 */
        MaximumNumberResults?: number
      },
      params: RequestParams = {}
    ) =>
      this.request<File, any>({
        path: `/${tenant}/note/export/filter`,
        method: 'GET',
        query: query,
        format: 'json',
        ...params
      }),

    /**
     * No description
     *
     * @tags Note
     * @name StatementLatestDetail
     * @summary Get the latest note documentation.
     * @request GET:/{tenant}/note/{noteId}/statement/latest
     */
    statementLatestDetail: (noteId: string, tenant: string, params: RequestParams = {}) =>
      this.request<StreamedResult, any>({
        path: `/${tenant}/note/${noteId}/statement/latest`,
        method: 'GET',
        format: 'json',
        ...params
      }),

    /**
     * No description
     *
     * @tags Note
     * @name StatementDetail
     * @summary Get the note documentation for a date.
     * @request GET:/{tenant}/note/{noteId}/statement/{date}
     */
    statementDetail: (noteId: string, date: string, tenant: string, params: RequestParams = {}) =>
      this.request<StreamedResult, any>({
        path: `/${tenant}/note/${noteId}/statement/${date}`,
        method: 'GET',
        format: 'json',
        ...params
      }),

    /**
     * No description
     *
     * @tags Note
     * @name StatementDetail2
     * @summary Get the note documentation for a date.
     * @request GET:/{tenant}/note/{noteId}/statement/{year}/{month}
     * @originalName statementDetail
     * @duplicate
     */
    statementDetail2: (
      noteId: string,
      year: number,
      month: number,
      tenant: string,
      params: RequestParams = {}
    ) =>
      this.request<StreamedResult, any>({
        path: `/${tenant}/note/${noteId}/statement/${year}/${month}`,
        method: 'GET',
        format: 'json',
        ...params
      }),

    /**
     * No description
     *
     * @tags Note
     * @name StatementsDetail
     * @summary Get the latest note documentation as a zip.
     * @request GET:/{tenant}/note/statements
     */
    statementsDetail: (
      tenant: string,
      query?: {
        ids?: string
      },
      params: RequestParams = {}
    ) =>
      this.request<StreamedResult, any>({
        path: `/${tenant}/note/statements`,
        method: 'GET',
        query: query,
        format: 'json',
        ...params
      }),

    /**
     * No description
     *
     * @tags Note
     * @name StatementsPreviousDetail
     * @summary Get the previous note documentation as a zip.
     * @request GET:/{tenant}/note/{noteId}/statements/previous
     */
    statementsPreviousDetail: (noteId: string, tenant: string, params: RequestParams = {}) =>
      this.request<StreamedResult, any>({
        path: `/${tenant}/note/${noteId}/statements/previous`,
        method: 'GET',
        format: 'json',
        ...params
      }),

    /**
     * No description
     *
     * @tags Note
     * @name DataAccountNewinstructionsCreate
     * @summary Gets the note data calculated from including the specified instructions.
     * @request POST:/{tenant}/note/data/account/{accountId}/newinstructions
     */
    dataAccountNewinstructionsCreate: (
      accountId: string,
      tenant: string,
      data: ApiInstructionSet,
      params: RequestParams = {}
    ) =>
      this.request<ApiNoteData, any>({
        path: `/${tenant}/note/data/account/${accountId}/newinstructions`,
        method: 'POST',
        body: data,
        type: ContentType.Json,
        format: 'json',
        ...params
      }),

    /**
 * No description
 *
 * @tags Note
 * @name InstructionValidateDetail
 * @summary Validates a new note instruction without submitting it.
This endpoint can be called while the user edits the form
to display early problem with the instruction, like tax classification breaches.
 * @request GET:/{tenant}/note/instruction/validate
 */
    instructionValidateDetail: (
      tenant: string,
      data: ApiNoteInstructionSubmission,
      params: RequestParams = {}
    ) =>
      this.request<BasicApiResult, string>({
        path: `/${tenant}/note/instruction/validate`,
        method: 'GET',
        body: data,
        type: ContentType.Json,
        format: 'json',
        ...params
      }),

    /**
     * No description
     *
     * @tags Note
     * @name InstructionSubmitCreate
     * @summary Submit a new note instruction.
     * @request POST:/{tenant}/note/instruction/submit
     */
    instructionSubmitCreate: (
      tenant: string,
      data: ApiNoteInstructionSubmission,
      params: RequestParams = {}
    ) =>
      this.request<BasicApiResult, string>({
        path: `/${tenant}/note/instruction/submit`,
        method: 'POST',
        body: data,
        type: ContentType.Json,
        format: 'json',
        ...params
      }),

    /**
     * No description
     *
     * @tags Note
     * @name InstructionRejectCreate
     * @summary Reject a note instruction.
     * @request POST:/{tenant}/note/{noteId}/instruction/reject
     */
    instructionRejectCreate: (noteId: string, tenant: string, params: RequestParams = {}) =>
      this.request<BasicApiResult, string>({
        path: `/${tenant}/note/${noteId}/instruction/reject`,
        method: 'POST',
        format: 'json',
        ...params
      }),

    /**
     * No description
     *
     * @tags Note
     * @name InstructionApproveCreate
     * @summary Approve a note instruction.
     * @request POST:/{tenant}/note/{noteId}/instruction/approve
     */
    instructionApproveCreate: (noteId: string, tenant: string, params: RequestParams = {}) =>
      this.request<BasicApiResult, string>({
        path: `/${tenant}/note/${noteId}/instruction/approve`,
        method: 'POST',
        format: 'json',
        ...params
      }),

    /**
     * No description
     *
     * @tags Note
     * @name InstructionApproveCommitmentCreate
     * @summary Commit a note instruction.
     * @request POST:/{tenant}/note/{noteId}/instruction/approve/commitment
     */
    instructionApproveCommitmentCreate: (
      noteId: string,
      tenant: string,
      params: RequestParams = {}
    ) =>
      this.request<BasicApiResult, string>({
        path: `/${tenant}/note/${noteId}/instruction/approve/commitment`,
        method: 'POST',
        format: 'json',
        ...params
      }),

    /**
     * No description
     *
     * @tags Note
     * @name InstructionApproveCommitmentClientCreate
     * @summary Client commit a note instruction.
     * @request POST:/{tenant}/note/{noteId}/instruction/approve/commitment/client
     */
    instructionApproveCommitmentClientCreate: (
      noteId: string,
      tenant: string,
      params: RequestParams = {}
    ) =>
      this.request<BasicApiResult, string>({
        path: `/${tenant}/note/${noteId}/instruction/approve/commitment/client`,
        method: 'POST',
        format: 'json',
        ...params
      }),

    /**
     * No description
     *
     * @tags Note
     * @name InstructionApproveSettlementCreate
     * @summary Approve settlement for note instruction.
     * @request POST:/{tenant}/note/{noteId}/instruction/approve/settlement
     */
    instructionApproveSettlementCreate: (
      noteId: string,
      tenant: string,
      params: RequestParams = {}
    ) =>
      this.request<BasicApiResult, string>({
        path: `/${tenant}/note/${noteId}/instruction/approve/settlement`,
        method: 'POST',
        format: 'json',
        ...params
      }),

    /**
     * No description
     *
     * @tags Note
     * @name InstructionActivateCreate
     * @summary Activate note instruction.
     * @request POST:/{tenant}/note/{noteId}/instruction/activate
     */
    instructionActivateCreate: (noteId: string, tenant: string, params: RequestParams = {}) =>
      this.request<BasicApiResult, string>({
        path: `/${tenant}/note/${noteId}/instruction/activate`,
        method: 'POST',
        format: 'json',
        ...params
      }),

    /**
     * No description
     *
     * @tags Note
     * @name InprogressDetail3
     * @summary Get all notes with instructions in progress.
     * @request GET:/{tenant}/note/inprogress
     * @originalName inprogressDetail
     * @duplicate
     */
    inprogressDetail3: (
      tenant: string,
      query?: {
        /** @format int32 */
        PageSize?: number
        /** @format int32 */
        PageNumber?: number
      },
      params: RequestParams = {}
    ) =>
      this.request<ApiNoteInProgressApiPaginationResult, any>({
        path: `/${tenant}/note/inprogress`,
        method: 'GET',
        query: query,
        format: 'json',
        ...params
      }),

    /**
     * No description
     *
     * @tags Note
     * @name InprogressCountDetail
     * @summary The number of notes and trades to be approved.
     * @request GET:/{tenant}/note/inprogress/count
     */
    inprogressCountDetail: (tenant: string, params: RequestParams = {}) =>
      this.request<ApiAccountsAndNotesInProgress, any>({
        path: `/${tenant}/note/inprogress/count`,
        method: 'GET',
        format: 'json',
        ...params
      }),

    /**
     * No description
     *
     * @tags Note
     * @name ChangeBusinessunitCreate
     * @summary Change the business unit id.
     * @request POST:/{tenant}/note/{noteId}/change/businessunit/{newBusinessUnitId}
     */
    changeBusinessunitCreate: (
      noteId: string,
      newBusinessUnitId: string,
      tenant: string,
      params: RequestParams = {}
    ) =>
      this.request<BasicApiResult, string>({
        path: `/${tenant}/note/${noteId}/change/businessunit/${newBusinessUnitId}`,
        method: 'POST',
        format: 'json',
        ...params
      }),

    /**
     * No description
     *
     * @tags Note
     * @name ChangeCounterpartyCreate
     * @summary Change the counterparty id.
     * @request POST:/{tenant}/note/{noteId}/change/counterparty/{newCounterpartyId}
     */
    changeCounterpartyCreate: (
      noteId: string,
      newCounterpartyId: string,
      tenant: string,
      params: RequestParams = {}
    ) =>
      this.request<BasicApiResult, string>({
        path: `/${tenant}/note/${noteId}/change/counterparty/${newCounterpartyId}`,
        method: 'POST',
        format: 'json',
        ...params
      }),

    /**
     * No description
     *
     * @tags Note
     * @name ChangeIscollateralforloanCreate
     * @summary Change the flag that specifies if the note is currently a collateral for a loan.
     * @request POST:/{tenant}/note/{noteId}/change/iscollateralforloan/{isCollateralForLoan}
     */
    changeIscollateralforloanCreate: (
      noteId: string,
      isCollateralForLoan: boolean,
      tenant: string,
      params: RequestParams = {}
    ) =>
      this.request<void, any>({
        path: `/${tenant}/note/${noteId}/change/iscollateralforloan/${isCollateralForLoan}`,
        method: 'POST',
        ...params
      }),

    /**
     * No description
     *
     * @tags Note
     * @name NoteCreate
     * @summary Adds a new note to the system.
     * @request POST:/{tenant}/note
     */
    noteCreate: (tenant: string, data: AddNote, params: RequestParams = {}) =>
      this.request<ApiNote, any>({
        path: `/${tenant}/note`,
        method: 'POST',
        body: data,
        type: ContentType.Json,
        format: 'json',
        ...params
      }),

    /**
     * No description
     *
     * @tags Note
     * @name NoteDetail
     * @summary A command to get all notes.
     * @request GET:/{tenant}/note
     */
    noteDetail: (tenant: string, params: RequestParams = {}) =>
      this.request<ApiNote[], any>({
        path: `/${tenant}/note`,
        method: 'GET',
        format: 'json',
        ...params
      }),

    /**
     * No description
     *
     * @tags Note
     * @name ChangetaxclassificationCreate
     * @summary Changes the note tax classification.
     * @request POST:/{tenant}/note/changetaxclassification/{NoteId}/{NewTaxClassification}
     */
    changetaxclassificationCreate: (
      tenant: string,
      noteId: string,
      newTaxClassification: string,
      data: ChangeNoteApiTaxClassification,
      params: RequestParams = {}
    ) =>
      this.request<ActionResult, any>({
        path: `/${tenant}/note/changetaxclassification/${noteId}/${newTaxClassification}`,
        method: 'POST',
        body: data,
        type: ContentType.Json,
        format: 'json',
        ...params
      }),

    /**
     * No description
     *
     * @tags Note
     * @name CloseDetail
     * @summary A request to close all trades in a note.
     * @request GET:/{tenant}/note/{NoteId}/close
     */
    closeDetail: (noteId: string, tenant: string, params: RequestParams = {}) =>
      this.request<void, any>({
        path: `/${tenant}/note/${noteId}/close`,
        method: 'GET',
        ...params
      }),

    /**
     * No description
     *
     * @tags Note
     * @name BusinessunitDetail2
     * @summary A command to get all notes.
     * @request GET:/{tenant}/note/businessunit/{Id}
     * @originalName businessunitDetail
     * @duplicate
     */
    businessunitDetail2: (id: string, tenant: string, params: RequestParams = {}) =>
      this.request<ApiNote[], any>({
        path: `/${tenant}/note/businessunit/${id}`,
        method: 'GET',
        format: 'json',
        ...params
      }),

    /**
     * No description
     *
     * @tags Note
     * @name DataAccountPendingchangesDetail
     * @summary A request to get  after approving pending changes.
     * @request GET:/{tenant}/note/data/account/{AccountId}/pendingchanges
     */
    dataAccountPendingchangesDetail: (
      accountId: string,
      tenant: string,
      params: RequestParams = {}
    ) =>
      this.request<ApiNoteData, any>({
        path: `/${tenant}/note/data/account/${accountId}/pendingchanges`,
        method: 'GET',
        format: 'json',
        ...params
      }),

    /**
     * No description
     *
     * @tags Note
     * @name DataAccountNewinstructions2Create
     * @summary Gets the note data after instructions.
     * @request POST:/{tenant}/note/data/account/{AccountId}/newinstructions2
     */
    dataAccountNewinstructions2Create: (
      accountId: string,
      tenant: string,
      data: GetApiNoteDataAfterInstructions,
      params: RequestParams = {}
    ) =>
      this.request<ApiNoteData, any>({
        path: `/${tenant}/note/data/account/${accountId}/newinstructions2`,
        method: 'POST',
        body: data,
        type: ContentType.Json,
        format: 'json',
        ...params
      }),

    /**
     * No description
     *
     * @tags Note
     * @name DataNewaccountCreate
     * @summary A request for the  tax classification after new account.
     * @request POST:/{tenant}/note/data/newaccount
     */
    dataNewaccountCreate: (
      tenant: string,
      data: GetApiNoteTaxClassificationAfterNewAccount,
      params: RequestParams = {}
    ) =>
      this.request<ApiNoteData, any>({
        path: `/${tenant}/note/data/newaccount`,
        method: 'POST',
        body: data,
        type: ContentType.Json,
        format: 'json',
        ...params
      }),

    /**
     * No description
     *
     * @tags Performance
     * @name PortfolioBacktestCreate
     * @summary Gets the back-test growth factor timeseries.
     * @request POST:/{tenant}/performance/portfolio/backtest
     */
    portfolioBacktestCreate: (
      tenant: string,
      data: ApiBacktestRequest,
      params: RequestParams = {}
    ) =>
      this.request<ApiBacktestResponse, any>({
        path: `/${tenant}/performance/portfolio/backtest`,
        method: 'POST',
        body: data,
        type: ContentType.Json,
        format: 'json',
        ...params
      }),

    /**
     * No description
     *
     * @tags Performance
     * @name PortfolioProjectionCreate
     * @summary Gets the projection growth factor timeseries.
     * @request POST:/{tenant}/performance/portfolio/projection
     */
    portfolioProjectionCreate: (
      tenant: string,
      data: ApiProjectionRequest,
      params: RequestParams = {}
    ) =>
      this.request<ApiProjectionResponse, any>({
        path: `/${tenant}/performance/portfolio/projection`,
        method: 'POST',
        body: data,
        type: ContentType.Json,
        format: 'json',
        ...params
      }),

    /**
     * No description
     *
     * @tags Performance
     * @name TradeBacktestCreate
     * @summary Gets the trade back test growth factor timeseries.
     * @request POST:/{tenant}/performance/trade/backtest
     */
    tradeBacktestCreate: (
      tenant: string,
      data: ApiTradePerformanceCalculation,
      params: RequestParams = {}
    ) =>
      this.request<ApiTradeBacktestResponse, any>({
        path: `/${tenant}/performance/trade/backtest`,
        method: 'POST',
        body: data,
        type: ContentType.Json,
        format: 'json',
        ...params
      }),

    /**
     * No description
     *
     * @tags Performance
     * @name TradeProjectionCreate
     * @summary Gets the trade projection growth factor timeseries.
     * @request POST:/{tenant}/performance/trade/projection
     */
    tradeProjectionCreate: (
      tenant: string,
      data: ApiTradePerformanceCalculation,
      params: RequestParams = {}
    ) =>
      this.request<ApiProjectionResponse, any>({
        path: `/${tenant}/performance/trade/projection`,
        method: 'POST',
        body: data,
        type: ContentType.Json,
        format: 'json',
        ...params
      }),

    /**
     * No description
     *
     * @tags Portfolio
     * @name PortfolioCreate
     * @summary Adds the model portfolio.
     * @request POST:/{tenant}/portfolio
     */
    portfolioCreate: (tenant: string, data: ApiNewPortfolio, params: RequestParams = {}) =>
      this.request<string, any>({
        path: `/${tenant}/portfolio`,
        method: 'POST',
        body: data,
        type: ContentType.Json,
        format: 'json',
        ...params
      }),

    /**
     * No description
     *
     * @tags Portfolio
     * @name PortfolioUpdate
     * @summary Updates the portfolio.
     * @request PUT:/{tenant}/portfolio
     */
    portfolioUpdate: (tenant: string, data: ApiSavedPortfolio, params: RequestParams = {}) =>
      this.request<void, any>({
        path: `/${tenant}/portfolio`,
        method: 'PUT',
        body: data,
        type: ContentType.Json,
        ...params
      }),

    /**
     * No description
     *
     * @tags Portfolio
     * @name PortfolioDetail
     * @summary Gets all model portfolio.
     * @request GET:/{tenant}/portfolio
     */
    portfolioDetail: (tenant: string, params: RequestParams = {}) =>
      this.request<ApiSavedPortfolio[], any>({
        path: `/${tenant}/portfolio`,
        method: 'GET',
        format: 'json',
        ...params
      }),

    /**
     * No description
     *
     * @tags Portfolio
     * @name MinimalDetail
     * @summary Gets all model portfolios (minimal) for lookups.
     * @request GET:/{tenant}/portfolio/minimal/{businessUnitId}
     */
    minimalDetail: (businessUnitId: string, tenant: string, params: RequestParams = {}) =>
      this.request<ApiModelPortfolioMinimal[], any>({
        path: `/${tenant}/portfolio/minimal/${businessUnitId}`,
        method: 'GET',
        format: 'json',
        ...params
      }),

    /**
     * No description
     *
     * @tags Portfolio
     * @name ListDetail3
     * @summary Gets the model portfolio list.
     * @request GET:/{tenant}/portfolio/list
     * @originalName listDetail
     * @duplicate
     */
    listDetail3: (
      tenant: string,
      query?: {
        WildcardString?: string
        PortfolioStatusFilter?: ApiPortfolioStatusFilter
        PortfolioTypes?: ApiPortfolioType[]
        /** @format int32 */
        PageSize?: number
        /** @format int32 */
        PageNumber?: number
        SortField?: string
        SortAscending?: boolean
      },
      params: RequestParams = {}
    ) =>
      this.request<ApiModelPortfolioApiPaginationResult, any>({
        path: `/${tenant}/portfolio/list`,
        method: 'GET',
        query: query,
        format: 'json',
        ...params
      }),

    /**
     * No description
     *
     * @tags Portfolio
     * @name PortfolioDetail2
     * @summary Gets the model portfolio.
     * @request GET:/{tenant}/portfolio/{modelPortfolioId}
     * @originalName portfolioDetail
     * @duplicate
     */
    portfolioDetail2: (modelPortfolioId: string, tenant: string, params: RequestParams = {}) =>
      this.request<ApiModelPortfolio, any>({
        path: `/${tenant}/portfolio/${modelPortfolioId}`,
        method: 'GET',
        format: 'json',
        ...params
      }),

    /**
     * No description
     *
     * @tags Portfolio
     * @name UsageDetail
     * @summary Gets the model portfolio usage.
     * @request GET:/{tenant}/portfolio/{modelPortfolioId}/usage
     */
    usageDetail: (modelPortfolioId: string, tenant: string, params: RequestParams = {}) =>
      this.request<ApiModelPortfolioUsage, any>({
        path: `/${tenant}/portfolio/${modelPortfolioId}/usage`,
        method: 'GET',
        format: 'json',
        ...params
      }),

    /**
     * No description
     *
     * @tags Portfolio
     * @name CalculatemultiplierCreate
     * @summary Gets the multiplier calculated based on the asset composition of the portfolio.
     * @request POST:/{tenant}/portfolio/calculatemultiplier
     */
    calculatemultiplierCreate: (
      tenant: string,
      data: ApiModelPortfolio | ApiFundOfFundsPortfolio | ApiSelfSelectPortfolio,
      params: RequestParams = {}
    ) =>
      this.request<ApiCalculatedPortfolioMultiplier, any>({
        path: `/${tenant}/portfolio/calculatemultiplier`,
        method: 'POST',
        body: data,
        type: ContentType.Json,
        format: 'json',
        ...params
      }),

    /**
     * No description
     *
     * @tags Portfolio
     * @name ApproveUpdate
     * @summary Approves the model portfolio.
     * @request PUT:/{tenant}/portfolio/{modelPortfolioId}/approve
     */
    approveUpdate: (modelPortfolioId: string, tenant: string, params: RequestParams = {}) =>
      this.request<void, any>({
        path: `/${tenant}/portfolio/${modelPortfolioId}/approve`,
        method: 'PUT',
        ...params
      }),

    /**
     * No description
     *
     * @tags Portfolio
     * @name RejectUpdate
     * @summary Rejects the model portfolio.
     * @request PUT:/{tenant}/portfolio/{modelPortfolioId}/reject
     */
    rejectUpdate: (modelPortfolioId: string, tenant: string, params: RequestParams = {}) =>
      this.request<void, any>({
        path: `/${tenant}/portfolio/${modelPortfolioId}/reject`,
        method: 'PUT',
        ...params
      }),

    /**
     * No description
     *
     * @tags Portfolio
     * @name PortfolioFactSheetDetail
     * @summary Get the fact sheet for the given date.
     * @request GET:/{tenant}/portfolio/{portfolioId}/portfolioFactSheet/{date}
     */
    portfolioFactSheetDetail: (
      portfolioId: string,
      date: string,
      tenant: string,
      params: RequestParams = {}
    ) =>
      this.request<StreamedResult, any>({
        path: `/${tenant}/portfolio/${portfolioId}/portfolioFactSheet/${date}`,
        method: 'GET',
        format: 'json',
        ...params
      }),

    /**
     * No description
     *
     * @tags Portfolio
     * @name PortfolioFactSheetDetail2
     * @summary Get the fact sheet for the last business day of the month.
     * @request GET:/{tenant}/portfolio/{portfolioId}/portfolioFactSheet/{year}/{month}
     * @originalName portfolioFactSheetDetail
     * @duplicate
     */
    portfolioFactSheetDetail2: (
      portfolioId: string,
      year: number,
      month: number,
      tenant: string,
      params: RequestParams = {}
    ) =>
      this.request<StreamedResult, any>({
        path: `/${tenant}/portfolio/${portfolioId}/portfolioFactSheet/${year}/${month}`,
        method: 'GET',
        format: 'json',
        ...params
      }),

    /**
     * No description
     *
     * @tags RiskManagement
     * @name LatestMarketdataFxDetail
     * @summary Get latest FX rates.
     * @request GET:/{tenant}/riskmanagement/latest/marketdata/fx
     */
    latestMarketdataFxDetail: (tenant: string, params: RequestParams = {}) =>
      this.request<ApiFxData[], any>({
        path: `/${tenant}/riskmanagement/latest/marketdata/fx`,
        method: 'GET',
        format: 'json',
        ...params
      }),

    /**
     * No description
     *
     * @tags RiskManagement
     * @name LatestHoldingsreconciliationDetail
     * @summary Get latest holdings reconciliation report.
     * @request GET:/{tenant}/riskmanagement/latest/holdingsreconciliation
     */
    latestHoldingsreconciliationDetail: (tenant: string, params: RequestParams = {}) =>
      this.request<HoldingReconciliationReport, any>({
        path: `/${tenant}/riskmanagement/latest/holdingsreconciliation`,
        method: 'GET',
        format: 'json',
        ...params
      }),

    /**
     * No description
     *
     * @tags RiskManagement
     * @name HoldingsreconciliationDetail
     * @summary Get holdings reconciliation report for a specific date.
     * @request GET:/{tenant}/riskmanagement/{date}/holdingsreconciliation
     */
    holdingsreconciliationDetail: (date: string, tenant: string, params: RequestParams = {}) =>
      this.request<HoldingReconciliationReport, any>({
        path: `/${tenant}/riskmanagement/${date}/holdingsreconciliation`,
        method: 'GET',
        format: 'json',
        ...params
      }),

    /**
     * No description
     *
     * @tags RiskManagement
     * @name LatestAssetconcentrationDetail
     * @summary Get latest asset concentration report.
     * @request GET:/{tenant}/riskmanagement/latest/assetconcentration
     */
    latestAssetconcentrationDetail: (tenant: string, params: RequestParams = {}) =>
      this.request<AssetConcentrationReport, any>({
        path: `/${tenant}/riskmanagement/latest/assetconcentration`,
        method: 'GET',
        format: 'json',
        ...params
      }),

    /**
     * No description
     *
     * @tags RiskManagement
     * @name AssetconcentrationDetail
     * @summary Get asset concentration report for a specific date.
     * @request GET:/{tenant}/riskmanagement/{date}/assetconcentration
     */
    assetconcentrationDetail: (date: string, tenant: string, params: RequestParams = {}) =>
      this.request<AssetConcentrationReport, any>({
        path: `/${tenant}/riskmanagement/${date}/assetconcentration`,
        method: 'GET',
        format: 'json',
        ...params
      }),

    /**
     * No description
     *
     * @tags RiskManagement
     * @name LatestMaxdrawdownDetail
     * @summary Get latest max drawdown report.
     * @request GET:/{tenant}/riskmanagement/latest/maxdrawdown
     */
    latestMaxdrawdownDetail: (tenant: string, params: RequestParams = {}) =>
      this.request<MaxDrawdownReport, any>({
        path: `/${tenant}/riskmanagement/latest/maxdrawdown`,
        method: 'GET',
        format: 'json',
        ...params
      }),

    /**
     * No description
     *
     * @tags RiskManagement
     * @name MaxdrawdownDetail
     * @summary Get max drawdown report for specific date.
     * @request GET:/{tenant}/riskmanagement/{date}/maxdrawdown
     */
    maxdrawdownDetail: (date: string, tenant: string, params: RequestParams = {}) =>
      this.request<MaxDrawdownReport, any>({
        path: `/${tenant}/riskmanagement/${date}/maxdrawdown`,
        method: 'GET',
        format: 'json',
        ...params
      }),

    /**
     * No description
     *
     * @tags RiskManagement
     * @name GapriskinfoDetail
     * @summary Get the gap risk info for a trade.
     * @request GET:/{tenant}/riskmanagement/{tradeId}/gapriskinfo
     */
    gapriskinfoDetail: (tradeId: string, tenant: string, params: RequestParams = {}) =>
      this.request<ApiGapRiskInfo, any>({
        path: `/${tenant}/riskmanagement/${tradeId}/gapriskinfo`,
        method: 'GET',
        format: 'json',
        ...params
      }),

    /**
     * No description
     *
     * @tags RiskManagement
     * @name LatestAssetspricesDetail
     * @summary Get latest asset prices.
     * @request GET:/{tenant}/riskmanagement/latest/assetsprices
     */
    latestAssetspricesDetail: (tenant: string, params: RequestParams = {}) =>
      this.request<ApiAssetPriceWithHistory[], any>({
        path: `/${tenant}/riskmanagement/latest/assetsprices`,
        method: 'GET',
        format: 'json',
        ...params
      }),

    /**
     * No description
     *
     * @tags RiskManagement
     * @name AssetpriceoverrideinfoDetail
     * @summary Get asset override info.
     * @request GET:/{tenant}/riskmanagement/assetpriceoverrideinfo
     */
    assetpriceoverrideinfoDetail: (tenant: string, params: RequestParams = {}) =>
      this.request<ApiOverrideInfo, any>({
        path: `/${tenant}/riskmanagement/assetpriceoverrideinfo`,
        method: 'GET',
        format: 'json',
        ...params
      }),

    /**
     * No description
     *
     * @tags RiskManagement
     * @name UploadmarketdatasetCreate
     * @summary Uploads a market data set.
     * @request POST:/{tenant}/riskmanagement/uploadmarketdataset
     */
    uploadmarketdatasetCreate: (
      tenant: string,
      data: ApiMarketDataSet,
      params: RequestParams = {}
    ) =>
      this.request<void, any>({
        path: `/${tenant}/riskmanagement/uploadmarketdataset`,
        method: 'POST',
        body: data,
        type: ContentType.Json,
        ...params
      }),

    /**
     * No description
     *
     * @tags RiskManagement
     * @name MarketdatasetsDetail
     * @summary Returns the market data sets created in a specific time window.
     * @request GET:/{tenant}/riskmanagement/marketdatasets
     */
    marketdatasetsDetail: (
      tenant: string,
      data: ApiMarketDataSetRequest,
      params: RequestParams = {}
    ) =>
      this.request<ApiMarketDataSet[], any>({
        path: `/${tenant}/riskmanagement/marketdatasets`,
        method: 'GET',
        body: data,
        type: ContentType.Json,
        format: 'json',
        ...params
      }),

    /**
     * No description
     *
     * @tags RiskManagement
     * @name AssetpriceoverrideCreate
     * @summary Adds an asset price override.
     * @request POST:/{tenant}/riskmanagement/assetpriceoverride
     */
    assetpriceoverrideCreate: (
      tenant: string,
      data: ApiAssetPriceUserOverride,
      params: RequestParams = {}
    ) =>
      this.request<ApiOverridenAssetPrice, any>({
        path: `/${tenant}/riskmanagement/assetpriceoverride`,
        method: 'POST',
        body: data,
        type: ContentType.Json,
        format: 'json',
        ...params
      }),

    /**
     * No description
     *
     * @tags RiskManagement
     * @name AssetConstituentsDetail
     * @summary Get all assets with their constituent assets.
     * @request GET:/{tenant}/riskmanagement/asset/constituents
     */
    assetConstituentsDetail: (tenant: string, params: RequestParams = {}) =>
      this.request<ApiAssetWithConstituents[], any>({
        path: `/${tenant}/riskmanagement/asset/constituents`,
        method: 'GET',
        format: 'json',
        ...params
      }),

    /**
     * No description
     *
     * @tags RiskManagement
     * @name ExportDetail
     * @summary Gets the latest risk management export.
     * @request GET:/{tenant}/riskmanagement/export
     */
    exportDetail: (tenant: string, params: RequestParams = {}) =>
      this.request<File, any>({
        path: `/${tenant}/riskmanagement/export`,
        method: 'GET',
        format: 'json',
        ...params
      }),

    /**
     * No description
     *
     * @tags RiskManagement
     * @name ExportHoldingsreportDetail
     * @summary Gets the latest holdings export.
     * @request GET:/{tenant}/riskmanagement/export/holdingsreport
     */
    exportHoldingsreportDetail: (tenant: string, params: RequestParams = {}) =>
      this.request<File, any>({
        path: `/${tenant}/riskmanagement/export/holdingsreport`,
        method: 'GET',
        format: 'json',
        ...params
      }),

    /**
     * No description
     *
     * @tags RiskManagement
     * @name ExportStaticDetail
     * @summary Gets the static data export.
     * @request GET:/{tenant}/riskmanagement/export/static
     */
    exportStaticDetail: (tenant: string, params: RequestParams = {}) =>
      this.request<File, any>({
        path: `/${tenant}/riskmanagement/export/static`,
        method: 'GET',
        format: 'json',
        ...params
      }),

    /**
     * No description
     *
     * @tags RiskManagement
     * @name LatestMarketdatasnapshotDetail
     * @summary Get latest market data snapshot.
     * @request GET:/{tenant}/riskmanagement/latest/marketdatasnapshot
     */
    latestMarketdatasnapshotDetail: (tenant: string, params: RequestParams = {}) =>
      this.request<ApiMarketDataSnapshot, any>({
        path: `/${tenant}/riskmanagement/latest/marketdatasnapshot`,
        method: 'GET',
        format: 'json',
        ...params
      }),

    /**
     * No description
     *
     * @tags RiskManagement
     * @name MarketdatasnapshotDetail
     * @summary Get market data snapshot for a specific date.
     * @request GET:/{tenant}/riskmanagement/{date}/marketdatasnapshot
     */
    marketdatasnapshotDetail: (date: string, tenant: string, params: RequestParams = {}) =>
      this.request<ApiMarketDataSnapshot, any>({
        path: `/${tenant}/riskmanagement/${date}/marketdatasnapshot`,
        method: 'GET',
        format: 'json',
        ...params
      }),

    /**
     * No description
     *
     * @tags RiskManagement
     * @name ClientgappaymentsDetail
     * @summary Gets the client gap payments for date.
     * @request GET:/{tenant}/riskmanagement/{date}/clientgappayments
     */
    clientgappaymentsDetail: (date: string, tenant: string, params: RequestParams = {}) =>
      this.request<ApiGapPayments[], any>({
        path: `/${tenant}/riskmanagement/${date}/clientgappayments`,
        method: 'GET',
        format: 'json',
        ...params
      }),

    /**
     * No description
     *
     * @tags RiskManagement
     * @name LatestHoldingstransferbalancesreconciliationDetail
     * @summary Get the latest holdings and transfer balances reconciliation.
     * @request GET:/{tenant}/riskmanagement/latest/holdingstransferbalancesreconciliation
     */
    latestHoldingstransferbalancesreconciliationDetail: (
      tenant: string,
      params: RequestParams = {}
    ) =>
      this.request<HoldingsAndTransferBalancesReconciliation, any>({
        path: `/${tenant}/riskmanagement/latest/holdingstransferbalancesreconciliation`,
        method: 'GET',
        format: 'json',
        ...params
      }),

    /**
     * No description
     *
     * @tags Scenario
     * @name ConfigurationAllassetsladderCreate
     * @summary Saves the configuration for the all assets ladder scenario.
     * @request POST:/{tenant}/scenarios/configuration/allassetsladder
     */
    configurationAllassetsladderCreate: (
      tenant: string,
      data: AllAssetsLadderScenarioConfiguration,
      params: RequestParams = {}
    ) =>
      this.request<void, any>({
        path: `/${tenant}/scenarios/configuration/allassetsladder`,
        method: 'POST',
        body: data,
        type: ContentType.Json,
        ...params
      }),

    /**
     * No description
     *
     * @tags Scenario
     * @name LatestAllassetsladderDetail
     * @summary Return an all assets ladder scenario analysis result.
     * @request GET:/{tenant}/scenarios/latest/allassetsladder
     */
    latestAllassetsladderDetail: (tenant: string, params: RequestParams = {}) =>
      this.request<AllAssetsLadderScenarioResult, any>({
        path: `/${tenant}/scenarios/latest/allassetsladder`,
        method: 'GET',
        format: 'json',
        ...params
      }),

    /**
     * No description
     *
     * @tags Scenario
     * @name ConfigurationSingleassetladderCreate
     * @summary Saves the configuration for the single asset ladder scenario.
     * @request POST:/{tenant}/scenarios/configuration/singleassetladder
     */
    configurationSingleassetladderCreate: (
      tenant: string,
      data: SingleAssetLadderScenarioConfiguration,
      params: RequestParams = {}
    ) =>
      this.request<void, any>({
        path: `/${tenant}/scenarios/configuration/singleassetladder`,
        method: 'POST',
        body: data,
        type: ContentType.Json,
        ...params
      }),

    /**
     * No description
     *
     * @tags Scenario
     * @name LatestSingleassetladderDetail
     * @summary Return a single asset ladder scenario analysis result.
     * @request GET:/{tenant}/scenarios/latest/singleassetladder
     */
    latestSingleassetladderDetail: (tenant: string, params: RequestParams = {}) =>
      this.request<SingleAssetLadderScenarioResult, any>({
        path: `/${tenant}/scenarios/latest/singleassetladder`,
        method: 'GET',
        format: 'json',
        ...params
      }),

    /**
     * No description
     *
     * @tags Scenario
     * @name ConfigurationSingleassetdrawdownCreate
     * @summary Saves the configuration for the single asset drawdown scenario.
     * @request POST:/{tenant}/scenarios/configuration/singleassetdrawdown
     */
    configurationSingleassetdrawdownCreate: (
      tenant: string,
      data: SingleAssetDrawdownScenarioConfiguration,
      params: RequestParams = {}
    ) =>
      this.request<void, any>({
        path: `/${tenant}/scenarios/configuration/singleassetdrawdown`,
        method: 'POST',
        body: data,
        type: ContentType.Json,
        ...params
      }),

    /**
     * No description
     *
     * @tags Scenario
     * @name LatestSingleassetdrawdownDetail
     * @summary Return a single asset drawdown scenario analysis result.
     * @request GET:/{tenant}/scenarios/latest/singleassetdrawdown
     */
    latestSingleassetdrawdownDetail: (tenant: string, params: RequestParams = {}) =>
      this.request<SingleAssetDrawdownScenarioResult, any>({
        path: `/${tenant}/scenarios/latest/singleassetdrawdown`,
        method: 'GET',
        format: 'json',
        ...params
      }),

    /**
     * No description
     *
     * @tags Scenario
     * @name ConfigurationFundmanagerladderCreate
     * @summary Saves the configuration for the fund manager ladder scenario.
     * @request POST:/{tenant}/scenarios/configuration/fundmanagerladder
     */
    configurationFundmanagerladderCreate: (
      tenant: string,
      data: FundManagerLadderScenarioConfiguration,
      params: RequestParams = {}
    ) =>
      this.request<void, any>({
        path: `/${tenant}/scenarios/configuration/fundmanagerladder`,
        method: 'POST',
        body: data,
        type: ContentType.Json,
        ...params
      }),

    /**
     * No description
     *
     * @tags Scenario
     * @name LatestFundmanagerladderDetail
     * @summary Return a fund manager ladder scenario analysis result.
     * @request GET:/{tenant}/scenarios/latest/fundmanagerladder
     */
    latestFundmanagerladderDetail: (tenant: string, params: RequestParams = {}) =>
      this.request<FundManagerLadderScenarioResult, any>({
        path: `/${tenant}/scenarios/latest/fundmanagerladder`,
        method: 'GET',
        format: 'json',
        ...params
      }),

    /**
     * No description
     *
     * @tags Scenario
     * @name ConfigurationFundmanagerdrawdownCreate
     * @summary Saves the configuration for the single asset drawdown scenario.
     * @request POST:/{tenant}/scenarios/configuration/fundmanagerdrawdown
     */
    configurationFundmanagerdrawdownCreate: (
      tenant: string,
      data: FundManagerDrawdownScenarioConfiguration,
      params: RequestParams = {}
    ) =>
      this.request<void, any>({
        path: `/${tenant}/scenarios/configuration/fundmanagerdrawdown`,
        method: 'POST',
        body: data,
        type: ContentType.Json,
        ...params
      }),

    /**
     * No description
     *
     * @tags Scenario
     * @name LatestFundmanagerdrawdownDetail
     * @summary Return a single asset drawdown scenario analysis result.
     * @request GET:/{tenant}/scenarios/latest/fundmanagerdrawdown
     */
    latestFundmanagerdrawdownDetail: (tenant: string, params: RequestParams = {}) =>
      this.request<FundManagerDrawdownScenarioResult, any>({
        path: `/${tenant}/scenarios/latest/fundmanagerdrawdown`,
        method: 'GET',
        format: 'json',
        ...params
      }),

    /**
     * No description
     *
     * @tags Scenario
     * @name ConfigurationCustomassetCreate
     * @summary Saves the configuration for the custom asset scenario.
     * @request POST:/{tenant}/scenarios/configuration/customasset
     */
    configurationCustomassetCreate: (
      tenant: string,
      data: CustomAssetScenarioConfiguration,
      params: RequestParams = {}
    ) =>
      this.request<void, any>({
        path: `/${tenant}/scenarios/configuration/customasset`,
        method: 'POST',
        body: data,
        type: ContentType.Json,
        ...params
      }),

    /**
     * No description
     *
     * @tags Scenario
     * @name LatestCustomassetDetail
     * @summary Return a custom asset scenario analysis result.
     * @request GET:/{tenant}/scenarios/latest/customasset
     */
    latestCustomassetDetail: (tenant: string, params: RequestParams = {}) =>
      this.request<CustomAssetScenarioResult, any>({
        path: `/${tenant}/scenarios/latest/customasset`,
        method: 'GET',
        format: 'json',
        ...params
      }),

    /**
     * No description
     *
     * @tags Scenario
     * @name ConfigurationCustomfundmanagerCreate
     * @summary Saves the configuration for the custom fund manager scenario.
     * @request POST:/{tenant}/scenarios/configuration/customfundmanager
     */
    configurationCustomfundmanagerCreate: (
      tenant: string,
      data: CustomFundManagerScenarioConfiguration,
      params: RequestParams = {}
    ) =>
      this.request<void, any>({
        path: `/${tenant}/scenarios/configuration/customfundmanager`,
        method: 'POST',
        body: data,
        type: ContentType.Json,
        ...params
      }),

    /**
     * No description
     *
     * @tags Scenario
     * @name LatestCustomfundmanagerDetail
     * @summary Return a custom fund manager scenario analysis result.
     * @request GET:/{tenant}/scenarios/latest/customfundmanager
     */
    latestCustomfundmanagerDetail: (tenant: string, params: RequestParams = {}) =>
      this.request<CustomFundManagerScenarioResult, any>({
        path: `/${tenant}/scenarios/latest/customfundmanager`,
        method: 'GET',
        format: 'json',
        ...params
      }),

    /**
     * No description
     *
     * @tags StaticData
     * @name FeetypeDetail
     * @summary Gets all fee types.
     * @request GET:/{tenant}/static/feetype
     */
    feetypeDetail: (tenant: string, params: RequestParams = {}) =>
      this.request<string[], any>({
        path: `/${tenant}/static/feetype`,
        method: 'GET',
        format: 'json',
        ...params
      }),

    /**
     * No description
     *
     * @tags StaticData
     * @name FeedeductionfrequencyDetail
     * @summary Gets all fee deduction frequencies.
     * @request GET:/{tenant}/static/feedeductionfrequency
     */
    feedeductionfrequencyDetail: (tenant: string, params: RequestParams = {}) =>
      this.request<string[], any>({
        path: `/${tenant}/static/feedeductionfrequency`,
        method: 'GET',
        format: 'json',
        ...params
      }),

    /**
     * No description
     *
     * @tags StaticData
     * @name FeebasisDetail
     * @summary Gets all fee basis.
     * @request GET:/{tenant}/static/feebasis
     */
    feebasisDetail: (tenant: string, params: RequestParams = {}) =>
      this.request<string[], any>({
        path: `/${tenant}/static/feebasis`,
        method: 'GET',
        format: 'json',
        ...params
      }),

    /**
     * No description
     *
     * @tags StaticData
     * @name FeedaycountDetail
     * @summary Gets all fee day counts.
     * @request GET:/{tenant}/static/feedaycount
     */
    feedaycountDetail: (tenant: string, params: RequestParams = {}) =>
      this.request<string[], any>({
        path: `/${tenant}/static/feedaycount`,
        method: 'GET',
        format: 'json',
        ...params
      }),

    /**
     * No description
     *
     * @tags StaticData
     * @name CashinstrumentreferenceratesDetail
     * @summary Gets all Cash Instrument Reference Rates.
     * @request GET:/{tenant}/static/cashinstrumentreferencerates
     */
    cashinstrumentreferenceratesDetail: (tenant: string, params: RequestParams = {}) =>
      this.request<string[], any>({
        path: `/${tenant}/static/cashinstrumentreferencerates`,
        method: 'GET',
        format: 'json',
        ...params
      }),

    /**
     * No description
     *
     * @tags StaticData
     * @name AssetclassesDetail
     * @summary Gets all Asset Classes.
     * @request GET:/{tenant}/static/assetclasses
     */
    assetclassesDetail: (tenant: string, params: RequestParams = {}) =>
      this.request<string[], any>({
        path: `/${tenant}/static/assetclasses`,
        method: 'GET',
        format: 'json',
        ...params
      }),

    /**
     * No description
     *
     * @tags StaticData
     * @name CurrenciesDetail
     * @summary Gets all Currencies.
     * @request GET:/{tenant}/static/currencies
     */
    currenciesDetail: (tenant: string, params: RequestParams = {}) =>
      this.request<string[], any>({
        path: `/${tenant}/static/currencies`,
        method: 'GET',
        format: 'json',
        ...params
      }),

    /**
     * No description
     *
     * @tags StaticData
     * @name BusinessdatesDetail
     * @summary All the business dates between two dates.
     * @request GET:/{tenant}/static/businessdates/{from}/{to}
     */
    businessdatesDetail: (from: string, to: string, tenant: string, params: RequestParams = {}) =>
      this.request<string[], any>({
        path: `/${tenant}/static/businessdates/${from}/${to}`,
        method: 'GET',
        format: 'json',
        ...params
      }),

    /**
     * No description
     *
     * @tags Strategy
     * @name StrategyCreate
     * @summary Adds (or updates) the strategy template.
     * @request POST:/{tenant}/strategy
     */
    strategyCreate: (tenant: string, data: ApiNewStrategyTemplate, params: RequestParams = {}) =>
      this.request<string, any>({
        path: `/${tenant}/strategy`,
        method: 'POST',
        body: data,
        type: ContentType.Json,
        format: 'json',
        ...params
      }),

    /**
     * No description
     *
     * @tags Strategy
     * @name StrategyUpdate
     * @summary Updates the strategy template.
     * @request PUT:/{tenant}/strategy
     */
    strategyUpdate: (tenant: string, data: ApiStrategyTemplate, params: RequestParams = {}) =>
      this.request<string, any>({
        path: `/${tenant}/strategy`,
        method: 'PUT',
        body: data,
        type: ContentType.Json,
        format: 'json',
        ...params
      }),

    /**
     * No description
     *
     * @tags Strategy
     * @name StrategyDetail
     * @summary Gets all strategy templates.
     * @request GET:/{tenant}/strategy
     */
    strategyDetail: (tenant: string, params: RequestParams = {}) =>
      this.request<ApiStrategyTemplate[], any>({
        path: `/${tenant}/strategy`,
        method: 'GET',
        format: 'json',
        ...params
      }),

    /**
     * No description
     *
     * @tags TenantConfiguration
     * @name TradeDetail
     * @summary Get the trade configuration.
     * @request GET:/{tenant}/configuration/trade
     */
    tradeDetail: (tenant: string, params: RequestParams = {}) =>
      this.request<TradeConfiguration, any>({
        path: `/${tenant}/configuration/trade`,
        method: 'GET',
        format: 'json',
        ...params
      }),

    /**
     * No description
     *
     * @tags TenantConfiguration
     * @name SchedulingDetail
     * @summary Get the scheduling configuration.
     * @request GET:/{tenant}/configuration/scheduling
     */
    schedulingDetail: (tenant: string, params: RequestParams = {}) =>
      this.request<SchedulingConfiguration, any>({
        path: `/${tenant}/configuration/scheduling`,
        method: 'GET',
        format: 'json',
        ...params
      }),

    /**
     * No description
     *
     * @tags TenantConfiguration
     * @name GetTenant2
     * @summary Get the trade configuration.
     * @request GET:/{tenant}/configuration/ui
     * @originalName getTenant
     * @duplicate
     */
    getTenant2: (tenant: string, params: RequestParams = {}) =>
      this.request<TradeConfiguration, any>({
        path: `/${tenant}/configuration/ui`,
        method: 'GET',
        format: 'json',
        ...params
      }),

    /**
     * No description
     *
     * @tags TenantConfiguration
     * @name TradeValuationcycleoverrideDetail
     * @summary Get the valuation cycle override configuration parameter.
     * @request GET:/{tenant}/configuration/trade/valuationcycleoverride
     */
    tradeValuationcycleoverrideDetail: (tenant: string, params: RequestParams = {}) =>
      this.request<string, any>({
        path: `/${tenant}/configuration/trade/valuationcycleoverride`,
        method: 'GET',
        format: 'json',
        ...params
      }),

    /**
     * No description
     *
     * @tags TenantConfiguration
     * @name TradeValuationsnapCurrentDetail
     * @summary Returns the current valuation cycle.
     * @request GET:/{tenant}/configuration/trade/valuationsnap/current
     */
    tradeValuationsnapCurrentDetail: (tenant: string, params: RequestParams = {}) =>
      this.request<string, any>({
        path: `/${tenant}/configuration/trade/valuationsnap/current`,
        method: 'GET',
        format: 'json',
        ...params
      }),

    /**
     * No description
     *
     * @tags TenantConfiguration
     * @name TradeValuationcycleCurrentDetail
     * @summary Returns the current valuation cycle.
     * @request GET:/{tenant}/configuration/trade/valuationcycle/current
     */
    tradeValuationcycleCurrentDetail: (tenant: string, params: RequestParams = {}) =>
      this.request<string, any>({
        path: `/${tenant}/configuration/trade/valuationcycle/current`,
        method: 'GET',
        format: 'json',
        ...params
      }),

    /**
     * No description
     *
     * @tags TenantConfiguration
     * @name TradeValuationcyclePreviousDetail
     * @summary Returns the previous valuation cycle
     * @request GET:/{tenant}/configuration/trade/valuationcycle/previous
     */
    tradeValuationcyclePreviousDetail: (tenant: string, params: RequestParams = {}) =>
      this.request<string, any>({
        path: `/${tenant}/configuration/trade/valuationcycle/previous`,
        method: 'GET',
        format: 'json',
        ...params
      }),

    /**
     * No description
     *
     * @tags TenantConfiguration
     * @name TradeValuationsnapandcycleoverrideUnsetCreate
     * @summary Unset the valuation cycle override parameter.
     * @request POST:/{tenant}/configuration/trade/valuationsnapandcycleoverride/unset
     */
    tradeValuationsnapandcycleoverrideUnsetCreate: (tenant: string, params: RequestParams = {}) =>
      this.request<ApiTradeConfiguration, any>({
        path: `/${tenant}/configuration/trade/valuationsnapandcycleoverride/unset`,
        method: 'POST',
        format: 'json',
        ...params
      }),

    /**
     * No description
     *
     * @tags TenantConfiguration
     * @name TradeValuationsnapoverrideDetail
     * @summary Get the valuation snap override configuration parameter.
     * @request GET:/{tenant}/configuration/trade/valuationsnapoverride
     */
    tradeValuationsnapoverrideDetail: (tenant: string, params: RequestParams = {}) =>
      this.request<string, any>({
        path: `/${tenant}/configuration/trade/valuationsnapoverride`,
        method: 'GET',
        format: 'json',
        ...params
      }),

    /**
     * No description
     *
     * @tags TenantConfiguration
     * @name TradeValuationsnapoverrideSetCreate
     * @summary Set the valuation snap override parameter.
     * @request POST:/{tenant}/configuration/trade/valuationsnapoverride/set/{valuationSnap}
     */
    tradeValuationsnapoverrideSetCreate: (
      valuationSnap: string,
      tenant: string,
      params: RequestParams = {}
    ) =>
      this.request<ApiTimeOverrideStatus, any>({
        path: `/${tenant}/configuration/trade/valuationsnapoverride/set/${valuationSnap}`,
        method: 'POST',
        format: 'json',
        ...params
      }),

    /**
     * No description
     *
     * @tags TenantConfiguration
     * @name TradeEnableCreate
     * @summary Enable valuation for this trade.
     * @request POST:/{tenant}/configuration/trade/enable
     */
    tradeEnableCreate: (tenant: string, params: RequestParams = {}) =>
      this.request<TradeConfiguration, any>({
        path: `/${tenant}/configuration/trade/enable`,
        method: 'POST',
        format: 'json',
        ...params
      }),

    /**
     * No description
     *
     * @tags TenantConfiguration
     * @name TradeDisableCreate
     * @summary Disable valuation for this trade.
     * @request POST:/{tenant}/configuration/trade/disable
     */
    tradeDisableCreate: (tenant: string, params: RequestParams = {}) =>
      this.request<TradeConfiguration, any>({
        path: `/${tenant}/configuration/trade/disable`,
        method: 'POST',
        format: 'json',
        ...params
      }),

    /**
     * No description
     *
     * @tags TenantConfiguration
     * @name GraphEnableCreate
     * @summary Enable calculation graph for this trade.
     * @request POST:/{tenant}/configuration/graph/enable
     */
    graphEnableCreate: (tenant: string, params: RequestParams = {}) =>
      this.request<TradeConfiguration, any>({
        path: `/${tenant}/configuration/graph/enable`,
        method: 'POST',
        format: 'json',
        ...params
      }),

    /**
     * No description
     *
     * @tags TenantConfiguration
     * @name GraphDisableCreate
     * @summary Disable calculation graph for this trade.
     * @request POST:/{tenant}/configuration/graph/disable
     */
    graphDisableCreate: (tenant: string, params: RequestParams = {}) =>
      this.request<SchedulingConfiguration, any>({
        path: `/${tenant}/configuration/graph/disable`,
        method: 'POST',
        format: 'json',
        ...params
      }),

    /**
     * No description
     *
     * @tags TenantConfiguration
     * @name CleanupEnableCreate
     * @summary Enable valuation for this trade.
     * @request POST:/{tenant}/configuration/cleanup/enable
     */
    cleanupEnableCreate: (tenant: string, params: RequestParams = {}) =>
      this.request<TradeConfiguration, any>({
        path: `/${tenant}/configuration/cleanup/enable`,
        method: 'POST',
        format: 'json',
        ...params
      }),

    /**
     * No description
     *
     * @tags TenantConfiguration
     * @name CleanupDisableCreate
     * @summary Disable valuation for this trade.
     * @request POST:/{tenant}/configuration/cleanup/disable
     */
    cleanupDisableCreate: (tenant: string, params: RequestParams = {}) =>
      this.request<TradeConfiguration, any>({
        path: `/${tenant}/configuration/cleanup/disable`,
        method: 'POST',
        format: 'json',
        ...params
      }),

    /**
     * No description
     *
     * @tags TenantConfiguration
     * @name ReconciliationDetail
     * @summary Get the reconciliation configuration.
     * @request GET:/{tenant}/configuration/reconciliation
     */
    reconciliationDetail: (tenant: string, params: RequestParams = {}) =>
      this.request<ReconciliationConfiguration, any>({
        path: `/${tenant}/configuration/reconciliation`,
        method: 'GET',
        format: 'json',
        ...params
      }),

    /**
     * No description
     *
     * @tags TenantConfiguration
     * @name ReconciliationUpdateCreate
     * @summary Update the reconciliation configuration.
     * @request POST:/{tenant}/configuration/reconciliation/update
     */
    reconciliationUpdateCreate: (
      tenant: string,
      data: ApiReconciliationConfiguration,
      params: RequestParams = {}
    ) =>
      this.request<ReconciliationConfiguration, any>({
        path: `/${tenant}/configuration/reconciliation/update`,
        method: 'POST',
        body: data,
        type: ContentType.Json,
        format: 'json',
        ...params
      }),

    /**
     * No description
     *
     * @tags TenantConfiguration
     * @name FinswitchIsocurrencycodesEnableCreate
     * @summary Enable ISO 4217 currency codes in the FinSwitch TR file (Column Q) for this tenant.
     * @request POST:/{tenant}/configuration/finswitch/isocurrencycodes/enable
     */
    finswitchIsocurrencycodesEnableCreate: (tenant: string, params: RequestParams = {}) =>
      this.request<boolean, any>({
        path: `/${tenant}/configuration/finswitch/isocurrencycodes/enable`,
        method: 'POST',
        format: 'json',
        ...params
      }),

    /**
     * No description
     *
     * @tags TenantConfiguration
     * @name FinswitchIsocurrencycodesDisableCreate
     * @summary Disable ISO 4217 currency codes in the FinSwitch TR file, reverting to FinSwitch's legacy codes.
     * @request POST:/{tenant}/configuration/finswitch/isocurrencycodes/disable
     */
    finswitchIsocurrencycodesDisableCreate: (tenant: string, params: RequestParams = {}) =>
      this.request<boolean, any>({
        path: `/${tenant}/configuration/finswitch/isocurrencycodes/disable`,
        method: 'POST',
        format: 'json',
        ...params
      }),

    /**
     * No description
     *
     * @tags TenantConfiguration
     * @name TradeNoteDefaultsCreate
     * @summary Sets the note configuration defaults.
     * @request POST:/{tenant}/configuration/trade/note/defaults
     */
    tradeNoteDefaultsCreate: (
      tenant: string,
      query?: {
        CounterPartyIds?: string[]
      },
      params: RequestParams = {}
    ) =>
      this.request<TradeConfiguration, any>({
        path: `/${tenant}/configuration/trade/note/defaults`,
        method: 'POST',
        query: query,
        format: 'json',
        ...params
      }),

    /**
     * No description
     *
     * @tags TenantConfiguration
     * @name TradeAssetDefaultsCreate
     * @summary Sets the asset configuration defaults.
     * @request POST:/{tenant}/configuration/trade/asset/defaults
     */
    tradeAssetDefaultsCreate: (
      tenant: string,
      query?: {
        Fees?: ApiFee[]
        AssetClasses?: string[]
        Currencies?: string[]
      },
      params: RequestParams = {}
    ) =>
      this.request<TradeConfiguration, any>({
        path: `/${tenant}/configuration/trade/asset/defaults`,
        method: 'POST',
        query: query,
        format: 'json',
        ...params
      }),

    /**
     * No description
     *
     * @tags TenantConfiguration
     * @name TradeIdentifierConfigurationCreate
     * @summary Set the valuation cycle override parameter.
     * @request POST:/{tenant}/configuration/trade/identifier/configuration
     */
    tradeIdentifierConfigurationCreate: (
      tenant: string,
      query?: {
        'AccountSettings.IdPrefix'?: string
        /** @format int32 */
        'AccountSettings.IdPaddingLength'?: number
        /** @format int32 */
        'AccountSettings.NextId'?: number
        /** @format date-time */
        'AccountSettings.LastUpdateTime'?: string
        'PortfolioSettings.IdPrefix'?: string
        /** @format int32 */
        'PortfolioSettings.IdPaddingLength'?: number
        /** @format int32 */
        'PortfolioSettings.NextId'?: number
        /** @format date-time */
        'PortfolioSettings.LastUpdateTime'?: string
        'NoteSettings.IdPrefix'?: string
        /** @format int32 */
        'NoteSettings.IdPaddingLength'?: number
        /** @format int32 */
        'NoteSettings.NextId'?: number
        /** @format date-time */
        'NoteSettings.LastUpdateTime'?: string
      },
      params: RequestParams = {}
    ) =>
      this.request<TradeConfiguration, any>({
        path: `/${tenant}/configuration/trade/identifier/configuration`,
        method: 'POST',
        query: query,
        format: 'json',
        ...params
      }),

    /**
     * No description
     *
     * @tags ValuationIndex
     * @name GetIndexStatus
     * @summary Get the status of a valuation index.
     * @request GET:/{tenant}/v/index/{date}/status
     */
    getIndexStatus: (date: string, tenant: string, params: RequestParams = {}) =>
      this.request<ValuationIndexStatus, any>({
        path: `/${tenant}/v/index/${date}/status`,
        method: 'GET',
        format: 'json',
        ...params
      }),

    /**
     * No description
     *
     * @tags ValuationIndex
     * @name RestoreObsoleteBlockChain
     * @summary Attempts to manually move a chain of valuations from the obsolete block repository from the last state root requested.
     * @request POST:/{tenant}/v/index/obsolete/restore/{base58StateRootAddress}
     */
    restoreObsoleteBlockChain: (
      base58StateRootAddress: string,
      tenant: string,
      params: RequestParams = {}
    ) =>
      this.request<void, any>({
        path: `/${tenant}/v/index/obsolete/restore/{base58StateRootAddress}`,
        method: 'POST',
        ...params
      }),

    /**
     * No description
     *
     * @tags ValuationReporting
     * @name GetReportingStatus
     * @summary Get the status of a valuation index.
     * @request GET:/{tenant}/r/index/{date}/{reportType}/status
     */
    getReportingStatus: (
      date: string,
      reportType: string,
      tenant: string,
      params: RequestParams = {}
    ) =>
      this.request<ValuationReportingStatus, any>({
        path: `/${tenant}/r/index/${date}/${reportType}/status`,
        method: 'GET',
        format: 'json',
        ...params
      })
  }
  system = {
    /**
     * No description
     *
     * @tags Audit
     * @name AuditAfterDetail
     * @summary Audits the logs after.
     * @request GET:/system/audit/after/{date}
     */
    auditAfterDetail: (date: string, params: RequestParams = {}) =>
      this.request<AuditLog[], any>({
        path: `/system/audit/after/${date}`,
        method: 'GET',
        format: 'json',
        ...params
      })
  }
  auth = {
    /**
     * No description
     *
     * @tags Auth
     * @name LoginCreate
     * @summary Login a user.
     * @request POST:/auth/login
     */
    loginCreate: (data: ApiLoginUser, params: RequestParams = {}) =>
      this.request<void, any>({
        path: `/auth/login`,
        method: 'POST',
        body: data,
        type: ContentType.Json,
        ...params
      }),

    /**
     * No description
     *
     * @tags Auth
     * @name LogoutCreate
     * @summary Logout a user.
     * @request POST:/auth/logout
     */
    logoutCreate: (params: RequestParams = {}) =>
      this.request<void, any>({
        path: `/auth/logout`,
        method: 'POST',
        ...params
      }),

    /**
     * No description
     *
     * @tags Auth
     * @name AuthConfigJsList
     * @summary Gets the authenication configuratioon.
     * @request GET:/auth/auth-config.js
     */
    authConfigJsList: (params: RequestParams = {}) =>
      this.request<SsoConfig, any>({
        path: `/auth/auth-config.js`,
        method: 'GET',
        format: 'json',
        ...params
      })
  }
  diagnostics = {
    /**
     * No description
     *
     * @tags Diagnostics
     * @name TaxclassifierList
     * @summary Diagnostic for tax classifier factory registration.
     * @request GET:/diagnostics/taxclassifier
     */
    taxclassifierList: (params: RequestParams = {}) =>
      this.request<string, any>({
        path: `/diagnostics/taxclassifier`,
        method: 'GET',
        format: 'json',
        ...params
      }),

    /**
     * No description
     *
     * @tags Diagnostics
     * @name TaxclassifierDetail
     * @summary Diagnostic for tax classifier factory registration.
     * @request GET:/diagnostics/{tenant}/taxclassifier
     */
    taxclassifierDetail: (tenant: string, params: RequestParams = {}) =>
      this.request<TaxClassification, any>({
        path: `/diagnostics/${tenant}/taxclassifier`,
        method: 'GET',
        format: 'json',
        ...params
      }),

    /**
     * No description
     *
     * @tags Diagnostics
     * @name ErrorList
     * @summary Throws an error (for testing exception handling).
     * @request GET:/diagnostics/error
     */
    errorList: (params: RequestParams = {}) =>
      this.request<void, any>({
        path: `/diagnostics/error`,
        method: 'GET',
        ...params
      }),

    /**
     * No description
     *
     * @tags Diagnostics
     * @name ErrorCreate
     * @summary Throws server error (for testing exception handling).
     * @request POST:/diagnostics/error
     */
    errorCreate: (data: Record<string, JsonNode>, params: RequestParams = {}) =>
      this.request<void, any>({
        path: `/diagnostics/error`,
        method: 'POST',
        body: data,
        type: ContentType.Json,
        ...params
      }),

    /**
     * No description
     *
     * @tags Diagnostics
     * @name MediatrList
     * @summary Throws server error (for testing exception handling).
     * @request GET:/diagnostics/mediatr
     */
    mediatrList: (params: RequestParams = {}) =>
      this.request<string, any>({
        path: `/diagnostics/mediatr`,
        method: 'GET',
        format: 'json',
        ...params
      }),

    /**
     * No description
     *
     * @tags Diagnostics
     * @name MediatrSendList
     * @summary Throws server error (for testing exception handling).
     * @request GET:/diagnostics/mediatr/send
     */
    mediatrSendList: (params: RequestParams = {}) =>
      this.request<TestResult, any>({
        path: `/diagnostics/mediatr/send`,
        method: 'GET',
        format: 'json',
        ...params
      }),

    /**
     * No description
     *
     * @tags Diagnostics
     * @name RolesList
     * @summary List the current user's roles.
     * @request GET:/diagnostics/roles
     */
    rolesList: (params: RequestParams = {}) =>
      this.request<string[], any>({
        path: `/diagnostics/roles`,
        method: 'GET',
        format: 'json',
        ...params
      }),

    /**
     * No description
     *
     * @tags Diagnostics
     * @name DiagnosticsList
     * @summary Root diagnostics endpoint.
     * @request GET:/diagnostics
     */
    diagnosticsList: (params: RequestParams = {}) =>
      this.request<DiagnosticsInformation, any>({
        path: `/diagnostics`,
        method: 'GET',
        format: 'json',
        ...params
      }),

    /**
     * No description
     *
     * @tags Diagnostics
     * @name ServiceList
     * @summary Service endpoint.
     * @request GET:/diagnostics/service
     */
    serviceList: (params: RequestParams = {}) =>
      this.request<ServiceInformation, any>({
        path: `/diagnostics/service`,
        method: 'GET',
        format: 'json',
        ...params
      }),

    /**
     * No description
     *
     * @tags Diagnostics
     * @name TenantDetail
     * @summary Specific tenant diagnostics.
     * @request GET:/diagnostics/tenant/{tenant}
     */
    tenantDetail: (tenant: string, params: RequestParams = {}) =>
      this.request<DiagnosticsInformation, any>({
        path: `/diagnostics/tenant/${tenant}`,
        method: 'GET',
        format: 'json',
        ...params
      }),

    /**
     * No description
     *
     * @tags Diagnostics
     * @name LogsCleanCreate
     * @summary Clean all logs.
     * @request POST:/diagnostics/logs/{tenantName}/clean
     */
    logsCleanCreate: (tenantName: string, params: RequestParams = {}) =>
      this.request<void, any>({
        path: `/diagnostics/logs/${tenantName}/clean`,
        method: 'POST',
        ...params
      }),

    /**
     * No description
     *
     * @tags Diagnostics
     * @name LogsCreate
     * @summary Get latest logs.
     * @request POST:/diagnostics/logs
     */
    logsCreate: (data: ApiLogRequest, params: RequestParams = {}) =>
      this.request<ApiLogEventSimple[], any>({
        path: `/diagnostics/logs`,
        method: 'POST',
        body: data,
        type: ContentType.Json,
        format: 'json',
        ...params
      }),

    /**
     * No description
     *
     * @tags Diagnostics
     * @name BackupIndexesdescriptionDetail
     * @summary Export part of the application.
     * @request GET:/diagnostics/backup/{part}/indexesdescription
     */
    backupIndexesdescriptionDetail: (part: string, params: RequestParams = {}) =>
      this.request<IndexDescription[], any>({
        path: `/diagnostics/backup/${part}/indexesdescription`,
        method: 'GET',
        format: 'json',
        ...params
      }),

    /**
     * No description
     *
     * @tags Diagnostics
     * @name BackupIndexesDetail
     * @summary Export part of the application.
     * @request GET:/diagnostics/backup/{part}/indexes
     */
    backupIndexesDetail: (part: string, params: RequestParams = {}) =>
      this.request<string[], any>({
        path: `/diagnostics/backup/${part}/indexes`,
        method: 'GET',
        format: 'json',
        ...params
      }),

    /**
     * No description
     *
     * @tags Diagnostics
     * @name BackupDetail
     * @summary Export part of the application.
     * @request GET:/diagnostics/backup/{part}
     */
    backupDetail: (part: string, params: RequestParams = {}) =>
      this.request<any, any>({
        path: `/diagnostics/backup/${part}`,
        method: 'GET',
        format: 'json',
        ...params
      }),

    /**
     * No description
     *
     * @tags Diagnostics
     * @name BackupCreate
     * @summary Export part of the application by indexes.
     * @request POST:/diagnostics/backup/{part}
     */
    backupCreate: (part: string, data: string[], params: RequestParams = {}) =>
      this.request<any, any>({
        path: `/diagnostics/backup/${part}`,
        method: 'POST',
        body: data,
        type: ContentType.Json,
        format: 'json',
        ...params
      }),

    /**
     * No description
     *
     * @tags Diagnostics
     * @name BackupPartialDetail
     * @summary Export documents of a collections created between two dates.
     * @request GET:/diagnostics/backup/partial/{part}
     */
    backupPartialDetail: (part: string, data: ApiBackUpRequest, params: RequestParams = {}) =>
      this.request<any, any>({
        path: `/diagnostics/backup/partial/${part}`,
        method: 'GET',
        body: data,
        type: ContentType.Json,
        format: 'json',
        ...params
      }),

    /**
     * No description
     *
     * @tags Diagnostics
     * @name RestoreCreate
     * @summary Import part of the application.
     * @request POST:/diagnostics/restore/{part}
     */
    restoreCreate: (part: string, params: RequestParams = {}) =>
      this.request<any, any>({
        path: `/diagnostics/restore/${part}`,
        method: 'POST',
        format: 'json',
        ...params
      }),

    /**
     * No description
     *
     * @tags Diagnostics
     * @name RestorePartialCreate
     * @summary Import part of the application.
     * @request POST:/diagnostics/restore/partial/{part}
     */
    restorePartialCreate: (part: string, params: RequestParams = {}) =>
      this.request<any, any>({
        path: `/diagnostics/restore/partial/${part}`,
        method: 'POST',
        format: 'json',
        ...params
      }),

    /**
     * No description
     *
     * @tags Diagnostics
     * @name RestoreIndexesCreate
     * @summary Setup indexes for part of the application.
     * @request POST:/diagnostics/restore/{part}/indexes
     */
    restoreIndexesCreate: (part: string, params: RequestParams = {}) =>
      this.request<any, any>({
        path: `/diagnostics/restore/${part}/indexes`,
        method: 'POST',
        format: 'json',
        ...params
      }),

    /**
     * No description
     *
     * @tags Diagnostics
     * @name DropIndexesCreate
     * @summary Restore indexes for the part of the application.
     * @request POST:/diagnostics/drop/{part}/indexes
     */
    dropIndexesCreate: (part: string, params: RequestParams = {}) =>
      this.request<boolean, any>({
        path: `/diagnostics/drop/${part}/indexes`,
        method: 'POST',
        format: 'json',
        ...params
      }),

    /**
     * No description
     *
     * @tags Diagnostics
     * @name DropIndexCreate
     * @summary Restore indexes for the part of the application.
     * @request POST:/diagnostics/drop/{part}/index/{index}
     */
    dropIndexCreate: (part: string, index: string, params: RequestParams = {}) =>
      this.request<boolean, any>({
        path: `/diagnostics/drop/${part}/index/${index}`,
        method: 'POST',
        format: 'json',
        ...params
      }),

    /**
     * No description
     *
     * @tags Diagnostics
     * @name CreateindexCreate
     * @summary Recreate all the missing indexes in the database.
     * @request POST:/diagnostics/createindex
     */
    createindexCreate: (data: IndexDescription, params: RequestParams = {}) =>
      this.request<boolean, any>({
        path: `/diagnostics/createindex`,
        method: 'POST',
        body: data,
        type: ContentType.Json,
        format: 'json',
        ...params
      }),

    /**
     * No description
     *
     * @tags Diagnostics
     * @name CheckindexesDetail
     * @summary Check that any index in the system is in line with those expected.
     * @request GET:/diagnostics/checkindexes/{tenant}
     */
    checkindexesDetail: (tenant: string, params: RequestParams = {}) =>
      this.request<string[], any>({
        path: `/diagnostics/checkindexes/${tenant}`,
        method: 'GET',
        format: 'json',
        ...params
      }),

    /**
     * No description
     *
     * @tags Diagnostics
     * @name EmailCreate
     * @summary Send a testing e-mail (to test SMTP server connectivity/availability).
     * @request POST:/diagnostics/email
     */
    emailCreate: (data: ApiEmailRequest, params: RequestParams = {}) =>
      this.request<void, any>({
        path: `/diagnostics/email`,
        method: 'POST',
        body: data,
        type: ContentType.Json,
        ...params
      }),

    /**
     * No description
     *
     * @tags Diagnostics
     * @name WaitDetail
     * @summary Wait for a certain amount of seconds, to test timeouts.
     * @request GET:/diagnostics/wait/{numberSeconds}
     */
    waitDetail: (numberSeconds: number, params: RequestParams = {}) =>
      this.request<void, any>({
        path: `/diagnostics/wait/${numberSeconds}`,
        method: 'GET',
        ...params
      }),

    /**
     * No description
     *
     * @tags Diagnostics
     * @name StopList
     * @summary Terminates the web-host.
     * @request GET:/diagnostics/stop
     */
    stopList: (params: RequestParams = {}) =>
      this.request<void, any>({
        path: `/diagnostics/stop`,
        method: 'GET',
        ...params
      })
  }
  email = {
    /**
     * No description
     *
     * @tags Emails
     * @name ListDetail
     * @summary Retrieve basic information about the e-mails sent for that day.
     * @request GET:/email/list/{date}
     */
    listDetail: (date: string, params: RequestParams = {}) =>
      this.request<ApiEmailDetails[], any>({
        path: `/email/list/${date}`,
        method: 'GET',
        format: 'json',
        ...params
      }),

    /**
     * No description
     *
     * @tags Emails
     * @name EmailDetail
     * @summary Retrieve the stream of the actual email message.
     * @request GET:/email/{id}
     */
    emailDetail: (id: string, params: RequestParams = {}) =>
      this.request<StreamedResult, any>({
        path: `/email/${id}`,
        method: 'GET',
        format: 'json',
        ...params
      })
  }
  exchangefile = {
    /**
     * No description
     *
     * @tags ExchangeFile
     * @name ExchangefileDetail
     * @summary Get exchange file by file name and type.
     * @request GET:/exchangefile/{tenant}/{filename}/{type}
     */
    exchangefileDetail: (
      filename: string,
      type: ExchangeFileType,
      tenant: string,
      params: RequestParams = {}
    ) =>
      this.request<any, any>({
        path: `/exchangefile/${tenant}/${filename}/${type}`,
        method: 'GET',
        format: 'json',
        ...params
      }),

    /**
     * No description
     *
     * @tags ExchangeFile
     * @name ExchangefileCreate
     * @summary Update exchange file by file name and type.
     * @request POST:/exchangefile/{tenant}/{filename}/{type}/{date}
     */
    exchangefileCreate: (
      filename: string,
      type: ExchangeFileType,
      date: string,
      tenant: string,
      params: RequestParams = {}
    ) =>
      this.request<void, any>({
        path: `/exchangefile/${tenant}/${filename}/${type}/${date}`,
        method: 'POST',
        ...params
      }),

    /**
     * No description
     *
     * @tags ExchangeFile
     * @name LastDetail
     * @summary Get latest exchange file by type and max inclusive date
     * @request GET:/exchangefile/last/{tenant}/{type}/{maxDateInclusive}
     */
    lastDetail: (
      type: ExchangeFileType,
      maxDateInclusive: string,
      tenant: string,
      params: RequestParams = {}
    ) =>
      this.request<File, any>({
        path: `/exchangefile/last/${tenant}/${type}/${maxDateInclusive}`,
        method: 'GET',
        format: 'json',
        ...params
      })
  }
  mediatR = {
    /**
     * No description
     *
     * @tags MediatR
     * @name SendList
     * @summary A test command for use with MediatR (via source generated controller).
     * @request GET:/MediatR/send
     */
    sendList: (
      query?: {
        /** The name. */
        Name?: string
        /**
         * The value.
         * @format int32
         */
        Value?: number
      },
      params: RequestParams = {}
    ) =>
      this.request<TestResult, any>({
        path: `/MediatR/send`,
        method: 'GET',
        query: query,
        format: 'json',
        ...params
      })
  }
  scheduler = {
    /**
     * No description
     *
     * @tags Scheduler
     * @name RunOustandingCreate
     * @summary Runs the valuation and then the scheduler and all the tasks until there is none to run.
     * @request POST:/scheduler/{tenant}/run/oustanding
     */
    runOustandingCreate: (tenant: string, params: RequestParams = {}) =>
      this.request<void, any>({
        path: `/scheduler/${tenant}/run/oustanding`,
        method: 'POST',
        ...params
      }),

    /**
     * No description
     *
     * @tags Scheduler
     * @name ExecutionsDetail
     * @summary Gets the latest task.
     * @request GET:/scheduler/{tenant}/executions
     */
    executionsDetail: (tenant: string, params: RequestParams = {}) =>
      this.request<ApiTaskExecution[], any>({
        path: `/scheduler/${tenant}/executions`,
        method: 'GET',
        format: 'json',
        ...params
      }),

    /**
     * No description
     *
     * @tags Scheduler
     * @name GetScheduler
     * @summary Schedules the task.
     * @request GET:/scheduler/{tenant}/run/{taskName}
     */
    getScheduler: (tenant: string, taskName: string, params: RequestParams = {}) =>
      this.request<void, any>({
        path: `/scheduler/${tenant}/run/${taskName}`,
        method: 'GET',
        ...params
      }),

    /**
     * No description
     *
     * @tags Scheduler
     * @name LogsDetail
     * @summary Gets the task logs logged after a specific snap.
     * @request GET:/scheduler/{tenant}/logs/{startSnapAsTicks}/{isInclusive}
     */
    logsDetail: (
      tenant: string,
      startSnapAsTicks: number,
      isInclusive: boolean,
      params: RequestParams = {}
    ) =>
      this.request<ApiTaskLog[], any>({
        path: `/scheduler/${tenant}/logs/${startSnapAsTicks}/${isInclusive}`,
        method: 'GET',
        format: 'json',
        ...params
      }),

    /**
     * No description
     *
     * @tags Scheduler
     * @name ReleaselockCreate
     * @summary Release a scheduler lock.
     * @request POST:/scheduler/{tenant}/releaselock/{lockName}/{processId}
     */
    releaselockCreate: (
      tenant: string,
      lockName: string,
      processId: string,
      params: RequestParams = {}
    ) =>
      this.request<boolean, any>({
        path: `/scheduler/${tenant}/releaselock/${lockName}/${processId}`,
        method: 'POST',
        format: 'json',
        ...params
      }),

    /**
     * No description
     *
     * @tags Scheduler
     * @name ReleaselockAllCreate
     * @summary Release all scheduler locks.
     * @request POST:/scheduler/{tenant}/releaselock/all
     */
    releaselockAllCreate: (tenant: string, params: RequestParams = {}) =>
      this.request<number, any>({
        path: `/scheduler/${tenant}/releaselock/all`,
        method: 'POST',
        format: 'json',
        ...params
      }),

    /**
     * No description
     *
     * @tags Scheduler
     * @name ExcecutionsUnsuccessfulLastDeleteAllCreate
     * @summary For each task name it retrieves the last excecution. If not successful all its logs will be physically deleted.
     * @request POST:/scheduler/{tenant}/excecutions/unsuccessful/last/delete/all
     */
    excecutionsUnsuccessfulLastDeleteAllCreate: (tenant: string, params: RequestParams = {}) =>
      this.request<number, any>({
        path: `/scheduler/${tenant}/excecutions/unsuccessful/last/delete/all`,
        method: 'POST',
        format: 'json',
        ...params
      }),

    /**
     * No description
     *
     * @tags Scheduler
     * @name ExcecutionsLastDeleteCreate
     * @summary For a specific task name physically delete all the logs for the last task execution.
     * @request POST:/scheduler/{tenant}/excecutions/last/delete/{taskName}
     */
    excecutionsLastDeleteCreate: (tenant: string, taskName: string, params: RequestParams = {}) =>
      this.request<boolean, any>({
        path: `/scheduler/${tenant}/excecutions/last/delete/${taskName}`,
        method: 'POST',
        format: 'json',
        ...params
      }),

    /**
     * No description
     *
     * @tags Scheduler
     * @name JobstatusesRevokeCreate
     * @summary Revoke some job status documents.
     * @request POST:/scheduler/{tenant}/jobstatuses/revoke
     */
    jobstatusesRevokeCreate: (tenant: string, data: string[], params: RequestParams = {}) =>
      this.request<number, any>({
        path: `/scheduler/${tenant}/jobstatuses/revoke`,
        method: 'POST',
        body: data,
        type: ContentType.Json,
        format: 'json',
        ...params
      })
  }
  setup = {
    /**
     * No description
     *
     * @tags Setup
     * @name ResetcollectionindexesCreate
     * @summary Forces the recreation of collection indexes.
     * @request POST:/setup/resetcollectionindexes
     */
    resetcollectionindexesCreate: (params: RequestParams = {}) =>
      this.request<void, any>({
        path: `/setup/resetcollectionindexes`,
        method: 'POST',
        ...params
      }),

    /**
     * No description
     *
     * @tags Setup
     * @name DropcollectionindexesCreate
     * @summary Drops all the tenant's collection indexes.
     * @request POST:/setup/dropcollectionindexes/{tenantName}
     */
    dropcollectionindexesCreate: (tenantName: string, params: RequestParams = {}) =>
      this.request<void, any>({
        path: `/setup/dropcollectionindexes/${tenantName}`,
        method: 'POST',
        ...params
      }),

    /**
     * No description
     *
     * @tags Setup
     * @name ResetidentityCreate
     * @summary Forces the recreation of collection indexes.
     * @request POST:/setup/resetidentity
     */
    resetidentityCreate: (params: RequestParams = {}) =>
      this.request<void, any>({
        path: `/setup/resetidentity`,
        method: 'POST',
        ...params
      }),

    /**
     * No description
     *
     * @tags Setup
     * @name RemovetenantCreate
     * @summary Create a new tenant with configuration.
     * @request POST:/setup/removetenant/{tenantName}
     */
    removetenantCreate: (tenantName: string, params: RequestParams = {}) =>
      this.request<void, any>({
        path: `/setup/removetenant/${tenantName}`,
        method: 'POST',
        ...params
      }),

    /**
     * No description
     *
     * @tags Setup
     * @name TenantsList
     * @summary Gets the tenants.
     * @request GET:/setup/tenants
     */
    tenantsList: (params: RequestParams = {}) =>
      this.request<string[], any>({
        path: `/setup/tenants`,
        method: 'GET',
        format: 'json',
        ...params
      }),

    /**
     * No description
     *
     * @tags Setup
     * @name CreatetenantCreate
     * @summary Create a new tenant with configuration.
     * @request POST:/setup/createtenant
     */
    createtenantCreate: (data: ApiTenantConfiguration, params: RequestParams = {}) =>
      this.request<void, any>({
        path: `/setup/createtenant`,
        method: 'POST',
        body: data,
        type: ContentType.Json,
        ...params
      }),

    /**
     * No description
     *
     * @tags Setup
     * @name UpdatetenantCreate
     * @summary Create a new tenant with configuration.
     * @request POST:/setup/updatetenant
     */
    updatetenantCreate: (data: ApiTenantConfiguration, params: RequestParams = {}) =>
      this.request<void, any>({
        path: `/setup/updatetenant`,
        method: 'POST',
        body: data,
        type: ContentType.Json,
        ...params
      }),

    /**
     * No description
     *
     * @tags Setup
     * @name UpdatetasksCreate
     * @summary Updates the task schedule on tenant.
     * @request POST:/setup/updatetasks/{tenantName}
     */
    updatetasksCreate: (
      tenantName: string,
      data: ApiSchedulingConfiguration,
      params: RequestParams = {}
    ) =>
      this.request<void, any>({
        path: `/setup/updatetasks/${tenantName}`,
        method: 'POST',
        body: data,
        type: ContentType.Json,
        ...params
      }),

    /**
     * No description
     *
     * @tags Setup
     * @name InitializeallcollectionsCreate
     * @summary Initialize all collections. To be used to avoid the creation of new indexes inside transactions.
     * @request POST:/setup/initializeallcollections/{tenantName}
     */
    initializeallcollectionsCreate: (tenantName: string, params: RequestParams = {}) =>
      this.request<void, any>({
        path: `/setup/initializeallcollections/${tenantName}`,
        method: 'POST',
        ...params
      }),

    /**
     * No description
     *
     * @tags Setup
     * @name ExportDetail
     * @summary Exports the specified tenant under the specified name using Ephemeral Mongo.
     * @request GET:/setup/export/{tenantName}/{name}
     */
    exportDetail: (tenantName: string, name: string, params: RequestParams = {}) =>
      this.request<void, any>({
        path: `/setup/export/${tenantName}/${name}`,
        method: 'GET',
        ...params
      }),

    /**
     * No description
     *
     * @tags Setup
     * @name ImportDetail
     * @summary Imports the specified tenant from the specified export name using Ephemeral Mongo.
     * @request GET:/setup/import/{tenantName}/{name}
     */
    importDetail: (tenantName: string, name: string, params: RequestParams = {}) =>
      this.request<void, any>({
        path: `/setup/import/${tenantName}/${name}`,
        method: 'GET',
        ...params
      }),

    /**
     * No description
     *
     * @tags Setup
     * @name ImportCreate
     * @summary Imports the specified tenant from the specified export name using Ephemeral Mongo.
     * @request POST:/setup/import
     */
    importCreate: (data: ImportTenantCommand, params: RequestParams = {}) =>
      this.request<void, any>({
        path: `/setup/import`,
        method: 'POST',
        body: data,
        type: ContentType.Json,
        ...params
      }),

    /**
     * No description
     *
     * @tags Setup
     * @name ExportsList
     * @summary List the existing exports.
     * @request GET:/setup/exports
     */
    exportsList: (params: RequestParams = {}) =>
      this.request<string[], any>({
        path: `/setup/exports`,
        method: 'GET',
        format: 'json',
        ...params
      }),

    /**
     * No description
     *
     * @tags Setup
     * @name ExportsDetail
     * @summary Gets the named export as a zip file.
     * @request GET:/setup/exports/{name}
     */
    exportsDetail: (name: string, params: RequestParams = {}) =>
      this.request<File, any>({
        path: `/setup/exports/${name}`,
        method: 'GET',
        format: 'json',
        ...params
      }),

    /**
     * No description
     *
     * @tags Setup
     * @name ExportsCreate
     * @summary Uploads an export zip.
     * @request POST:/setup/exports/{name}
     */
    exportsCreate: (
      name: string,
      data: {
        /** @format binary */
        File?: File
        Overwrite?: boolean
      },
      params: RequestParams = {}
    ) =>
      this.request<void, any>({
        path: `/setup/exports/${name}`,
        method: 'POST',
        body: data,
        type: ContentType.FormData,
        ...params
      }),

    /**
     * No description
     *
     * @tags Setup
     * @name ExportsDelete
     * @summary Deletes an export folder.
     * @request DELETE:/setup/exports/{name}
     */
    exportsDelete: (name: string, params: RequestParams = {}) =>
      this.request<void, any>({
        path: `/setup/exports/${name}`,
        method: 'DELETE',
        ...params
      })
  }
  status = {
    /**
     * No description
     *
     * @tags Status
     * @name OnlineList
     * @summary Is the service online.
     * @request GET:/status/online
     */
    onlineList: (params: RequestParams = {}) =>
      this.request<boolean, any>({
        path: `/status/online`,
        method: 'GET',
        format: 'json',
        ...params
      }),

    /**
     * No description
     *
     * @tags Status
     * @name AccessAdministratorList
     * @summary Administrator access test.
     * @request GET:/status/access/Administrator
     */
    accessAdministratorList: (params: RequestParams = {}) =>
      this.request<boolean, any>({
        path: `/status/access/Administrator`,
        method: 'GET',
        format: 'json',
        ...params
      }),

    /**
     * No description
     *
     * @tags Status
     * @name AccessBusinessUnitUserList
     * @summary BusinessUnitUser access test.
     * @request GET:/status/access/BusinessUnitUser
     */
    accessBusinessUnitUserList: (params: RequestParams = {}) =>
      this.request<boolean, any>({
        path: `/status/access/BusinessUnitUser`,
        method: 'GET',
        format: 'json',
        ...params
      }),

    /**
     * No description
     *
     * @tags Status
     * @name AccessServertoserverList
     * @summary Server to server access test.
     * @request GET:/status/access/servertoserver
     */
    accessServertoserverList: (params: RequestParams = {}) =>
      this.request<boolean, any>({
        path: `/status/access/servertoserver`,
        method: 'GET',
        format: 'json',
        ...params
      }),

    /**
     * No description
     *
     * @tags Status
     * @name AccessUserList
     * @summary Returns the logged-in user.
     * @request GET:/status/access/user
     */
    accessUserList: (params: RequestParams = {}) =>
      this.request<string, any>({
        path: `/status/access/user`,
        method: 'GET',
        format: 'json',
        ...params
      })
  }
  twoFactor = {
    /**
     * No description
     *
     * @tags TwoFactorAuthentication
     * @name TwoFactorList
     * @summary Returns user details.
     * @request GET:/two-factor
     */
    twoFactorList: (params: RequestParams = {}) =>
      this.request<ApiAccountUserDetails, void>({
        path: `/two-factor`,
        method: 'GET',
        format: 'json',
        ...params
      }),

    /**
 * No description
 *
 * @tags TwoFactorAuthentication
 * @name SetupList
 * @summary Returns the authenticator.
If not setup yet, authenticator is setup.
 * @request GET:/two-factor/setup
 */
    setupList: (params: RequestParams = {}) =>
      this.request<ApiAuthenticatorDetails, void>({
        path: `/two-factor/setup`,
        method: 'GET',
        format: 'json',
        ...params
      }),

    /**
     * No description
     *
     * @tags TwoFactorAuthentication
     * @name ResetCreate
     * @summary Resets the authenticator for the logged on user.
     * @request POST:/two-factor/reset
     */
    resetCreate: (data: ApiResetAuthenticator, params: RequestParams = {}) =>
      this.request<ApiResult, void>({
        path: `/two-factor/reset`,
        method: 'POST',
        body: data,
        type: ContentType.Json,
        format: 'json',
        ...params
      }),

    /**
     * No description
     *
     * @tags TwoFactorAuthentication
     * @name RecoveryCodesCreate
     * @summary Generates recovery codes.
     * @request POST:/two-factor/recovery-codes
     */
    recoveryCodesCreate: (params: RequestParams = {}) =>
      this.request<ApiResult, void>({
        path: `/two-factor/recovery-codes`,
        method: 'POST',
        format: 'json',
        ...params
      }),

    /**
     * No description
     *
     * @tags TwoFactorAuthentication
     * @name VerifyCreate
     * @summary Verifies TOTP code.
     * @request POST:/two-factor/verify
     */
    verifyCreate: (data: ApiVerifyAuthenticator, params: RequestParams = {}) =>
      this.request<ApiResult, void>({
        path: `/two-factor/verify`,
        method: 'POST',
        body: data,
        type: ContentType.Json,
        format: 'json',
        ...params
      }),

    /**
     * No description
     *
     * @tags TwoFactorAuthentication
     * @name LoginCreate
     * @summary Two-Factor Authentication login.
     * @request POST:/two-factor/login
     */
    loginCreate: (
      data: ApiTwoFactorLoginUser,
      query?: {
        /** Set to true to remember this machine. */
        rememberMachine?: boolean
      },
      params: RequestParams = {}
    ) =>
      this.request<ApiResult, void>({
        path: `/two-factor/login`,
        method: 'POST',
        query: query,
        body: data,
        type: ContentType.Json,
        format: 'json',
        ...params
      }),

    /**
     * No description
     *
     * @tags TwoFactorAuthentication
     * @name EnableCreate
     * @summary Enables two factor authentication.
     * @request POST:/two-factor/enable
     */
    enableCreate: (data: ApiSetTwoFactorEnabled, params: RequestParams = {}) =>
      this.request<ApiResult, void>({
        path: `/two-factor/enable`,
        method: 'POST',
        body: data,
        type: ContentType.Json,
        format: 'json',
        ...params
      })
  }
  usermanager = {
    /**
     * No description
     *
     * @tags UserManager
     * @name UsermanagerList
     * @summary Get all users visible to to the currenct user.
     * @request GET:/usermanager
     */
    usermanagerList: (params: RequestParams = {}) =>
      this.request<UserInformation[], any>({
        path: `/usermanager`,
        method: 'GET',
        format: 'json',
        ...params
      }),

    /**
     * No description
     *
     * @tags UserManager
     * @name UsermanagerUpdate
     * @summary Edits a user.
     * @request PUT:/usermanager
     */
    usermanagerUpdate: (data: ApiEditUser, params: RequestParams = {}) =>
      this.request<void, any>({
        path: `/usermanager`,
        method: 'PUT',
        body: data,
        type: ContentType.Json,
        ...params
      }),

    /**
     * No description
     *
     * @tags UserManager
     * @name BankAllList
     * @summary Get all bank users.
     * @request GET:/usermanager/bank/all
     */
    bankAllList: (params: RequestParams = {}) =>
      this.request<UserInformationBasic[], any>({
        path: `/usermanager/bank/all`,
        method: 'GET',
        format: 'json',
        ...params
      }),

    /**
     * No description
     *
     * @tags UserManager
     * @name ClientAllList
     * @summary Get all bank users.
     * @request GET:/usermanager/client/all
     */
    clientAllList: (params: RequestParams = {}) =>
      this.request<UserInformationBasic[], any>({
        path: `/usermanager/client/all`,
        method: 'GET',
        format: 'json',
        ...params
      }),

    /**
     * No description
     *
     * @tags UserManager
     * @name GetbyidDetail
     * @summary Get a specific user information.
     * @request GET:/usermanager/getbyid/{userId}
     */
    getbyidDetail: (userId: string, params: RequestParams = {}) =>
      this.request<UserInformation, any>({
        path: `/usermanager/getbyid/${userId}`,
        method: 'GET',
        format: 'json',
        ...params
      }),

    /**
     * No description
     *
     * @tags UserManager
     * @name RolesList
     * @summary Get all user roles.
     * @request GET:/usermanager/roles
     */
    rolesList: (params: RequestParams = {}) =>
      this.request<string[], any>({
        path: `/usermanager/roles`,
        method: 'GET',
        format: 'json',
        ...params
      }),

    /**
     * No description
     *
     * @tags UserManager
     * @name RolesAllList
     * @summary Get all roles.
     * @request GET:/usermanager/roles/all
     */
    rolesAllList: (params: RequestParams = {}) =>
      this.request<string[], any>({
        path: `/usermanager/roles/all`,
        method: 'GET',
        format: 'json',
        ...params
      }),

    /**
     * No description
     *
     * @tags UserManager
     * @name RolesBankAllList
     * @summary Get all bank roles.
     * @request GET:/usermanager/roles/bank/all
     */
    rolesBankAllList: (params: RequestParams = {}) =>
      this.request<string[], any>({
        path: `/usermanager/roles/bank/all`,
        method: 'GET',
        format: 'json',
        ...params
      }),

    /**
     * No description
     *
     * @tags UserManager
     * @name RolesClientAllList
     * @summary Get all client roles.
     * @request GET:/usermanager/roles/client/all
     */
    rolesClientAllList: (params: RequestParams = {}) =>
      this.request<string[], any>({
        path: `/usermanager/roles/client/all`,
        method: 'GET',
        format: 'json',
        ...params
      }),

    /**
     * No description
     *
     * @tags UserManager
     * @name CurrentList
     * @summary Gets the current user.
     * @request GET:/usermanager/current
     */
    currentList: (params: RequestParams = {}) =>
      this.request<UserInformation, any>({
        path: `/usermanager/current`,
        method: 'GET',
        format: 'json',
        ...params
      }),

    /**
     * No description
     *
     * @tags UserManager
     * @name CreateCreate
     * @summary Create a new user.
     * @request POST:/usermanager/create
     */
    createCreate: (data: NewUserCommand, params: RequestParams = {}) =>
      this.request<void, any>({
        path: `/usermanager/create`,
        method: 'POST',
        body: data,
        type: ContentType.Json,
        ...params
      }),

    /**
     * No description
     *
     * @tags UserManager
     * @name ConfirmEmailCreate
     * @summary Confirms email to finish user registration process and enable their sign in.
     * @request POST:/usermanager/confirmEmail
     */
    confirmEmailCreate: (data: ApiConfirmEmail, params: RequestParams = {}) =>
      this.request<ApiConfirmEmailResult, string>({
        path: `/usermanager/confirmEmail`,
        method: 'POST',
        body: data,
        type: ContentType.Json,
        format: 'json',
        ...params
      }),

    /**
     * No description
     *
     * @tags UserManager
     * @name OnboardCreate
     * @summary Onboards a user.
     * @request POST:/usermanager/onboard
     */
    onboardCreate: (data: ApiOnboardingDetails, params: RequestParams = {}) =>
      this.request<ApiAuthenticatorDetails, string>({
        path: `/usermanager/onboard`,
        method: 'POST',
        body: data,
        type: ContentType.Json,
        format: 'json',
        ...params
      }),

    /**
     * No description
     *
     * @tags UserManager
     * @name RecaptchaDisabledList
     * @summary Gets whether Recaptcha is disabled.
     * @request GET:/usermanager/recaptcha/disabled
     */
    recaptchaDisabledList: (params: RequestParams = {}) =>
      this.request<ApiRecaptchaConfiguration, any>({
        path: `/usermanager/recaptcha/disabled`,
        method: 'GET',
        format: 'json',
        ...params
      }),

    /**
     * No description
     *
     * @tags UserManager
     * @name ForgotPasswordCreate
     * @summary Forgot password functionality.
     * @request POST:/usermanager/forgotPassword
     */
    forgotPasswordCreate: (data: ApiForgotPassword, params: RequestParams = {}) =>
      this.request<void, string>({
        path: `/usermanager/forgotPassword`,
        method: 'POST',
        body: data,
        type: ContentType.Json,
        ...params
      }),

    /**
     * No description
     *
     * @tags UserManager
     * @name ResetCreate
     * @summary Reset a users password.
     * @request POST:/usermanager/reset
     */
    resetCreate: (data: ResetPasswordCommand, params: RequestParams = {}) =>
      this.request<void, string>({
        path: `/usermanager/reset`,
        method: 'POST',
        body: data,
        type: ContentType.Json,
        ...params
      }),

    /**
     * No description
     *
     * @tags UserManager
     * @name ChangepwdCreate
     * @summary Change a users password.
     * @request POST:/usermanager/changepwd
     */
    changepwdCreate: (data: ChangePasswordCommand, params: RequestParams = {}) =>
      this.request<void, string>({
        path: `/usermanager/changepwd`,
        method: 'POST',
        body: data,
        type: ContentType.Json,
        ...params
      }),

    /**
     * No description
     *
     * @tags UserManager
     * @name AddtoroleCreate
     * @summary Add a user to a role.
     * @request POST:/usermanager/addtorole
     */
    addtoroleCreate: (data: AddUserRoleCommand, params: RequestParams = {}) =>
      this.request<void, any>({
        path: `/usermanager/addtorole`,
        method: 'POST',
        body: data,
        type: ContentType.Json,
        ...params
      }),

    /**
     * No description
     *
     * @tags UserManager
     * @name RemovefromroleCreate
     * @summary Add a user to a role.
     * @request POST:/usermanager/removefromrole
     */
    removefromroleCreate: (data: RemoveUserFromRoleCommand, params: RequestParams = {}) =>
      this.request<void, any>({
        path: `/usermanager/removefromrole`,
        method: 'POST',
        body: data,
        type: ContentType.Json,
        ...params
      }),

    /**
     * No description
     *
     * @tags UserManager
     * @name RemoveDelete
     * @summary Remove a user.
     * @request DELETE:/usermanager/remove/{username}
     */
    removeDelete: (username: string, params: RequestParams = {}) =>
      this.request<void, string>({
        path: `/usermanager/remove/${username}`,
        method: 'DELETE',
        ...params
      }),

    /**
     * No description
     *
     * @tags UserManager
     * @name UnlockDetail
     * @summary Unlock a user.
     * @request GET:/usermanager/unlock/{username}
     */
    unlockDetail: (username: string, params: RequestParams = {}) =>
      this.request<void, string>({
        path: `/usermanager/unlock/${username}`,
        method: 'GET',
        ...params
      }),

    /**
     * No description
     *
     * @tags UserManager
     * @name EnabledisablelockoutDetail
     * @summary Set if a user got the lockout feature enabled or disabled.
     * @request GET:/usermanager/enabledisablelockout/{username}/{isEnabled}
     */
    enabledisablelockoutDetail: (
      username: string,
      isEnabled: boolean,
      params: RequestParams = {}
    ) =>
      this.request<void, string>({
        path: `/usermanager/enabledisablelockout/${username}/${isEnabled}`,
        method: 'GET',
        ...params
      }),

    /**
     * No description
     *
     * @tags UserManager
     * @name DeactivateCreate
     * @summary Deactivate a user.
     * @request POST:/usermanager/deactivate/{username}
     */
    deactivateCreate: (username: string, params: RequestParams = {}) =>
      this.request<void, string>({
        path: `/usermanager/deactivate/${username}`,
        method: 'POST',
        ...params
      }),

    /**
     * No description
     *
     * @tags UserManager
     * @name ActivateCreate
     * @summary Activate a user.
     * @request POST:/usermanager/activate/{username}
     */
    activateCreate: (username: string, params: RequestParams = {}) =>
      this.request<void, string>({
        path: `/usermanager/activate/${username}`,
        method: 'POST',
        ...params
      }),

    /**
     * No description
     *
     * @tags UserManager
     * @name ExportList
     * @summary Gets the user export.
     * @request GET:/usermanager/export
     */
    exportList: (params: RequestParams = {}) =>
      this.request<File, any>({
        path: `/usermanager/export`,
        method: 'GET',
        format: 'json',
        ...params
      }),

    /**
     * No description
     *
     * @tags UserManager
     * @name ExportBankList
     * @summary Gets the bank user export.
     * @request GET:/usermanager/export/bank
     */
    exportBankList: (params: RequestParams = {}) =>
      this.request<File, any>({
        path: `/usermanager/export/bank`,
        method: 'GET',
        format: 'json',
        ...params
      }),

    /**
     * No description
     *
     * @tags UserManager
     * @name ExportClientList
     * @summary Gets the client user export.
     * @request GET:/usermanager/export/client
     */
    exportClientList: (params: RequestParams = {}) =>
      this.request<File, any>({
        path: `/usermanager/export/client`,
        method: 'GET',
        format: 'json',
        ...params
      }),

    /**
     * No description
     *
     * @tags UserManager
     * @name ExportClientDetail
     * @summary Gets the client user export for a specific client id.
     * @request GET:/usermanager/export/client/{cliendId}
     */
    exportClientDetail: (
      cliendId: string,
      query?: {
        /** Client Id */
        clientId?: string
      },
      params: RequestParams = {}
    ) =>
      this.request<File, any>({
        path: `/usermanager/export/client/${cliendId}`,
        method: 'GET',
        query: query,
        format: 'json',
        ...params
      }),

    /**
     * No description
     *
     * @tags UserManager
     * @name ExportBusinessunitDetail
     * @summary Gets the client user export for a specific business unit id.
     * @request GET:/usermanager/export/businessunit/{businessUnitId}
     */
    exportBusinessunitDetail: (businessUnitId: string, params: RequestParams = {}) =>
      this.request<File, any>({
        path: `/usermanager/export/businessunit/${businessUnitId}`,
        method: 'GET',
        format: 'json',
        ...params
      }),

    /**
     * No description
     *
     * @tags UserManager
     * @name UsernameGenerateCreate
     * @summary Gets the name of the available user.
     * @request POST:/usermanager/username/generate
     */
    usernameGenerateCreate: (data: GetUserNameCommand, params: RequestParams = {}) =>
      this.request<GetUserNameResponse, any>({
        path: `/usermanager/username/generate`,
        method: 'POST',
        body: data,
        type: ContentType.Json,
        format: 'json',
        ...params
      })
  }
}
